var AE = AE || {}; /* Add to Base object or create it if it doesn't exist. */
/*
The AE.ui object will be the returned result of a self-invoked function. This allows us to expose methods
for use by other modules while protecting some variables in a closure. If the AE.ui object is already
defined then it's not altered. This prevents us from running the entire function each time one of its
internal methods are called.
*/
AE.ui = AE.ui || (function () {
	/*
	DEPENDENCIES: AE
	*/

	var UI = {
		// Like resizeTasks in AE.js, these arrays are to be filled with functions to be executed...
		bodyClickTasks: [], // Delegated Tasks Triggered On Body Click
		bodyChangeTasks: [], // Delegated Tasks Triggered On Body Change
		init: function () {
			var prepMenusearch = prepMenusearch || false;
			/* Establish the props object only upon init. No need to do the work if the module isn't being called. */
			UI.props = {
				bodyEvent: '',
				clicksDisabled: false, // If set to true, then clicks will not be registered for matrix and results elements.
				// This property will be defined as the result of an IFFE (Individually Invoked Function Expression)
				appendTarget: (function () {
					// Used for the main search form. Most jQuery UI widgets have a property called "appendTo" which controls where widgets will
					// exist in the DOM. If the value is null then widgets will be attached to the body. Otherwise, the widget will be attached
					// to whatever selector or jQuery object is defined. This is important because we've put our content on a different branch of
					// the DOM than dialogs occupy, so we could have dropdowns or autocomplete widgets which don't scroll when they should.
					//
					// We have three possibilities for where the main search form may appear. The main page, modify or in a dialog. The value is
					// initially set to null, which means that the widgets will be appended to the body.
					// 1. MODIFY:		This is an inline form, but it doesn't have the same parent structure as the main page. The page is checked
					// 					to see if the user is on the modify page and sets the variable accordingly.
					// 2. HOME PAGE:	Same as above, but due to the different structure the variable is set to a different ID.
					// 3. IN A DIALOG:	Dialogs are not on the same branch of the DOM, to prevent them from scrolling along with site content. For
					// 					this case, the variable needs to be set to null so that widgets will be appended to the body.

					var appendTo = null; // Default, mainly used for dialogs.
					if ($('body').hasClass('my-booking')) {
						// Modify page
						appendTo = '#search-form';
					} else if (!$('#ae-search').closest('.ui-dialog')[0]) {
						// Home page
						appendTo = '#top_search_form';
					}
					return appendTo; //( $('#ae-search').closest('.ui-dialog')[0] ) ? null : '#top_search_form'
				})(),

				scrollContainer: $('#scroll-content'),
				$mainFooterTogglers: $('.main-footer__header'),
				$mainFooterTogglees: $('.main-footer__links'),
				$aeSearch: $("#ae-search"),
				$menusearchEnabled: prepMenusearch,
				$tabContainers: $(".tab_container"),
				$accordionContainers: $(".accordion_container"),
				$accordionCollapsedContainers: $(".accordion_container--collapsed"),
				$dateInputs: $('input[class="datePickerInput"]'),
				$autoPostForms: $('#trg-autoPostForm'),
				$currentDatePicker: null
			};

			UI.searchProps = {
				roundTrip: true,
				city: null, // City name for pickup
				cityr: null, // City name for dropoff
				puloclist: null, // List of pickup locations
				doloclist: null, // List of dropoff locations
				pucode: null, // country ISO code for pickup.
				docode: null, // country ISO code for dropoff.
				puCal: null, // Pickup date
				doCal: null, // Dropoff date
				putime: null, // Pickup hour, must be 24 hour time, 0 - 23
				dotime: null, // dropoff hour, must be 24 hour time, 0 - 23
				searchAge: 40, // checkbox for if the driver's age is between 25 and 70
				bookingstep: 'searchwait' // Set and done. Required for back-end.
				/* Conditional Properties
					modUUID: Included when search form posts from Modify Page, ColdFusion UUID
				*/
			};

			UI.addBodyClickTask({
				func: UI.onBodyClick
			});

			//var bodyEvent = (AE.getSiteViewType() === 'palm' && $('html').hasClass('ua-ios')) ? 'click, touchend' : 'click';
			$('body').on('click', function (event) {
				UI.manageBodyClick(event);
			});
			//$('body').on('touchend', function(event){UI.manageBodyClick(event)});

			$('body').on('change', function (event) {
				UI.manageBodyChange(event)
			});
			UI.applyJQUI();

			// iOS patch for related links,
			// real solution would be to move
			// bodyevent from manage resize to props
			if ($('html').hasClass('ua-ios')) {
				$('body').on('touchend', function (event) {
					if ($(event.target).parent().hasClass('related__links')) {
						UI.manageBodyClick(event);
					}
				});
			}

			/* Set padding-top to <5px to workaround WEBAE3-4259
			* This will cause jquery-ui _hasScroll() to return false to jquery-ui _scrollIntoView()
			* avoiding an uncaught exception inside the latter where the passed element is empty. 
			
			WEBAE3-5178 - changed padding below from 4px to 2px and it seems to fix sporadic
			issue that breaks text inputs
			
			*/
			var fractionalScrollHeightStyle = document.createElement('style');
			if (AE.props.siteCode == 'FCR') {
				fractionalScrollHeightStyle.appendChild( document.createTextNode('#ui-id-147,#ui-id-150{padding-top:2px!important}') );
			}
			else {
				fractionalScrollHeightStyle.appendChild( document.createTextNode('#ui-id-99,#ui-id-102{padding-top:2px!important}') );
			}
			document.head.appendChild(fractionalScrollHeightStyle);

		
			$('a').filter(function () {
				// Checking for external links and adding rel="noopener" - Because we can't train marketing how to SEO good
				var $a = $(this);
				var _href = $a.attr('href') || false;
				var _host = this.hostname || false;
			
				// test script to remove the no opener rel tag
				var _langTag = $a.attr('hreflang');
				var _href = $a.attr('href') || false;
			
				if (_langTag === 'zh-CN' || _langTag === 'tr-TR') {
					_href = false;
				}

				var _location = (typeof (location) != 'undefined') ? location.hostname : false;
				var _hrefStr = _href ? $a.attr('href').substring(0, 4) : _href;
			
				if (_host && _location && (_host === _location)) {
					_hrefStr = false;
				}
				if (_host && _location && (_host.substring(0, 3) === _location.substring(0, 3))) {
					_hrefStr = false;
				}
				return (_hrefStr === 'http') ? this.hostname && this.hostname !== location.hostname : false;
			}).addClass("external").attr({
				rel: 'noopener'
			});
		
			// Manage resize
			AE.addResizeTask({
				func: function () {
					UI.manageResize();
				},
				args: []
			});

			// scroll task-Back to top-WEBAE3-3319
			AE.addScrollTask({
 				func: function () {	 					
 					var elm = document.getElementById("scroll_target");
 					var distanceFromTop = elm.getBoundingClientRect().top; 
 					var targetDistance = -1200; 
 					var $b2t = $('#back2top'); 				
					if(distanceFromTop < targetDistance){
    					$b2t.removeClass('visuallyhidden');
    				}else{
    					$b2t.addClass('visuallyhidden');
    				}    				
 				}
 			});
		
			// Initiate UI modules, if they exist
			if (AE.ui.search && $("#ae-search")[0]) {
				AE.ui.search.init();
			} else {
				$.each($('select.time--select'), function () {
					$(this).parent('.styled--select').removeClass('ui-searchform--custom-form-el ui-timeselect-rev ui-ready-waiting');
				});
			}
			if (AE.ui.searchType && $("#ae-search")[0]) {
				AE.ui.searchType.init();
			}
			if (AE.ui.dialog) {
				AE.ui.dialog.init();
			}
			/*
			 * Timeselect and datepicker inits are now in AE.ui.searchType's init function
			 *
			 * if (AE.ui.timeselectmenu) { AE.ui.timeselectmenu.init(); }
			 * if (AE.ui.datepicker) { AE.ui.datepicker.init(); }
			 */
			if (AE.ui.modify && $('#aemodify')[0]) {
				AE.ui.modify.init();
			}
			if (AE.ui.tabcordion) {
				AE.ui.tabcordion.init();
			}
			if (AE.ui.carousel) {
				AE.ui.carousel.init();
			}
			if (AE.ui.selectmenu) {
				AE.ui.selectmenu.init();
			}
			if (AE.affiliate) {
				AE.affiliate.init();
			}
			if (AE.affiliate.terms) {
				AE.affiliate.terms.init();
			}

			// CAROUSEL FOR RAU/RNZ HERO CARDS
			var slide = document.getElementsByClassName("hero_-slide");// WEBAE3-3645 - disable test

			if(slide.length !== 0) {
				var heroCardIndex = 0;
				function carousel() {
					var i;
					slide[0].style.display = "block";
					for (i = 0; i < slide.length; i++) {
						slide[i].style.display = "none";
					}
					heroCardIndex++;
					if (heroCardIndex > slide.length) {heroCardIndex = 1}
					$(slide[heroCardIndex-1]).css('opacity', 1)
								.show('slide', {direction: 'right'}, 1500)
								.animate(
									{ opacity: 1 },
									{ queue: false, duration: 2000 }
								);
					setTimeout(carousel, 7000); // Change hero card every 7 seconds
				}
				carousel();
			}
		},
		disableClicks: function () {
			UI.props.clicksDisabled = true;
		},
		enableClicks: function () {
			UI.props.clicksDisabled = false;
		},
		manageResize: function () {
			var siteViewType = AE.getSiteViewType();

			// Changing the target event for body clicks, changing to touchend when using a mobile device.
			UI.props.bodyEvent = ($('html').hasClass('ua-mobile')) ? 'touchend' : 'click';

			/*
			NOTE: The $mainFooterTogglees start with the "visuallyhidden" class so they don't flash into view upon palm-sized page load. This is
			sorted out by the initial run of manageResize() so they will be properly visible on a desk-sized page load.

			* Added check if toggle was already open on resize to leave it at it's current state.
			*/
			$('.hasDatepicker')
				.datepicker('hide')
				.on('click', function () {
					$(this).datepicker('show')
				});

			/* Mobile toggles only work at lap and down sizes. */
			$('.toggler.toggler--portable')
				.each(function (index) {
					var $togglee = $(this)
						.closest('.toggle')
						.find('.togglee');

					if (siteViewType === 'desk' || siteViewType === 'desk-wide') {
						$(this).addClass('open');
						UI.show($togglee);
					} else {
						$(this).removeClass('open');
						UI.hide($togglee);
					}
				});

			/* Palm-only toggles only work at palm size, so they need to be closed initially. */
			$('.toggler.toggler--palm')
				.each(function (index) {
					var $togglee = $('' + $(this).data('togglee') + '');

					// Insurance options Shenanigans  with Plus and Minus state, different than other toggles
					var insurance = ($(this).closest('#insuranceUI').length) ? true : false;
					var pmOptionsStop = ($(this).hasClass('open') && !$togglee.hasClass('visuallyhidden')) ? false : true;

					if (siteViewType === 'palm') {
						if (insurance) {
							if (pmOptionsStop) {
								hideToggle($(this), $togglee);
							}
						} else {
							hideToggle($(this), $togglee);
						}
					} else {
						if (!pmOptionsStop) {
							$(this).addClass('open');
							UI.show($togglee);
						}

						if (insurance) {
							if (!pmOptionsStop) {
								showToggle($(this), $togglee);
							}
						} else {
							showToggle($(this), $togglee);
						}
					}

					function hideToggle($toggler, $togglee) {
						$toggler.removeClass('open');
						UI.hide($togglee);
					}

					function showToggle($toggler, $togglee) {
						$toggler.addClass('open');
						UI.show($togglee);
					}

				});

			/* Toggles for larger sizes don't work at this size, so they need to be opened. */
			$('.toggler.toggler--lap-and-up').each(function (index) {
				var $togglee = $(this).closest('.toggle').find('.togglee');

				/* Open non-palm toggles upon resize in palm view. */
				if (siteViewType === 'palm') {
					$(this).addClass('open');
					UI.show($togglee);
				} else {
					$(this).removeClass('open');
					UI.hide($togglee);
				}
			});

			/*
				Togglees that need to be open and delay befor then closing.
				NOTE: Need to add data size on togglee to target delay by type or all
			*/
			$('.togglee--delay-close').each(function (index) {
				var $togglee = $(this);
				var deviceSize = ($togglee.data('size') !== undefined) ? $togglee.data('size') : '';
				var palm = ($togglee.hasClass('delay--palm')) ? 'palm' : '';
				var lap = ($togglee.hasClass('delay--lap')) ? 'lap' : '';
				var desk = ($togglee.hasClass('delay--desk')) ? 'desk' : '';

				setTimeout(function () {
					_.each([palm, lap, desk], function (device) {
						if (AE.getSiteViewType() === device) {
							var passSize = (deviceSize !== '') ? '--' + device : '';
							UI.hide($togglee, passSize);
						}
					});
				}, 2000);
			});
		},
		onBodyClick: function (event, $target) {

			// Add scroll to top of this id selector
			if($target.hasClass('btn--back2top') || $($target.parent()).hasClass('btn--back2top')){					
 				document.getElementById('sticky-wrapper').scrollIntoView();		
 			}

			/*  HANDLE TOGGLES:
				A container with a class of ".toggle" contains a ".toggler" and a "togglee". They don't have
				to be siblings. They can be in grids and other containers, so long as they can track upward to the same parent.
				
				For manual toggles, use both classes: "toggler" and "toggler--manual". The toggler class will apply the proper
				CSS to the element, and the toggler--manual class will prevent it from functioning automatically.
				
				Manual toggles require specific code to run the handleToggle() function, but they can add a callback function.
				Send in a jQuery collection of your toggler, the name of your function and an array of arguments.
				
				Example: AE.ui.handleToggle( $myToggler, myFunctionName, [arg1, arg2, arg3] );
			*/
			if ($target.hasClass('toggler') && !$target.hasClass('toggler--manual')) {
				UI.handleToggle($target);
			}else if($target.prop('tagName') !== 'INPUT' && !$target.hasClass('grid__item-ta-modifier')){// WEBAE3-3866 - don't run closeToggle when user clicks an input to start entering values - LJW
				var $target = $(event.target);// now it's a jQuery object
				var $toggleeContainer = $target.closest('.matrix_filter');
				var $taModChildren = $target.find('.grid__item-ta-modifier');
                var checkout_process = $('body#options').length || $('body#upgrade').length|| $('body#checkout').length == 0;
				if($toggleeContainer.length == 0 && $taModChildren.length == 0 && !checkout_process) {
					UI.closeToggle();
				}
			}
			
			// Test environment for staging and production - QA1, QA2, QA3, QA4, and PTEST
			if ($target.hasClass('test_environment')) {
				AECookie.update('PTEST', 'no', 0); //remove the ptest cookie
				var qaCookie = (AECookie.read('QA')) ? '?QA=false' : '';
				window.location.href = '/'+qaCookie; //reset the stage/test environment back to the base
			}
			
			// ENABLER ELEMENT - toggle disabled property of a selected element
			if ($target.hasClass('trg__enabler') && $target.data('enablee')) {
				if ($target.hasClass('enabler--on')) {
					$($target.data('enablee')).prop('disabled', true);
					$target.removeClass('enabler--on');
				} else {
					$($target.data('enablee')).prop('disabled', false);
					$target.addClass('enabler--on');
				}
			}
			
			// Matrix Results, Utility bar, Modify & Optional Eq - More Info Tips
			if ($target.hasClass('more-info-tip')) {
				//WEBAE-4574 catch cancel modal triggers
				if ($target.attr('data-modalname')=="cancelModal"){
					AE.booking.cancelModal();
				
				}else{
				AE.ui.dialog.launch({
					type: 'infoTip',
					pos: {
						my: 'left top',
						at: 'left bottom+5',
						of: $target
					},
					selector: $target.children('.more-info-text')
				});
				}

			
			}

			// For pages which aren't part of the buyback or luxury portions of the booking system, we're going to have a special
			// link for "iCommunicator Voice Over IP". This is only shown on desktop, and opens a pop-up window.
			if ($target.hasClass('voip-link')) {
				AE.ga.gaArrayProcess([{
					GACATEGORY: 'VOIP',
					GAACTION: 'click'
				}]);
				var clientID = $target.data('voipcode');
				
				if ($target.hasClass('icomm_direct') || (clientID == '8fb2338n0n5w2bj7' || clientID == 'ecz610fox8q57dgn' || clientID == 'o3lwm3e04730w06o')) {
					window.open("http://client.icommconnect.com/Home/DirectCall?contactGuid=" + clientID + "", "", "scrollbars=yes,width=360, height=640");
				} else {
					// hasClass 'icomm_directory'
					window.open("http://client.icommconnect.com/Home/Call?clientSubscriptionGUId=" + clientID + "", "", "scrollbars=yes,width=360, height=640");
				}
			}
			
			// 8x8 co-browsing
			if ($target.hasClass('co_browse_site')) {
				return UI.call8x8CoBrowsing(event);
			}
		},
		manageBodyClick: function (event) {
			/* Cycle through Body Click tasks */
			if (UI.props.clicksDisabled) {
				return
			};
			// This module listens to 'click' and 'touchend' events to run this function. To prevent it from firing
			// twice, we keep a string in the props object to indicate which one to use. The event.type string in
			// the event object must match this module prop string in order to go forward. For example, if a tablet
			// registers both events, then the 'click' will cause this function to return, while the 'touchent' call
			// will run this function normally.
			//
			// This is important in case some brand of tablets decides to abandon click in favor of touchend. Since
			// the bodyEvent property initializes as an empty string, this line will also prevent toggles from working
			// until the property is populated by the name of the appropriate event.
			//if(event.type !== UI.props.bodyEvent) { return; }

			var $target = $(event.target);

			// Run through all of the registered body click tasks in our codebase.
			for (var i = 0; i < UI.bodyClickTasks.length; i++) {
				// Even if no arguments were passed in, the args array was still established as an empty array when
				// the task is added to the array. The first two arguments will be the event and target, with other
				// arguments following after. A new array is made with each loop iteration so that previous arguments
				// cannot carry over into subsequent iterations.
				var arrArgs = [event, $target].concat(UI.bodyClickTasks[i].args);

				// Using the apply method, we'll pass in "this" from the perspective of this function, using the
				// arguments from the task object. So if you were to establish some sort of property like "this.thing"
				// then every bodyClick function in every module would have access to this.thing. We don't really do
				// that, however. Most of these functions simply require the event object and the first thing they
				// want to do is establish a jQuery collection of the event target. To save lines, we do this here
				// and pass it in.
				UI.bodyClickTasks[i].func.apply(this, arrArgs);
			};
		},
		addBodyClickTask: function (task) {
			/*
			Adds an object with a func property that is function taking the
			event object as its ONLY argument to an array of functions.
			On a body change event, these functions will be executed using
			the apply() method in manageBodyClick() to pass in the correct target on each event.

			Each 'task' should start by performing logic on the event target to determine whether it should run.

			AE.ui.addBodyClickTask(
				{
				func:function(event){
					if(event meets criteria){
					do stuff
					}
				}
				}
			);
			*/

			// Make sure that the args array is an array if it wasn't defined.
			task.args = task.args || [];
			UI.bodyClickTasks.push(task);
		},
		manageBodyChange: function (event) {
			/* Cycle through Body Change tasks */
			// Explanations for this code are documented above in body click management
			var $target = $(event.target);
			for (var i = 0; i < UI.bodyChangeTasks.length; i++) {
				var arrArgs = [event, $target].concat(UI.bodyChangeTasks[i].args);
				UI.bodyChangeTasks[i].func.apply(this, arrArgs);
			};
		},
		addBodyChangeTask: function (task) {
			/*
			Adds an object with a func property that is function taking the
			event object as its ONLY argument to an array of functions.
			On a body change event, these functions will be executed using
			the apply() method in manageBodyChange() to pass in the correct target on each event.

			Each 'task' should start by performing logic on the event target to determine whether it should run.

			AE.ui.addBodyChangeTask(
				{
				func:function(event){
					if(event meets criteria){
					do stuff
					}
				}
				}
			);
			*/
			task.args = task.args || [];
			UI.bodyChangeTasks.push(task);
		},
		addSpinner: function (selector, settings) {
			/*
			Turns an element into a relatively-positioned container for a spinner element, then adds the spinner. FontAwesome
			is used for the spinner itself, and it's rotated with CSS.

			Example call: AE.ui.addSpinner('.my-selector', { size:'5x', color: 'white' });
			The size can be any size provided by FontAwesome. A value of '5x' results in a class of "fa-5x". The color can be
			the default gray, white or black. Hex values may not be passed in because we don't want every developer to use a
			different color every time. Three colors is plenty.
			*/
			var $target = $(selector);
			settings = settings || {};
			var sizeClass = settings.size ? ' fa-ae-' + settings.size : '';

			/* If a color setting is passed in, white or black is used instead of relying upon the default gray in the CSS. */

			$target
				.addClass('spinner__container')
				.find('.spinner__div').parent()
				.remove()
				.end();


			if(AE.props.siteCode !== 'FCR') {
				$target.append('<div class="wrap"><div class="spinner__div align-center' + sizeClass + '"><i class="spinner fa fa-ae-spinner fa-spin' + sizeClass + ' " aria-hidden="true"></i></div></div>');
			} else {
				function isIE() {
					var ua = window.navigator.userAgent; //Check the userAgent property of the window.navigator object
					var msie = ua.indexOf('MSIE '); // IE 10 or older
					var trident = ua.indexOf('Trident/'); //IE 11
				
					return (msie > 0 || trident > 0);
				}
				if(isIE()) {
					$target.append('<div class="wrap"><div class="spinner__div align-center"><div class="preloader-wrapper small active"><div class="spinner-layer spinner-blue-only"><div class="circle-clipper left"><div class="circle"></div></div><div class="gap-patch"><div class="circle"></div></div><div class="circle-clipper right"><div class="circle"></div></div></div></div></div></div>');
				} else {
					$target.append('<div class="wrap"><div class="spinner__div align-center' + sizeClass + '"><div style="position:relative"><div class="indeterminate-circle"><svg version="1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" width="100%" height="100%" viewBox="0 0 24 24"><path id="indeterminate" d="M12 3.25A8.75 8.75 0 1 1 3.25 12" fill="none" stroke-width="2.5" stroke-linecap="square" stroke="#0072EA"/></svg></div></div></div></div>');
				}
			}

			if (settings.color) {
				if ((settings.color.indexOf('#') != -1)) {
					$target.find('.spinner').css({
						'color': settings.color
					});
				} else {
					var colorClass = (settings.color === 'white') ? 'spinner--white' : 'spinner--black';
					$target.find('.spinner').addClass(colorClass);
				}
			}

			$target.find('.spinner__div').parent().css('min-height', ($target.find('.spinner__div').outerHeight(true)) + 'px');

			if (settings.noWobble) {
				var noWobbleClass = 'no-wobble';
				$target.find('.spinner').addClass(noWobbleClass);
			}

		},
		removeSpinner: function (selector) {
			$(selector).removeClass('spinner__container').find('.spinner__div').parent().remove();
		},
		applyJQUI: function (selector) { // Applies Common jQueryUI widget behaviors to elements with trigger classes in selected container
			// Get the jQuery selector for the CONTAINER element
			selector = selector || 'body';
			
			// This applies the jQueryUI datepicker method to all input elements with the datePickerInput class
            $(selector + ' input.datePickerInput').datepicker();
			
			// Set an "onSelect" event globally to all datePicker form fields on the page
			$(selector + ' input.datePickerInput')
				.datepicker("option", "onSelect", function (dateText, inst) {
					if (this.dataset && this.dataset.endDatePicker && this.dataset.endDatePicker.length) {
						var startDate = new Date(dateText);
						var duration = this.dataset.minDuration || 0;
						if ($.isNumeric(duration) && duration >= 0) {
							startDate.setDate(startDate.getDate() + duration);
						}
						$($.trim(this.dataset.endDatePicker)).datepicker("option", "minDate", startDate);
					}
				});
			
			$(selector + ' input.datePickerInput').prop("readonly", true);
			
			/* Additional DatePicker calendar parameters */
			// Loop through all of the DatePickers on the page
			for (var i = 0; i < $(selector + ' input.datePickerInput').length; i++) {
				// Get a pointer to the current DatePicker
				var currentDatePicker = $(selector + ' input.datePickerInput')[i];

				// Read the data attribute about what kind of DatePicker this is
				var pickerType = $(currentDatePicker).attr('data-pickertype');

				// If there is a date already chosen, get it
				var pickerValue = $(currentDatePicker).val();
				
				// Call a function to configure this specific DatePicker
				configureCurrentDatePicker($(currentDatePicker), pickerType, pickerValue);
			}

			/* Function to configure specific DatePicker parameters */
			function configureCurrentDatePicker(currentDatePicker, pickerType, pickerValue) {
				var yearUpperRange, yearLowerRange, dp_options = {};
				switch (pickerType) {
					case "birthdate":
					case "birthdateNotReq":
					
						// DatePicker used for "date of birth"
						yearUpperRange = $.datepicker.formatDate("yy", new Date()) - 18;
						if (pickerValue == "") {
							pickerValue = (pickerType == "birthdateNotReq") ? pickerValue : "-18y";
						}
						var setminDate = "-18y";
						hiddenDob = $("input#hidden-dob-date").val();

						if(hiddenDob.length){							
							hiddenDob = $.datepicker.parseDate('yy-mm-dd', hiddenDob);
							//pickerValue = hiddenDob;
							pickerValue = new Date(hiddenDob);
					     } 
						dp_options = {
							hideIfNoPrevNext: true,
							changeMonth: true,
							changeYear: true,
							yearRange: "1900:" + yearUpperRange,
							minDate: new Date("01/01/1900"),
							defaultDate: setminDate,
							setDate: pickerValue,
							altField: '#hidden-dob-date',
							altFormat: 'mm-dd-yy'									
						}

						if(hiddenDob.length !=0){currentDatePicker.datepicker("setDate", pickerValue);} 
						// Should we show or hide the "clear datepicker input form field" option
						if (pickerValue == "") {
							$('span.ui-datepicker-target-input').hide();
						} else {
							$('span.ui-datepicker-target-input').show();
						}
						break;				
					case "expires":
						// Datepicker used for things that expire in the future
						yearUpperRange = parseInt($.datepicker.formatDate("yy", new Date())) + 20;
						yearLowerRange = parseInt($.datepicker.formatDate("yy", new Date()));
						dp_options = {
							hideIfNoPrevNext: true,
							changeMonth: true,
							changeYear: true,
							yearRange: yearLowerRange + ":" + yearUpperRange,
							minDate: new Date(),
							setDate: ""
						};
						break;
					case "report":
					
						// DatePicker used for "date of birth"
						//yearUpperRange = $.datepicker.formatDate("yy", new Date()) - 18;
						if (pickerValue == "") {
							pickerValue = (pickerType == "birthdateNotReq") ? pickerValue : "-18y";
						}
						//var setminDate = "-18y";
						hiddenReport = $("input#hiddenreportdate").val();

						if(hiddenReport.length){							
							hiddenReport = $.datepicker.parseDate('yy-mm-dd', hiddenReport);
							pickerValue = new Date(hiddenReport);
					     } 
						dp_options = {
							hideIfNoPrevNext: true,
							changeMonth: true,
							changeYear: true,
							//yearRange: "1900:" + yearUpperRange,
							minDate: new Date("01/01/1900"),
							//defaultDate: setminDate,
							maxDate: new Date(),
							setDate: pickerValue,
							altField: '#hiddenreportdate',
							altFormat: 'mm-dd-yy'									
						}

						if(hiddenReport.length !=0){currentDatePicker.datepicker("setDate", pickerValue);} 
						// Should we show or hide the "clear datepicker input form field" option
						if (pickerValue == "") {
							$('span.ui-datepicker-target-input').hide();
						} else {
							$('span.ui-datepicker-target-input').show();
						}
						break;	
					case "report2":
					
						// DatePicker used for "date of birth"
						//yearUpperRange = $.datepicker.formatDate("yy", new Date()) - 18;
						if (pickerValue == "") {
							pickerValue = (pickerType == "birthdateNotReq") ? pickerValue : "-18y";
						}
						//var setminDate = "-18y";
						hiddenReport = $("input#hiddenreportdate2").val();

						if(hiddenReport.length){							
							hiddenReport = $.datepicker.parseDate('yy-mm-dd', hiddenReport);
							pickerValue = new Date(hiddenReport);
					     } 
						dp_options = {
							hideIfNoPrevNext: true,
							changeMonth: true,
							changeYear: true,
							//yearRange: "1900:" + yearUpperRange,
							minDate: new Date("01/01/1900"),
							//defaultDate: setminDate,
							maxDate: new Date(),
							setDate: pickerValue,
							altField: '#hiddenreportdate2',
							altFormat: 'mm-dd-yy'									
						}

						if(hiddenReport.length !=0){currentDatePicker.datepicker("setDate", pickerValue);} 
						// Should we show or hide the "clear datepicker input form field" option
						if (pickerValue == "") {
							$('span.ui-datepicker-target-input').hide();
						} else {
							$('span.ui-datepicker-target-input').show();
						}
						break;	
					case "issued":
                        if(AE.props.siteCode == 'DAU' || AE.props.siteCode == 'DNZ' || AE.props.siteCode == 'DAP') {
                            dp_options = {
								beforeShow: function (input, inst) {
                                    setTimeout(function() {
                                        var dpoffset = currentDatePicker.offset();
                                        var dpheight = currentDatePicker.outerHeight();
                                        var top = dpoffset.top + dpheight;
                                        
                                        inst.dpDiv.css({
                                            top: top,
                                            left: dpoffset.left
                                        });
                                    }, 0);
                                }
                            };
                            break;
                        }
					case "issuedExt":
						// DatePicker used for things in the past like a "date of issue"
						yearUpperRange = parseInt($.datepicker.formatDate("yy", new Date()));
						yearRangeSize = (pickerType === 'issuedExt' && AE.props.chaosSystem === 'EU')? 100 : 20;
						yearLowerRange = parseInt($.datepicker.formatDate("yy", new Date())) - yearRangeSize;
						dp_options = {
							hideIfNoPrevNext: true,
							changeMonth: true,
							changeYear: true,
							yearRange: yearLowerRange + ":" + yearUpperRange,
							minDate: new Date("01/01/" + yearLowerRange),
							maxDate: new Date(),
							setDate: ""
						};
						break;
					case "lookup":
						// DatePicker used to lookup a voucher
						dp_options = {
							altFormat: "mm-dd-yy",
							altField: "#dateToPassAlong"
						};
						break;
					case "gps_pu":
						// DatePicker used on the GPS form
						dp_options = {
							// dateFormat: "mm/dd/yy",
							altFormat: "mm-dd-yy",
							minDate: new Date(),
							setDate: ""
						};
						// Removed for WEBAE3-1652
						// currentDatePicker.attr("placeholder", $.datepicker.formatDate(currentDatePicker.datepicker("option", "dateFormat"), new Date()));
						break;
					case "gps_do":
						// DatePicker used on the GPS form
						dp_options = {
							// dateFormat: "mm/dd/yy",
							altFormat: "mm-dd-yy",
							minDate: new Date(),
							setDate: ""
						};
						// Removed for WEBAE3-1652
						// currentDatePicker.attr("placeholder", $.datepicker.formatDate(currentDatePicker.datepicker("option", "dateFormat"), new Date()));
						break;
					case "datepaid":
						// DatePicker used on the DAP advise electronic payment form
						// This is specifically written for Sydney, AU time. dapDatePaidMax and dapDatePaidMin are created in CF and sent to JS in mod_ds_actions.cfm.
						
						/*console.log(dapDatePaidMax);
						console.log(dapDatePaidMin);*/
						
						dp_options = {
							// dateFormat: "mm/dd/yy",
							altFormat: "mm-dd-yy",
							minDate: dapDatePaidMin,
							maxDate: dapDatePaidMax,
							setDate: dapDatePaidMax
						};
						break;
					default:
						// All other DatePickers
						dp_options = {
							minDate: new Date(),
							setDate: new Date()
						};
						break;
				}
				
				dp_options.onSelect = function (dateText) {
					if ($(this).attr('required') && dateText != '') {
						$(this).parent()
							.removeClass("ui-state-invalid")
							.addClass("ui-state-valid");
							
						$(this).next('span.ui-error-message').remove();
					}
				};
				
				dp_options.onClose = function (dateText) {
					if ($(this).is('[dpStartDate]')) {
						var startDate = new Date(dateText);
						var endDateElement = document.querySelector('input.datePickerInput[dpEndDate]');
						if (endDateElement) {
							$(endDateElement).datepicker("option", "minDate", startDate);
						}
					}
				};
				
				// Apply the above datepicker options
				currentDatePicker.datepicker("hide").datepicker("destroy").blur();
				currentDatePicker.datepicker(dp_options);
				
				$(AE.ui.props.scrollContainer)[0].addEventListener('scroll', function (e) {
					currentDatePicker.datepicker('hide').on('click', function () {
						currentDatePicker.datepicker('show');
					});
				}, {
					passive: true
				});
		}

			// Keep the datepicker field empty on the forms found on these pages
			var pagesWithEmptyDatepickerFields = ["/driver-profile/", "/beatrate/"];
			if (pagesWithEmptyDatepickerFields.includes(AE.url.props.path)) {
				//$(selector+' input.datePickerInput').datepicker('setDate','')
			}
			
				// Pick Up Date field in voucher lookup form must be excluded from these rules per Karen 2017-01-26 NW
				if ($('#vouchpudate')[0]) {
					$.datepicker._clearDate($('#vouchpudate').datepicker('option', 'minDate', null));
				}

				// IATA report date rules: allow future dates only when report basis is Drop Off.
				(function syncIataReportDateBasis() {
					var $reportForm = $(selector + ' #rpt__sales');
					if (!$reportForm.length) {
						return;
					}

					var $dateBasis = $reportForm.find('select[name="dateBasis"]');
					var $reportDateInputs = $reportForm.find('input.datePickerInput[data-pickertype="report"], input.datePickerInput[data-pickertype="report2"]');
					if (!$dateBasis.length || !$reportDateInputs.length) {
						return;
					}

					var getToday = function () {
						var today = new Date();
						today.setHours(0, 0, 0, 0);
						return today;
					};

					var applyDateBasisRules = function () {
						var isDropOffBasis = String($dateBasis.val() || '').toUpperCase() === 'DROPOFF';
						var today = getToday();
						var startDate = null;

						$reportDateInputs.each(function () {
							var $input = $(this);
							$input.datepicker('option', 'maxDate', isDropOffBasis ? null : today);

							if (!isDropOffBasis) {
								var selectedDate = $input.datepicker('getDate');
								if (selectedDate instanceof Date && !isNaN(selectedDate)) {
									selectedDate.setHours(0, 0, 0, 0);
									if (selectedDate > today) {
										$input.datepicker('setDate', today);
										selectedDate = $input.datepicker('getDate');
									}
								}
							}

							if ($input.is('[dpStartDate]')) {
								startDate = $input.datepicker('getDate');
							}
						});

						if (startDate instanceof Date && !isNaN(startDate)) {
							startDate.setHours(0, 0, 0, 0);
							$reportDateInputs.filter('[dpEndDate]').datepicker('option', 'minDate', startDate);
						}
					};

					$reportForm
						.off('change.aeIataDateBasis', 'select[name="dateBasis"]')
						.on('change.aeIataDateBasis', 'select[name="dateBasis"]', applyDateBasisRules);

					applyDateBasisRules();
				})();
				
				// Pickup and Dropoff defaults for different services. Put correct class on given input
				$(selector + ' .tab_container').tabs();
			
			/* This code anticipates an element with the tab_container class to have a child UL
				with LIs of anchored links to subsequent children
				Example:
				<div class="tab_container">
				<ul>
					<li><a href="#tab_1">First</a></li>
					<li><a href="#tab_2">Second</a></li>
				</ul>
				<div id="tab_1">First</div>
				<div id="tab_2">Second</div>
				</div>
			*/
			$(selector + ' .accordion_container').accordion({
				heightStyle: 'content'
			});
			
			/* This code anticipates an element with the accordion_container class to have a
				series of child header and div pairs
				Example:
				<div class="accordion_container">
				<h6>First</h6>
				<div>Lorem ipsum dolor sit amet. Lorem ipsum dolor sit amet. Lorem ipsum dolor sit amet.</div>
				<h6>Second</h6>
				<div>Phasellus mattis tincidunt nibh.</div>
				<h6>Third</h6>
				<div>Nam dui erat, auctor a, dignissim quis.</div>
				</div>
			*/
			$(selector + ' .accordion_container--collapsed').accordion({
				collapsible: true,
				active: false,
				heightStyle: "content"
			}); // This accordion variant "starts closed" and sections will "close" if clicked after being "opened"
		},
		decodeHtml: function (htmlStr) {
			var txt = document.createElement("textarea");
			txt.innerHTML = htmlStr;
			return txt.value;
		},
	
		/*
		We have our own functions for some common jQuery methods to help with accessibility. The 'visuallyhidden' class moves an element
		off-screen but leaves it visible so that screen readers can still read it. The 'size' argument allows us to specifically target
		certain sizes. For example, you could hide something only from the palm size. Leaving out the 'size' argument results in the
		regular 'visuallyhidden' class.

		The code looks weird, so here are the steps:

		show()
		1. Check the size, and set to an empty string if it isn't defined.
		2. Do a normal jQuery slideUp(). The element now has an inline style of "display:none".
		3. When finished, remove the 'visuallyhidden' class.
		4. Do a normal jQuery slideDown, but with a zero duration. The element is now displayed, but off-screen.

		hide()
		1. Check the size, and set to an empty string if it isn't defined.
		2. Add the appropriate "visuallyhidden" class.
		4. Do a jQuery slideDown with a zero duration just to make sure that the element doesn't have "display:none" attached to it.

		slideUp()
		1. Check the size, and set to an empty string if it isn't defined.
		2. Do a jQuery slideUp() with a duration of 'fast'.The element now has an inline style of "display:none".
		3. When finished, add the appropriate "visuallyhidden" class.
		4. Do a normal jQuery slideDown, but with a zero duration. The element is now displayed, but off-screen.

		slideDown()
		1. Do a normal jQuery slideUp() to put "display:none" on the elements. This prevents it from becoming momentarily visible in the next step.
		2. When finished, remove all "visuallyhidden" classes. This eliminates the need for a size argument.
		3. Do a normal jQuery slideDown. The element is now displayed and on-screen.
		*/
		show: function ($target, size) {
			size = size || '';
			$target.slideUp(0, function () {
				$target.removeClass('visuallyhidden' + size).slideDown(0);
			});
		},
		hide: function ($target, size) {
			size = size || '';
			$target.addClass('visuallyhidden' + size).slideDown(0);
		},
		slideUp: function ($target, size) {
			/*
			If the size has been passed in and if it's not an empty string, then prepend with dashes to build visibility class.
			Otherwise, leave it as an empty string so that we will wind up with just "visuallyhidden".
			*/
			size = size || '';
			$target.slideUp('fast', function () {
				$target.addClass('visuallyhidden' + size).slideDown(0);
			});
		},
		slideDown: function ($target) {
			$target.slideUp(0, function () {
				$target
					.removeClass('visuallyhidden visuallyhidden--palm visuallyhidden--lap visuallyhidden--portable visuallyhidden--lap-and-up visuallyhidden--desk visuallyhidden--desk-wide')
					.slideDown('fast', function()
                    {
                        $target.removeClass('opening');
                    });
			});
		},
		isVisuallyHidden: function ($target, size) {
			/* Returns true if the target is visually hidden at the given size. If no size is given, current size is used. */
			size = size || AE.getSiteViewType();
			return ($target.hasClass('visuallyhidden') || $target.hasClass('visuallyhidden' + size));
		},
		handleToggle: function ($toggler, objCallback, args) {
			// $toggler:  jQuery object representing your toggler.
			// callback:  The name of a function that you want to run along with the toggle. Not invoked, so no parentheses.
			// args:    An array of arguments to be applied to the function.
			//
			// Example: AE.ui.handleToggle( $myToggler, myFunctionName, [arg1, arg2, arg3] );

			var $togglee = null,
				$toggleo = null,
				size = $toggler.data('size');

			// If there's a data attribute for the togglee, then use that as a jQuery selector string. If not, then find the
			// parent "toggle" class and then drill down within that parent container to the element with the "togglee" class.

			if ($toggler.data('togglee')) {
				$togglee = $($toggler.data('togglee'));

				// Since there's a date attribute, look for any other elements with the same data attribute. This covers the
				// rare case when there are two different togglers which act upon the same target. A $toggler is just a jQuery
				// collection, so jQuery methods will be run on all elements within that collection. Chevrons will stay in sync.
				$toggler = $('[data-togglee="' + $toggler.data('togglee') + '"]');

			} else {
				$togglee = $toggler.closest('.toggle').find('.togglee');
			}

			if ($toggler.data('toggleo')) {
				$toggleo = $($toggler.data('toggleo'));
			} else {
				$toggleo = $togglee;
			}

			if (!(
					size === 'palm' ||
					size === 'portable' ||
					size === 'lap' ||
					size === 'lap-and-up' ||
					size === 'desk' ||
					size === 'desk-wide'
				)) {
				size = '';
			}
		
			// This is an on/off toggle using a slide animation. We use our own slideUp and slideDown functions.

			// If the subset has been passed in and if it's not an empty string, then prepend with dashes to build visibility class.
			// Otherwise, leave it as an empty string so that we will wind up with just "visuallyhidden".
			size = (size !== '') ? ('--' + size) : '';

			if ($togglee.hasClass('visuallyhidden' + size)) {
			// Close any open filters first
                var checkout_process = $('body#options').length || $('body#upgrade').length|| $('body#checkout').length == 0;
				if ($('.toggler').hasClass('open') && !$('.toggler').closest('#insuranceUI').length && !checkout_process) {
                    $('.toggler').removeClass('open');
					$('.toggler').addClass('closed');
					UI.slideUp($('.styled--select .togglee'));
                    
                    // WEBAE3-4854 Handle closing of opened accordion FAQ questions
                    UI.slideUp($('.US_Accordion .togglee'));
				}
				// Now open the the togglee
                $toggler.removeClass('closed')
                $toggler.addClass('open')
                $togglee.addClass('opening'); // Opening the toggle target, so add the 'open' class.
                UI.slideDown($togglee)
            } else if(!$togglee.hasClass('opening')) {
                $toggler.removeClass('open'); // Closing the toggle target, so remove the 'open' class.
                $toggler.addClass('closed'); // Closing the toggle target, so remove the 'open' class.
                UI.slideUp($togglee, size);
            }

            // Target an non nested header with an open class Modify Optional Eq has a cancel button that is an alternate toggler
            if ($toggleo.hasClass('open')) {
                $toggleo.removeClass('open');
            }

            // $('body').on('click', function () {
            // 	$('.toggler').removeClass('open')
            // 	$('.toggler').addClass('closed')
            // 	UI.slideUp($('.togglee'));
            // });

            // After the slide up or down is activated, the optional callback object is handled, if it was passed in.
            if (objCallback) {
                objCallback.func.apply(this, objCallback.args);
            }
			// }
		},
		closeToggle: function () {
            // WEABE3-3864 & 5526 - Plus Minus Headers shouldn't be part of the togglers auto-closed when something besides them gets clicked.
			$('.toggler:not(.toggle_pm_header):not(.package-header)').removeClass('open')
			$('.toggler:not(.toggle_pm_header):not(.package-header)').addClass('closed')
			UI.slideUp($('.styled--select .togglee'));

			// var $toggleParent = ([event.target][0].parentElement)
			// // console.log("&*&*&*&*&*&*&*&*&*&")
			// // console.log($toggleParent)
			// if ($toggleParent !== $('.matrix_filter')[0]) {
			// 	$('.toggler').removeClass('open')
			// 	$('.toggler').addClass('closed')
			// 	UI.slideUp($('.togglee'));
			// }
		},
		contentGroup: function ($controllers, $contentEls, settings) {
			/*
			Similar to tabs, but not limited by markup. The $controllers argument is a jQuery collection of links which will show or hide
			content. The $contentEls argument is a jQuery selector which targets the various content areas. For example, a set of navigation
			links could have a class called 'controllers' and the content areas could have a class called 'content'.

			The controller links each need to have a data attribute which will identify it's content area. This DOES NOT need to be an id.
			Content areas will be limited to the $contentEls collection, so the data attribute just needs to be unique in that context.

			NOTE: The settings object is optional, and is used to determine what kind of show/hide method will be used.

			1.	Setting the "willSlide" boolean property to true will cause items to slide up or down instead of the default show/hide.
			2.	The "visual" property determins whether our own show/hide methods will be used instead of the standard jQuery versions.
				Our methods show, hide and slide up or down using the "visuallyhidden" class within the inuitcss framework. Since these
				are technically visible (although off-screen) we can't just use is(":visible") to see if an element is shown on-screen.
				This function DOES NOT support the other forms of the "visuallyhidden" class used for media queries. It just uses the
				regular class.

			Here's an example of the markup:

			<nav>
				<a href class="myController" data-content="stuff">Stuff</a>
				<a href class="myController" data-content="things">Things</a>
				<a href class="myController" data-content="doodad">Doodads</a>
				<a href class="myController" data-content="dinglehopper">Dinglehopper</a>
			</nav>
			<div class="myContent" data-content="stuff">This is some stuff.</div>
			<div class="myContent" data-content="things">Here are some things.</div>
			<div class="myContent" data-content="doodad">Look at these doodads.</div>
			<div class="myContent" data-content="dinglehopper">Here is a dinglehopper.</div>

			You would either add "visuallyhidden" or style="display:none" to elements which will start out hidden.

			And then in your JavaScript:
			AE.ui.contentGroup( $('.myController'), $('.myContent') );
			*/
			var options = $.extend({
					willSlide: false, // slide up/down or just show/hide
					visual: false // display block/none or use "visuallyhidden" class
				},
				settings // Object passed in will override default.
			);

			var showHideFunc = (options.visual === true) ? visuallyToggle : showHide;

			$controllers.on("click", function (event) {
				event.preventDefault();
				$controllers.not($(this)).removeClass('current');
				$(this).addClass('current');

				// Saving "$(this)" to variable for when we go into a different scope.
				var $content = $contentEls.filter("[data-content='" + $(this).data('content') + "']");
				showHideFunc($contentEls, $content, options.willSlide);
			});


			function showHide($contentEls, $content, willSlide) {

				var $otherEls = $([]),
					$targetEl = $([]);

				$contentEls.not($content).each(function (index) {
					var $item = $(this);
					if ($item.is(':visible')) {
						$otherEls = $otherEls.add($item);
					}
				});

				if (!$content.is(':visible')) {
					$targetEl = $targetEl.add($content);
				}

				if (willSlide) {
					// Using jQuery selectors to decide which ones to show or hide.
					$otherEls.slideUp();
					$targetEl.slideDown();
				} else {
					// Using jQuery selectors to decide which ones to show or hide.
					$otherEls.hide();
					$targetEl.show();
				}
			}

			function visuallyToggle($contentEls, $content, willSlide) {

				// Empty at first, fill it up in a sec.
				var $otherEls = $([]),
					$targetEl = $([]);

				$contentEls.not($content).each(function (index) {
					var $item = $(this);
					if (!$item.hasClass('visuallyhidden')) {
						$otherEls = $otherEls.add($item);
					}
				});

				if ($content.hasClass('visuallyhidden')) {
					$targetEl = $targetEl.add($content);
				}


				if (willSlide) {
					// Using jQuery selectors to decide which ones to show or hide.
					AE.ui.slideUp($otherEls);
					AE.ui.slideDown($targetEl);
				} else {
					// Using jQuery selectors to decide which ones to show or hide.
					AE.ui.hide($otherEls);
					AE.ui.show($targetEl);
				}
			}
		}
		

		

	}
	return UI;
})();

;
var AE = AE || {}; /* Add to Base object or create it if it doesn't exist. */

/*
    This object will be the returned result of a self-invoked function. This allows us to expose methods
    for use by other modules while protecting some variables in a closure. If the object is already
    defined then it's not altered. This prevents us from running the entire function each time one of its
    internal methods are called.
*/
AE.ui.search = AE.ui.search || (function () {
    'use strict';
    /* DEPENDENCIES: Any other modules that this one will call */

    var oSubmit = {},
        oStoredSearch = {},
        props = {},
        searchPuDate,
        searchDoDate,
        searchPuTime,
        searchDoTime,
        isMenuSearch = false;

    var UI = {
        init: function () {
            // Options for the datepicker, adding to props because they need to be reset (after widget.Destroy) in order to change the number of displayed months
            props = {
                $form: $("#ae-search"),
                memberage: "",
                ageDefault: (AEdata && AEdata.defaultAgeOverride) ? AEdata.defaultAgeOverride : 40, // The generic default age can be overridden by member age bewteen 25-69 in search_form.cfm - WEBAE3-1686
                ageMin: 25, // The minimum age to rent without additional restrictions or fees
                ageMax: 69, // The maximum age to rent without additional restrictions or fees
                direction: "",
                useStoredSearch: (typeof useStoredSearch != "undefined") ? useStoredSearch : false, // useStoredSearch: ("localStorage" in window),
                $viewSize: AE.getSiteViewType(), // As of now, only changing the number of months displayed on the calendar for handhelds
                searchFormErrorHandler: {},
                displayMenusearch: AE.ui.props.$menusearchEnabled,
                oStoredSearch: AE.ui.search.getStoredSearch(),
                menusearch: {},
                menusearchOptions: {
                    searchtype: 'menusearch',
                    query: window.location.search.substring(1),
                    timeout: 0
                },
                $searchFormErrorHandler: {
                    msgTitle: null,
                    msgDesc: null,
                    pos: {
                        top: -5,
                        left: 0
                    }
                },
                hasAgeChkbx:true,
            };

            if(oSite.bIsDapTpDomain){ //WEBAE3-6038
                if (oSite.path_info === ""){ 
                    AE.ui.search.cleanStoredSearch();
                }
            }

            if (!window.jsloginStatus) {
                if (UI.readCookie('MEMBERAGE')) { $.removeCookie('MEMBERAGE', { path: '/' }); }
                if (UI.readCookie('MEMBERFIRST')) { $.removeCookie('MEMBERFIRST', { path: '/' }); }
                props.showFillAgeCheckout = true;
            }

            // The appendTarget considers this module when setting its value
            props.$topSearch = AE.ui.props.appendTarget;
            props.$bottomSearch = '#bottom_search_form';
            props.$searchContainer = $('#search-form')[0];
            props.$searchSlideBtn = $('#targetSearch');

            props.$locationsWrapper = $('#locations-wrapper');
            props.$chkDiff = props.$form.find($("input[name='chk-diff']")); // Pointer to the "Different Dropoff Location" checkbox form field
            props.$chkAge = props.$form.find($("input[name='chk-age']")); // Pointer to the "Age" checkbox form field
            props.$txtAge = props.$form.find($("input[name='txt-age']")); // Pointer to the "Age" text imput form field

            props.$jsonPost = props.$form.find($("input[name='jsonPost']")); // A stringified version of the other values in the "form" object
            props.$btnSubmit = props.$form.find($("button[name='btn-submit']")); // Button used to submit the hidden form

            props.$puLoc = props.$form.find($("div[name='pickup-loc']"));
            props.$doLoc = props.$form.find($("div[name='dropoff-loc']"));

            // MENU search: pointers to the PU & DO form fields
            props.$menu_puCountry = props.$form.find($("select[name='PU-country']"));
            props.$menu_puCity = props.$form.find($("select[name='PU-city']"));
            props.$menu_puLocation = props.$form.find($("select[name='PU-loc']"));
            props.$menu_doCountry = props.$form.find($("select[name='DO-country']"));
            props.$menu_doCity = props.$form.find($("select[name='DO-city']"));
            props.$menu_doLocation = props.$form.find($("select[name='DO-loc']"));

            // Pointers to the "Pickup Date" & "Dropoff Date" form fields
            props.$puDate = props.$form.find($("input[name='pickup-date']"));
            props.$doDate = props.$form.find($("input[name='dropoff-date']"));
            props.$doDateOneway = props.$form.find($("input[id='dropoff-date_oneway']"));

            // Pointers to the hidden "Pickup Date" & "Dropoff Date" form fields - used when the past search criteria is found
            props.$hiddenPuDate = props.$form.find($("input[name='hidden-pickup-date']"));
            props.$hiddenDoDate = props.$form.find($("input[name='hidden-dropoff-date']"));
            

            // Pointers to the "Pickup Time" & "Dropoff Time" form fields
            props.$puTime = props.$form.find($("select[name='pickup-time']"));
            props.$doTime = props.$form.find($("select[name='dropoff-time']"));
            props.$doTimeOneway = props.$form.find($("select[id='dropoff-time_oneway']"));

            // Pointers to the hidden "Pickup Time" & "Dropoff Time" form fields - used when the past search criteria is found
            props.$hiddenPuTime = props.$form.find($("input[name='hidden-pickup-time']"));
            props.$hiddenDoTime = props.$form.find($("input[name='hidden-dropoff-time']"));
         
            props.memberage = UI.readCookie('MEMBERAGE');

            props.$fcrOnewayChk = props.$form.find($("input[name='fcr-oneway_chk']"))
 

            if (props.memberage == null) {
                props.memberage = (AEdata && AEdata.defaultAgeOverride) ? AEdata.defaultAgeOverride : props.memberage;
            }
           
            props.useStoredSearch = (!AE.privateBrowsing._checkLocalStorageAvailability()) ? true : false;

            if (!props.useStoredSearch) {
                props.ageDefault = (props.memberage) ? props.memberage:  props.ageDefault;       
            }

            isMenuSearch = prepMenusearch;//WEBAE3-4074 prepMenusearch will always be a boolean from CF now

            if(AE.props.siteCode){props.hasAgeChkbx = (AE.props.siteCode === 'PEU' || AE.props.siteCode === 'RNZ'|| AE.props.siteCode === 'RAU')? false : true;}

            oSubmit = {
                viewSize: AE.getSiteViewType(),
                display_label: null, // display value for search input
                display_labelr: null, // display value for search input
                city: null, // city name for pickup
                cityr: null, // city name for dropoff
                puloclist: null, // list of pickup locations
                doloclist: null, // list of dropoff locations
                pucode: null, // country ISO code for pickup
                docode: null, // country ISO code for dropoff
                puloctype: null, // category type for pickup
                doloctype: null, // category type for dropoff
                puCal: null, // pickup date sent from form (different from what the user sees)
                doCal: null, // dropoff date sent from form (different from what the user sees)
                putime: null, // pickup hour, must be 24 hour time, 0 - 23
                dotime: null, // dropoff hour, must be 24 hour time, 0 - 23
                puchaos_hub_id: null, // chaos_hub_id to increment click count server side
                dochaos_hub_id: null, // chaos_hub_id to increment click count server side
                searchAge: props.ageDefault, // checkbox for when the driver's age is less than 25 or over 69
                searchAgeCheckbox: true,
                showFillAgeCheckout:true,
                bookingstep: 'searchwait', // Set and done - required for back-end
                bookingUUID: '', // Filled with Car Search UUID or Booking Lookup UUID when posting from the Booking Process or Lookup Page respectively
                excl_ltr: false, // Flag for Long-Term Rental/Peugeot Lease exclusive search
                excl_cats: '' // Optional comma-delimited list of category codes (e.g. C6,C10 for luxury/convertible) for category exclusive search
            };

             props.searchAgeCheckbox = props.hasAgeChkbx;

            // Set the age checkbox as checked, setting the text input to the default age - moved above stored search check WEBAE3-1695
            if(props.hasAgeChkbx){
                if (props.ageDefault >= props.ageMax || props.ageDefault <= props.ageMin) {
                     props.$chkAge.prop('checked', false);
                     props.$txtAge.val(props.ageDefault.toString()).show();
                } else {
                   props.$chkAge.prop('checked', true);  
                   props.$txtAge.val(props.ageDefault.toString()).hide();
                }
            }
            //WEBAE3-5460 if WL site, make sure aff and sys haven't changed
            //and if they have, clear stored search (again) only on white labels
            if(localStorage.getItem('aeSearchAff') !== null && localStorage.getItem('aeSearchSys') !== null && oSite.mSiteCode == 'WL'){
                if(localStorage.getItem('aeSearchAff') !== oSite.affiliate || localStorage.getItem('aeSearchSys') !== oSite.chaosSystem){
                    localStorage.removeItem('aeSearch');
                    localStorage.removeItem('aeSearchAff');
                    localStorage.removeItem('aeSearchSys');
                }
            }

            if(AE.ui.search.useStoredSearch() && localStorage.getItem('aeSearch') === null && AECookie.read('aeSearch')){
                var cookieSearch = AECookie.read('aeSearch');
                if(_.isString(cookieSearch) && cookieSearch !== ''){
                    localStorage.setItem('aeSearch',cookieSearch);
                }
            }

            if (AE.ui.search.useStoredSearch() && localStorage.getItem('aeSearch') && 
                _.isString(localStorage.getItem('aeSearch')) && 
                localStorage.getItem('aeSearch') != '') {
                props.oStoredSearch = JSON.parse(localStorage.getItem('aeSearch'));

                if (props.oStoredSearch.putime && _.isString(props.oStoredSearch.putime) && props.oStoredSearch.putime != '') {
                    searchPuTime = props.oStoredSearch.putime;
                    props.$hiddenPuTime.val(searchPuTime);
                    props.$puTime.val(searchPuTime);
                } else {
                    searchPuTime = '10:00';
                    props.$hiddenPuTime.val(searchPuTime);
                    props.$puTime.val(searchPuTime);
                }
                
                if (props.oStoredSearch.dotime && _.isString(props.oStoredSearch.dotime) && props.oStoredSearch.dotime != '') {
                    searchDoTime = props.oStoredSearch.dotime;
                    props.$hiddenDoTime.val(searchDoTime);
                    props.$doTime.val(searchDoTime);
                } else {
                    searchDoTime = '10:00';
                    props.$hiddenDoTime.val(searchDoTime);
                    props.$doTime.val(searchDoTime);
                }
                
                if (props.oStoredSearch.puCal && _.isString(props.oStoredSearch.puCal) && props.oStoredSearch.puCal != '') {
                    searchPuDate = props.oStoredSearch.puCal;
                    props.$hiddenPuDate.val(searchPuDate);
                }
                
                if (props.oStoredSearch.doCal && _.isString(props.oStoredSearch.doCal) && props.oStoredSearch.doCal != '') {
                    searchDoDate = props.oStoredSearch.doCal;
                    props.$hiddenDoDate.val(searchDoDate);
                    isMenuSearch = prepMenusearch;//WEBAE3-4074 prepMenusearch will always be a boolean from CF now
                }
                
                //WEBAE3-1695 - use age from stored search if avail

                if (props.oStoredSearch.searchAge && props.oStoredSearch.search != '' && !isLTRSearch) {
                    searchAge = props.oStoredSearch.searchAge;
                    AE.ui.search.setAge(searchAge);//setAge function handles box checking for age range

                    //if previous search had box unchecked, make sure this one does, too - WEBAE3-1686
                    if (props.oStoredSearch.searchAgeCheckbox === false) {
                        AE.ui.search.forceSearchAgeCheckBox();
                     }
                }
            } else {
                //WEBAE3-1686 if not using local storage so analyze search age set in search_form.cfm for possible member age or oBK age
                if (props.ageDefault && props.ageDefault != '' && props.hasAgeChkbx) {
                    AE.ui.search.setAge(props.ageDefault);
                } else if (searchAge && searchAge != '') {
                    AE.ui.search.setAge(searchAge);

                    //if previous search had box unchecked, make sure this one does, too - WEBAE3-1686
                    if (props.oStoredSearch.searchAgeCheckbox === false) {
                        AE.ui.search.forceSearchAgeCheckBox();
                     }
                }
            }

            if(isBMRSearch){
               if(localStorage.getItem('aeBMRsearch')){ 
                    var bmr_age = JSON.parse(localStorage.getItem('aeBMRsearch')).driverAge;
                    props.$txtAge.val(bmr_age);
                } 
            }

             if(!props.hasAgeChkbx){
                props.$chkAge.hide();
                $('label[for="chk-age"]').hide();

                props.$txtAge.addClass('flush').prop('required',true).attr('max',1000);
                $('input[name="txt-age"]').show();
                props.$txtAge.show();
           
                if(props.memberage && props.memberage != '' && !AE.ui.search.useStoredSearch()){
                      props.$txtAge.val( props.memberage);
                }       
            }

            //search age handlers
            props.$chkAge.on("change", function (event) {
                UI.chkAgeHandler(event.target.checked);
                var _checked = $(this).is(':checked');
                if (!_checked) {
                    props.$txtAge.attr({ 'required': true });
                    if (AE.props.siteCode == 'FCR') {
                        $('#txt-age-error').show();
                    }
                } else {
                    props.$txtAge.attr({ 'required': false });
                    if (AE.props.siteCode == 'FCR') {
                        $('#txt-age-error').hide();
                    }
                }
                if(!AE.account.props){AE.account.init();}

                if (props.memberage && AE.account.props.$isLoggedIn && !isBMRSearch) {
                    if (_checked) {
                        if (props.$txtAge.val() > props.ageMax || props.$txtAge.val()< props.ageMin || props.$txtAge.val() == "") {
                            UI.setAge(40);// WEABE3-2963 - Changing this value to props.ageDefault in WEBAE3-2936 causes the checkbox to break
                            // Returning this value to 40 restores checkbox functionality WITHOUT messing up the age input filling from the voucher OR member data
                        } else { 
                            UI.setAge(props.$txtAge.val());
                        }
                    }
                }
                //WEBAE3-3047
                if (isBMRSearch) {
                    if (bmr_age) {
                         props.$txtAge.val(bmr_age);
                    } else if ( props.memberage) {
                     props.$txtAge.val(props.memberage);
                   }
                }
            });
            //search age handlers
            props.$txtAge.on("blur", function (event) {
                var runThis = true;
                if (AE.props.isAUNZ) { runThis = false; }
                if (runThis) {
                    if (props.$txtAge.val() != '') {
                        props.ageDefault = props.$txtAge.val();
                        searchAge = props.oStoredSearch.searchAge;
                    } else {
                        props.$txtAge.attr({'required': true });
                        oSubmit.searchAge = '';
                        UI.chkAgeHandler(props.$chkAge.prop('checked'));
                    }
                } else {
                    props.$txtAge.attr({'required': true });
                }
            });
            props.$chkDiff.on("change", function (event) {
                var _checked = $(this).is(':checked');
                if (_checked) {
                    props.$locationsWrapper.addClass('both');
                } else {
                    props.$locationsWrapper.removeClass('both');

                    // clear the drop off input and check for LTR
                    if (isLTRSearch) {
                        AE.ui.searchType.leasesearch.props.$ltrdo.val(AE.ui.searchType.leasesearch.props.$ltrpu.val());
                        AE.ui.searchType._forceInputBlur(AE.ui.searchType.text.props.$ltrdo);
                    } else if (isBMRSearch) {
                        // AE.ui.searchType.bmr.props.$ltrdo.val(AE.ui.searchType.bmr.props.$ltrpu.val());
                    } else {
                        AE.ui.searchType.text.props.$doLoc.next('.ui-textsearch-clear-input').trigger('click');
                        AE.ui.searchType._forceInputBlur(AE.ui.searchType.text.props.$doLoc);
                    }
                }
            });

            // // keep oneway search open without registering change event
            // if ($("input[name='chk-diff']").is(":checked")) {
            //     alert("checked")
            //     props.$locationsWrapper.addClass('both');
            // } else {
            //     props.$locationsWrapper.removeClass('both');
            //     alert("NOT checked")

            // }

            // Set the bookingUUID
            if (AEdata) {
                if (AEdata.booking && AEdata.booking.props && AEdata.booking.props.uuid) {
                    oSubmit.bookingUUID = AEdata.booking.props.uuid;
                } else if (AEdata.modify && AEdata.modify.uuid) {
                    oSubmit.bookingUUID = AEdata.modify.uuid;
                }
                // Set the Commission Junction Event ID //WEBAE3-5634 : commission junction - believe this to possibly still be in use
                if(AEdata.URL && AEdata.URL.cjevent){
                    oSubmit.cjEvent = AEdata.URL.cjevent;
                } else if(AEdata.URL && AEdata.URL.CJEVENT) {
                    oSubmit.cjEvent = AEdata.URL.CJEVENT;
                } else if(AECookie.read('cje')) { //WEBAE3-5053
                    if(_.isString(AECookie.read('cje')) && AECookie.read('cje') !== ''){
                        oSubmit.cjEvent = AECookie.read('cje');
                    }
                }
            }
            // Set exclusive search parameters
            if ($('.search-type--lease')[0]) {
                oSubmit.excl_ltr = true;
            } // Long Term Rental/Short Term Lease/Buyback only search
            
            if ($('.search-type--luxury')[0]) {
                oSubmit.excl_cats = 'C6,C10';
            } // Luxury ONLY Search - will include Standards to ensure results come back
            
            if ($('.search-type--van')[0]) {
                oSubmit.excl_cats = 'C8,C9';
            } // Vans ONLY Search

            // Submit button behaviors
            props.$btnSubmit.on("click", function (event) {
                event.preventDefault();
                UI.formSubmit();
            });

            // Slide down to the form
            props.$searchSlideBtn.on("click", function (event) {
                $('#scroll-content').stop().animate({
                        scrollTop: parseInt($(props.$bottomSearch).offset().top)
                    },
                    'fast',
                    'swing'
                );
            });

            // (WEBAE3-1095)
            props.$txtAge.on('keydown', function (e) {
                if (e.keyCode == 13) {
                    e.preventDefault();
                }
            });

            // Submit the search form when the user presses the submit button
            // Ignore "Return" by defaulting to click submit button
            props.$form.on('keydown', function (e) {
                if (e.keyCode == 13) {
                    // props.$btnSubmit.click();
                    e.preventDefault();// WEBAE3-3383
                }
            });

            // ONLY RUN IF THE BOTTOM FORM CONTAINER EXISTS
            if (props.$bottomSearch != 'undefined') {
                // If open site in mobile view append search to bottom container
                if (AE.getSiteViewType() == 'palm') {
                    AE.ui.props.appendTarget = props.$bottomSearch; // set target
                    // wait for the page to load everything then append
                    $(window).on('load', function () {
                        $(props.$bottomSearch).append(props.$searchContainer)
                            .ready(function () {
                                // try and catch any mis loads and set page at top
                                $('#scroll-content').scrollTop(0);
                            });
                    });
                } else {
                    AE.ui.props.appendTarget = ($('#ae-search').closest('.ui-dialog')[0]) ? null : props.$topSearch;
                }

                // Transition between lap and palm append search
                AE.addTransitionTask({
                    func: function () {
                        /*  HANDLES CONTENT MOVED BY APPEND:
                            ARGUMENTS: 'Palm View', 'Desk Container', 'Mobile Container', 'Content Appended'  */
                        UI.palmTransition(arguments[0], props.$topSearch, props.$bottomSearch, '#search-form'); // Search Form
                    }
                });
            };

            

            props.$fcrOnewayChk.on("change", function(event) {
                var _checked = $(this).is(':checked');
                if (_checked) {
                    UI.fcrToggleOnewayOpen();
                } else {
                    UI.fcrToggleOnewayClose();
                }
            });

            if (AE.props.siteCode == 'FCR') {
                $(document).ready(function(event) {
                    if(props.$fcrOnewayChk.is(':checked')){
                        UI.fcrToggleOnewayOpen();
                    } else {
                        //see if different dropoff box should be checked on page load based on previous search
                        var oStoredSearch = JSON.parse(localStorage.getItem('aeSearch'));
                        try {
                            if (oStoredSearch.puloclist !== oStoredSearch.doloclist && oStoredSearch.doloclist !== null && typeof AEdata.booking === 'undefined') {
                                $("input[name='fcr-oneway_chk']").prop( "checked", true );
                                UI.fcrToggleOnewayOpen();
                            } 
                        }
                        catch (e) {
                        }
                    }
                });
            }

            if (AE.props.siteCode == 'FCR' && typeof(AEdata.booking) !== 'undefined') {
                //console.log("this ran AEbooking ==", AEdata.booking )
                $(document).ready(function(event) {
                    //console.log("this ran too")
                    UI.fcrOneWayToggle();
                });
            }
        },

        fcrToggleOnewayOpen: function(){
            //make sure it isn't already open
            if(!props.$locationsWrapper.hasClass('both')) {
                props.$locationsWrapper.addClass('both');
                $(".fcr-dropoff_toggle").slideDown();
                $(".fcr-input_text_over").addClass('fcr-full_width');
                $(".fcr-pu_do_toggle").toggle();
            }
        },
        fcrToggleOnewayClose: function(){
            props.$locationsWrapper.removeClass('both');
            $(".fcr-dropoff_toggle").slideUp();
            $(".fcr-pu_do_toggle").toggle();
            $(".fcr-input_text_over").removeClass('fcr-full_width');
            $("[name='dropoff-loc']").next('.ui-textsearch-target-input').trigger('click');
        },
        palmTransition: function () {
            var palmContent = $('' + arguments[3] + '')[0];
            var container = (arguments[0]) ? arguments[2] : arguments[1];

            if (AE.getSiteViewType() == 'palm') {
                AE.ui.props.appendTarget = props.$bottomSearch;
            } else {
                AE.ui.props.appendTarget = ($('#ae-search').closest('.ui-dialog')[0]) ? null : props.$topSearch;
            }

            $('' + container + '').append(palmContent);
        },
        getValue: function (property) {
            /*
            Gets the current value from the JSON object which will be submitted to the server. This
            isn't the same as getting the value of the
            */
            var value = 'No property given';
            var _obj = Object.keys(oSubmit);

            for (var i in _obj) {
                var _key = _obj[i];
                if (_key.toString() == property) {
                    value = oSubmit[_key];
                }
            }
            return value;
        },
        getSubmitValues: function () {
            // Returns the JSON object which will be submitted to the server
            return oSubmit;
        },
        getStoredSearch: function () {
            // Returns the JSON object which will was submitted to the server and saved in local storage
            if (props.oStoredSearch) {
                return props.oStoredSearch; // WEBAE3-2049 added 'props.' so menu search doesn't get empty default object
            } else {
                return oStoredSearch; // return empty default struct
            }; 
        },
        getMaxAge: function () {
           return props.$ageMax;
        },
        getMinAge: function () {
           return props.$ageMin;
        },
        setValue: function (settings) {
            var options = {
                name: null,
                value: null,
                item: null,
                jsonOnly: false
            };
            $.extend(options, settings);

            // Without a name, we can't go forward
            if (!options.name) {
                throw "ERR: AE.ui.search.setValue() - No input or value given.";
            }

            if (options.resetAge) {
                oSubmit.searchAge = '';
            }

            if (options.item) {
                // Only the autocomplete needs entire jQuery UI item. For now, we'll just
                // assume that we're dealing with those two fields only.
                if (options.name == 'pickup-loc') {
                    UI.autocomplete.setValue(options.item);
                } else if (options.name == 'dropoff-loc') {
                    UI.autocomplete.setValue(options.item);
                } else {
                    throw 'ERR search.setValue(): Valid jQuery UI item required.';
                }
            }
            if (options.value) {
                // If there's a value, then we're going to directly set the input
                switch (options.name) {
                    case "pickup-time":
                        if (!options.jsonOnly) {
                            props.$puTime.val(options.value);
                        }
                        oSubmit.putime = options.value;
                        props.$hiddenPuTime.val(options.value);
                        break;
                    case "dropoff-time":
                        if (!options.jsonOnly) {
                            props.$doTime.val(options.value);
                        }
                        oSubmit.dotime = options.value;
                        props.$hiddenDoTime.val(options.value);
                        break;
                    case "pickup-date":
                        if (!options.jsonOnly) {
                            props.$puDate.val(options.value);
                        }

                        var _puDate = UI.isValidDate(options.value) ? options.value : AE.ui.datepicker.convertDate(props.$puDate);

                        oSubmit.puCal = _puDate;
                        props.$hiddenPuDate.val(_puDate);

                        break;
                    case "dropoff-date":
                        if (!options.jsonOnly) {
                            props.$doDate.val(options.value);
                        }

                        var _doDate = UI.isValidDate(options.value) ? options.value : AE.ui.datepicker.convertDate(props.$doDate);

                        oSubmit.doCal = _doDate;
                        props.$hiddenDoDate.val(_doDate);

                        break;
                        //case 'chk-diff':
                        //  break;
                        //case 'chk-age':
                        //  break;
                        //VM
                    case "txt-age":
                        if (!options.jsonOnly) {
                            props.$txtAge.val(options.value);
                        }
                        oSubmit.searchAge = options.value;
                        break;
                    case "chk-age":
                        if (!options.jsonOnly) {
                            props.$chkAge.prop('checked');
                        }
                        oSubmit.searchAgeCheckbox = options.value;
                        break;
                    case "display_label":
                        oSubmit.display_label = options.value;
                        break;
                    case "display_labelr":
                        oSubmit.display_labelr = options.value;
                        break;
                    default:
                        throw "ERR search.setValue(): Valid value required.";
                }
            }

            return oSubmit;
        },
        getmemberage : function() {
            return  props.memberage;
        },
        isValidDate : function(d) {
            return d instanceof Date && !isNaN(d);
        },
        formSubmit: function (loginOverride) {
			loginOverride = loginOverride || false;

            /*
                oSubmit.city        = set upon select in the ui.autocomplete module
                oSubmit.cityr       = set upon select in the ui.autocomplete module
                oSubmit.puloclist   = set upon select in the ui.autocomplete module
                oSubmit.doloclist   = set upon select in the ui.autocomplete module
                oSubmit.pucode      = set upon select in the ui.autocomplete module
                oSubmit.docode      = set upon select in the ui.autocomplete module
                oSubmit.puCal       = set upon init and select in the ui.datepicker module
                oSubmit.doCal       = set upon init and select in the ui.datepicker module
                oSubmit.searchAge   = Set in the behaviors listed above
                oSubmit.searchAgeCheckbox
            */

            var $ui_chkDiff = props.$chkDiff;

            // Text search
             var $ui_puInput = props.$puLoc;
             var $ui_doInput = props.$doLoc;

            // Menu search
            var $ui_menu_puInput_country = props.$menu_puCountry;
            var $ui_menu_puInput_city = props.$menu_puCity;
            var $ui_menu_puInput_location = props.$menu_puLocation;
            var $ui_menu_doInput_country = props.$menu_doCountry;
            var $ui_menu_doInput_city = props.$menu_doCity;
            var $ui_menu_doInput_location = props.$menu_doLocation;

            var $ui_puDate = props.$puDate;
            var $ui_doDate = props.$doDate;

            var $ui_puTime = props.$puTime;
            var $ui_doTime = props.$doTime;

            var $ui_chkAge = props.$chkAge;
            var $ui_txtAge = props.$txtAge;
            var $_subBtn = props.$btnSubmit;

            var _flagTitle;
            var _flagMsg;
            var _posDiff = {
                top: -5,
                left: 0
            };

            var $ui_elObj = {}

            if (isMenuSearch && !loginOverride && !isLTRSearch) {       
                $ui_elObj.menusearchpucountry = ($ui_menu_puInput_country.val() === '' || $ui_menu_puInput_country.val() === '--') ? $fn_checkMenuSearchLocationInput : false;
                $ui_elObj.menusearchpucity = ($ui_menu_puInput_city.val() === '' || $ui_menu_puInput_city.val() === '--') ? $fn_checkMenuSearchLocationInput : false;
                $ui_elObj.menusearchpulocation = ($ui_menu_puInput_location.val() === '' || $ui_menu_puInput_location.val() === '--') ? $fn_checkMenuSearchLocationInput : false;
                if ($ui_chkDiff.is(':checked')) {
                    $ui_elObj.menusearchdocountry = ($ui_menu_doInput_country.val() === '' || $ui_menu_doInput_country.val() === '--') ? $fn_checkMenuSearchLocationInput : false;
                    $ui_elObj.menusearchdocity = ($ui_menu_doInput_city.val() === '' || $ui_menu_doInput_city.val() === '--') ? $fn_checkMenuSearchLocationInput : false;
                    $ui_elObj.menusearchdolocation = ($ui_menu_doInput_location.val() === '' || $ui_menu_doInput_location.val() === '--') ? $fn_checkMenuSearchLocationInput : false;
                }
            } else if (isBMRSearch) {                
                // Let remote BMR API call to check results handle incomplete input
                $ui_menu_puInput_country = $('select#bmr__country');
                $ui_menu_puInput_city = $('select#bmr__city');
                $ui_menu_doInput_country = $('select#bmr__countryr');
                $ui_menu_doInput_city = $('select#bmr__cityr');
                $ui_elObj.menusearchpucountry = ($ui_menu_puInput_country.val() === '' || $ui_menu_puInput_country.val() === '--') ? $fn_checkMenuSearchLocationInput : false;
                $ui_elObj.menusearchpucity = ($ui_menu_puInput_city.val() === '' || $ui_menu_puInput_city.val() === '--') ? $fn_checkMenuSearchLocationInput : false;
                if ($ui_chkDiff.is(':checked')) {
                    $ui_elObj.menusearchdocountry = ($ui_menu_doInput_country.val() === '' || $ui_menu_doInput_country.val() === '--') ? $fn_checkMenuSearchLocationInput : false;
                    $ui_elObj.menusearchdocity = ($ui_menu_doInput_city.val() === '' || $ui_menu_doInput_city.val() === '--') ? $fn_checkMenuSearchLocationInput : false;
                }
            } else {
               if (isLTRSearch ) {
                    $ui_puInput = AE.ui.searchType.leasesearch.props.$ltrpu;
                    $ui_doInput =  AE.ui.searchType.leasesearch.props.$ltrdo;

                    if($ui_puInput.val() === ''){
                        $ui_elObj.textsearchlocation = $fn_flagLocationInput;
                    }else if ($ui_doInput.val() === ''){
                        $ui_elObj.textsearchlocation = $fn_flagLocationInput;
                    }else{
                        $ui_elObj.textsearchlocation = false;
                    } 
                } else {
                   $ui_elObj.textsearchlocation = (UI.getValue("city") == null) ? $fn_flagLocationInput : false;                     
               }       
            }

            if (isBMRSearch && AE.ui.searchType.bmr) {
                if(AE.props.isAUNZ && AE.account.props.$isLoggedIn && props.$txtAge.val() == ""){
                    /* WEBAE3-3034 - AUS and NZL display changes lead to mix ups when
                        user is logged in, but deletes their age from the BMR search form
                        this forces stricter validation and the appropriate alerts to display
                    */
                    oSubmit.searchAgeCheckbox = false;
                    oSubmit.searchAge = '';
                }
            }  
           
            if(props.hasAgeChkbx){
                $ui_elObj.age = (!UI.getValue("searchAgeCheckbox") && props.$txtAge.val() === "" ) ? $fn_flagChkAgeInput : false;               
                //$ui_elObj.age = (!UI.getValue("searchAgeCheckbox") && UI.getValue("searchAge") == "" ) ? $fn_flagChkAgeInput : false;
            }
            else{
                $ui_elObj.age = (UI.getValue("searchAge") == "" ||  $ui_txtAge.val() == '') ? $fn_flagChkAgeInput : false;
            }

            //WEBAE3-4473 - make sure DO is later than PU
            var pickupDate = new Date($.datepicker.formatDate('yy-mm-dd',$ui_puDate.datepicker("getDate")) + 'T' + $ui_puTime.val());
            var dropoffDate = new Date($.datepicker.formatDate('yy-mm-dd', $ui_doDate.datepicker("getDate")) + 'T' + $ui_doTime.val());
            $ui_elObj.badDates = (dropoffDate.getTime() <= pickupDate.getTime()) ? $fn_flagDates  : false;


            AE.forms.addSpinGear($_subBtn.attr('disabled', true));
            for (var i = 0; i < Object.keys($ui_elObj).length; i++) {
                var _el = Object.keys($ui_elObj)[i];       

                if ($ui_elObj[_el] != false) {
                 return $ui_elObj[_el]();
                }
            }
            function $fn_flagDates() {
                $ui_doTime.addClass('ui--invalid-input');
                var _posDiff = {
                    top: -5,
                    left: -8
                };

                _flagTitle = AE.ui.decodeHtml(AE.props.oSearch.LABEL_DROPOFF_TIME); 
                _flagMsg = '';

              return AE.ui.search.searchFormErrorHandler.init(_flagTitle, _flagMsg, _posDiff);
            }
            function $fn_flagLocationInput() {

                var _posDiff = {
                    top: -5,
                    left: -8
                };

                if(isLTRSearch ){          
                    if($ui_puInput.val() === ''){
                        $ui_puInput.addClass('ui--invalid-input');
                        _flagTitle = AE.ui.decodeHtml(AE.props.oSearch.ERRORMSG_INPUTEMPTY); 
                        _flagMsg = '';
                        $ui_puInput.attr({
                            placeholder: _flagTitle
                        });
                    }else{
                        $ui_doInput.addClass('ui--invalid-input');
                        _flagTitle = AE.ui.decodeHtml(AE.props.oSearch.ERRORMSG_INPUTEMPTY); 
                        _flagMsg = '';
                        $ui_doInput.attr({
                            placeholder: _flagTitle
                        });
                    }
                }else{
                     $ui_puInput.addClass('ui--invalid-input');
                     _flagTitle = AE.ui.decodeHtml(AE.props.oSearch.ERRORMSG_PULOCEMPTY); 
                    _flagMsg = AE.ui.decodeHtml(AE.props.oSearch.ERRORMSG_INPUTEMPTY);
                    $ui_puInput.attr({
                        placeholder: _flagTitle
                    });
                } 

              return AE.ui.search.searchFormErrorHandler.init(_flagTitle, _flagMsg, _posDiff);
            }                

            function $fn_flagChkAgeInput() {
                var $ui_ageInput = $ui_txtAge;
                var _val = $ui_ageInput.val();
                var _chars = _val.length;
                var _min = $ui_ageInput.attr('min');
                var _max = $ui_ageInput.attr('max');

                _posDiff = {
                    top: -5,
                    left: AE.legacy.grief.isIE ? 180 : 165
                };

                if((isBMRSearch && AE.props.isAUNZ) || !props.hasAgeChkbx) {
                    _posDiff = { top: -5 };
                }

                $ui_txtAge.addClass('ui--invalid-input').parent().css({
                    position: 'relative'
                });

                if (_val == '') { //} || _val <= 17) {
                    _flagTitle = AE.props.oSearch.ERRORMSG_DRIVERAGETITLE; //'DRIVER AGE'
                    _flagMsg = AE.props.oSearch.ERRORMSG_DRIVERAGEMESSAGE; //'ENTER A THE DRIVER'S AGE'
                    return AE.ui.search.searchFormErrorHandler.init(_flagTitle, _flagMsg, _posDiff);
//                } else if ( (_val < parseInt(_min)) || (_chars == 2 && (parseInt(_val) < parseInt(_min))) ) {
                } else if ( (parseInt(_val) < parseInt(_min)) || (parseInt(_val) > parseInt(_max)) ) {
                    _flagTitle = AE.props.oSearch.ERRORMSG_INVALIDAGETITLE; //'INVALID AGE SELECTION'
                    _flagMsg = AE.props.oSearch.ERRORMSG_INVALIDAGEMESSAGE.replace('[AGE]', '<strong>' + _min + '</strong>');
                    return AE.ui.search.searchFormErrorHandler.init(_flagTitle, _flagMsg, _posDiff);
                }

                UI.setValue({
                    name: 'txt-age',
                    value: props.$txtAge.val(),
                    jsonOnly: true
                });
          
                props.$btnSubmit.removeClass('ui--btn-submit-wait').attr({
                    'disabled': false
                }).find('.ui--loading-results').remove();
               // return props.$btnSubmit.trigger('click');
               return false;
            }

            function $fn_checkMenuSearchLocationInput() {
                var menuSearchError = false;

                // Only show one error in this particular order
                if ($ui_menu_puInput_country.val() === '' || $ui_menu_puInput_country.val() === '--') {
                    menuSearchError = true;
                    $ui_menu_puInput_country.addClass('ui--invalid-input');
                    _posDiff = { top: -19, left: -2 };
                } else if ($ui_menu_puInput_city.val() === '' || $ui_menu_puInput_city.val() === '--') {
                    menuSearchError = true;
                    $ui_menu_puInput_city.addClass('ui--invalid-input');
                    _posDiff = { top: -19, left: -2 };
                } else if ($ui_menu_puInput_location.val() === '' || $ui_menu_puInput_location.val() === '--') {
                    menuSearchError = true;
                    $ui_menu_puInput_location.addClass('ui--invalid-input');
                    _posDiff = { top: -19, left: -15 };
                } else if ($ui_chkDiff.is(':checked')) {
                    if ($ui_menu_doInput_country.val() === '' || $ui_menu_doInput_country.val() === '--') {
                        menuSearchError = true;
                        $ui_menu_doInput_country.addClass('ui--invalid-input');
                        _posDiff = { top: -19, left: -2 };
                    } else if ($ui_menu_doInput_city.val() === '' || $ui_menu_doInput_city.val() === '--') {
                        menuSearchError = true;
                        $ui_menu_doInput_city.addClass('ui--invalid-input');
                        _posDiff = { top: -19, left: -2 };
                    } else if ($ui_menu_doInput_location.val() === '' || $ui_menu_doInput_location.val() === '--') {
                        menuSearchError = true;
                        $ui_menu_doInput_location.addClass('ui--invalid-input');
                        _posDiff = { top: -19, left: -15 };
                    }
                }

                if (menuSearchError) {
                    _flagTitle = AE.ui.decodeHtml(AE.props.oSearch.ERRORMSG_INPUTEMPTY); //'INPUT CANNOT BE EMPTY'
                    _flagMsg = '';
                    $ui_puInput.attr({ placeholder: _flagTitle });
                    return AE.ui.search.searchFormErrorHandler.init(_flagTitle, _flagMsg, _posDiff);
                }
            }

            if(!loginOverride){
                UI.setValue({
                    name: "txt-age",
                    value: props.$txtAge.val(),
                    jsonOnly: true
                });

                UI.setValue({
                    name: "chk-age",
                    value: props.$chkAge.prop('checked'),
                    jsonOnly: true
                });
            }

            UI.setValue({
                name: 'pickup-date',
                value: props.$puDate.val(),
                jsonOnly: true
            });

                            //gbr test
//if( AE.props.siteCode == 'GBR' ) {console.log("GBR")}else{console.log("not GBR")}
            
            // check for FCR one way dropoff date before setting value



            if (AE.props.siteCode == 'FCR') {
                if(props.$fcrOnewayChk.is(':checked')){
                    props.$doDate = props.$doDateOneway;
                }
            }

            UI.setValue({
                name: 'dropoff-date',
                value: props.$doDate.val(),
                jsonOnly: true
            });
            
            /*if (AE.props.siteCode == 'FCR') {
               if(props.$fcrOnewayChk.is(':checked')){
                    UI.setValue({
                        name: 'dropoff-date',
                        value: props.$doDateOneway.val(),
                        jsonOnly: true
                    });
                }
            }*/
           
            UI.setValue({
                name: 'pickup-time',
                value: props.$puTime.val(),
                jsonOnly: true
            });

            UI.setValue({
                name: 'dropoff-time',
                value: props.$doTime.val(),
                jsonOnly: true
            });

            // check for FCR one way and override dropoff time if present
            if (AE.props.siteCode == 'FCR') {
                if(props.$fcrOnewayChk.is(':checked')){
                    UI.setValue({
                        name: 'dropoff-time',
                        value: props.$doTimeOneway.val(),
                        jsonOnly: true
                    });
                }
            }

            var _obj = JSON.stringify(oSubmit);
            var _path = $(props.$form).attr("action");

            AECookie.create('aeSearch', _obj);
            //WEBAE3-5460 save aff and sys at time of search in case of change
            localStorage.setItem('aeSearchAff',oSite.affiliate);
            localStorage.setItem('aeSearchSys',oSite.chaosSystem);
            props.useStoredSearch = (AE.ui.search.useStoredSearch() && localStorage.setItem('aeSearch', _obj) == null) ? true : false;

            if (isBMRSearch && AE.ui.searchType.bmr) {
                AE.ui.searchType.bmr.handleSubmit(oSubmit);
            } else {
                 return AE.ui.search.postToForm(_path, oSubmit, 'post');
            }

         },
        postToForm: function (path, params, method) {
            method = method || "post";
            
            //Sanitize JSON from POST URL
            var _tempForm = document.createElement("form");
            _tempForm.setAttribute("method", method);
            _tempForm.setAttribute("action", path);
            
            //respect window targeting
            var killBtnSpinner = false;
            if (tgt !== undefined && tgt !== 0 && (isBMRSearch || self !== top)) {
                switch (tgt) {
                    case "1":
                        _tempForm.setAttribute("target", '_blank');
                        killBtnSpinner = true; //if targeting a new window, don't leave form in endless waiting
                        break;
                    case "2":
                        _tempForm.setAttribute("target", '_parent');
                        break;
                }
            }

            // Check to see if the search is coming from within an iFrame and cookies have been disabled
            if (window.location !== window.parent.location) {
                // The form submit is coming from inside an iframe
                if (!AECookie.props.cookiesEnabled()) {
                    // Cookies have been turned off, pop out of the iFrame to show results in a new tab
                    _tempForm.setAttribute("target", '_parent');
                    
                    // Since cookies have been disables, set a hidden form field with the session id so that
                    // the search results in a new tab in the AE.com domain can continue
                    // WEBAE3-5723 changed sessid to affiliate because we only get sessid from the cookie 
                    var _tempHiddenField_aff = document.createElement("input");
                    _tempHiddenField_aff.setAttribute("type", "hidden");
                    _tempHiddenField_aff.setAttribute("name", "aff");
                    _tempHiddenField_aff.setAttribute("value", AE.props.affiliate);
                    _tempForm.appendChild(_tempHiddenField_aff);
                    
                    // We now want to just send the customer's search request to the domain associated with the affiliate
                    //_tempForm.setAttribute("action", 'https://'+actualURL+'/'+searchFormAction+'/');//We dont need to do this so it is now commented out, form should know already WEBAE3-6611
                } else if ((navigator.userAgent.search("Safari") >= 0 && navigator.userAgent.search("Chrome") < 0) ||navigator.userAgent.search("Firefox") >= 0) {
                    // 3rd party cookies are no longer allowed by Safari without user interaction with domain
                    // set critical values in DOM but change no other behavior
                    // WEBAE3-5723 added check for Firefox and changed sessid to affiliate because we only get sessid from the cookie 
                    var _tempHiddenField_aff = document.createElement("input");
                    _tempHiddenField_aff.setAttribute("type", "hidden");
                    _tempHiddenField_aff.setAttribute("name", "aff");
                    _tempHiddenField_aff.setAttribute("value", AE.props.affiliate);
                    _tempForm.appendChild(_tempHiddenField_aff);
                }
            }

            for (var key in params) {
                if (params.hasOwnProperty(key)) {
                    var _tempHiddenField = document.createElement("input");
                    _tempHiddenField.setAttribute("type", "hidden");
                    _tempHiddenField.setAttribute("name", key);
                    _tempHiddenField.setAttribute("value", params[key]);
                    _tempForm.appendChild(_tempHiddenField);
                }
            }

            document.body.appendChild(_tempForm);
            _tempForm.submit();
            if (killBtnSpinner) props.$btnSubmit.removeClass('ui--btn-submit-wait').attr({
                'disabled': false
            }).find('.ui--loading-results').remove();
        },
        chkAgeHandler: function (isChecked) {
            /* This is called on the checkbox's change event, and also handles the text input. */
            var _checked = isChecked || false;

        //4646 console.log(_checked)
 

            if (_checked == true) {
                props.$txtAge.val(props.ageDefault.toString()).hide();
                props.$chkAge.prop("checked", true);
                oSubmit.searchAgeCheckbox = true;
                $('.ui-warn-flag').hide();
                
                //fix issue with driver age error still showing when checked 
                // what should happen is the last error message should not show if unchecked and pick-up location is set to default
                props.$txtAge.removeClass('ui--invalid-input');//WEBAE3-4632

                           

            } else {
                props.$txtAge.val("").show();
                props.$chkAge.prop("checked", false);
                oSubmit.searchAgeCheckbox = false;
     
            }
            oSubmit.searchAge = props.$txtAge.val();
            
            return oSubmit;
        },
        setDefaultAgeOverride: function (age) {
            // This is called from outside of this module. It starts with the text input and updates the checkbox
            AEdata.defaultAgeOverride = age;
        },
        setAge: function (age) {
            // This is called from outside of this module. It starts with the text input and updates the checkbox

            // First we update the text input
            props.$txtAge.val(age.toString());
                            // And now we update the JSON object
            oSubmit.searchAge = age.toString();

            if(!AEdata.modify){// Then we update the checkbox and show/hide the text input according to the age
                if(!props.hasAgeChkbx){
                    props.$chkAge.hide()
                    oSubmit.searchAgeCheckbox = false;
                    props.$txtAge.show();
                }
                else if (age < props.ageMin || age > props.ageMax) {
                    props.$chkAge.prop('checked', false);
                    oSubmit.searchAgeCheckbox = false;
                    props.$txtAge.show();
                } else {
                    props.$chkAge.prop('checked', true);
                    oSubmit.searchAgeCheckbox = true;
                    props.$txtAge.hide();
                }
            }
            return oSubmit;
        },
        forceSearchAgeCheckBox: function () {
            //will uncheck search age box even if age is within range so user sees whatever was input - WEBAE3-1686
            props.$chkAge.prop('checked', false); 
            props.$txtAge.show();
            oSubmit.searchAgeCheckbox = false;

            return true;
        },
        useStoredSearch: function () {
            return props.useStoredSearch;
        },

        hasAgeChkbx: function () {
            return props.hasAgeChkbx;
        },
        cleanStoredSearch: function () {
            if (AE.ui.search.useStoredSearch()) {
                return (localStorage.aeSearch = "");
            } else {
                return "";
            }
        },
        searchFormErrorHandler: {
            init: function (title, msg, posDiff, newClass) {
                var _elems = $('[tag*=\'--ae-custom\']');

                props.$searchFormErrorHandler = {
                    msgTitle: title,
                    msgDesc: msg,
                    pos: posDiff || {
                        top: -5,
                        left: 0
                    },
                    newClass: newClass || 'arrow-down'
                };

                if (AE.getSiteViewType() == 'palm') { 
                    props.$puLoc.blur();
                    props.$doLoc.blur();
                }

                props.$btnSubmit.removeClass('ui--btn-submit-wait').attr({
                    'disabled': false
                }).find('.ui--loading-results').remove();

                return UI.searchFormErrorHandler._checkValidity(_elems);
            },
            _checkValidity: function (elems) {
                var _elems = elems;

                for (var i = 0; i < _elems.length; i++) {
                    var _el = _elems[i];
                    var _isInvalid = $(_el).hasClass('ui--invalid-input');

                    if (_isInvalid) {
                        UI.searchFormErrorHandler._toggleFlag(_el);
                    }
                }

                return false;
            },
            _renderFlag: function (el) {

                var _el = el;
                var _flag = $('<div/>', {
                    'class': 'ui-warn-flag ui-invalid-input',
                    role: 'tooltip',
                    tag: 'warn--ae-custom',
                    'for': $(_el).attr('name'),
                    visible: false
                }).uniqueId();
                var $ui_closeBtn = $('<button/>', {
                    'class': 'ui-warn-flag-close-btn',
                    role: 'button'
                });
                var $ui_txtContent = $('<div/>', {
                    'class': 'ui-warn-flag-content',
                    role: 'contentinfo'
                });
                var $ui_warnTitle = $('<h5/>', {
                    'class': 'ui-warn-flag-title',
                    role: 'heading'
                });
                var $ui_warnMsg = $('<span/>', {
                    'class': 'ui-warn-flag-message',
                    role: 'definition'
                });
                var $ui_flagPos = {};

                $ui_warnTitle.text(AE.ui.decodeHtml(props.$searchFormErrorHandler.msgTitle)).attr({
                    alt: props.$searchFormErrorHandler.msgTitle
                });
                $ui_warnMsg.html(props.$searchFormErrorHandler.msgDesc).attr({
                    alt: props.$searchFormErrorHandler.msgDesc
                });

                if( AE.props.siteCode == 'FCR' ) {
                    var invalidName = $(_el).attr('name');
                    $('#' + invalidName + '-error').html(props.$searchFormErrorHandler.msgTitle);
                    $('#' + invalidName + '-error').show();
                    if(invalidName == 'pickup-loc') {
                        $('div[name="pickup-input_text_wrapper"]').addClass('ui--invalid-input');
                    }
                    if(invalidName == 'dropoff-loc') {
                        $('div[name="dropoff-input_text_wrapper"]').addClass('ui--invalid-input');
                    }
                    
                }
                $ui_txtContent.append($('<header/>').append($ui_warnTitle), $('<section/>').append($ui_warnMsg));

                _flag.append($ui_closeBtn, $('<article/>').append($ui_txtContent)).insertBefore(_el);

                props.$searchFormErrorHandler.pos = {
                    top: (_flag.height() < 30) ? parseInt(props.$searchFormErrorHandler.pos.top + 12) : props.$searchFormErrorHandler.pos.top,
                    left: props.$searchFormErrorHandler.pos.left
                };

                $ui_flagPos = {
                    top: (props.$searchFormErrorHandler.pos.top - _flag.outerHeight()) + 'px',
                    left: props.$searchFormErrorHandler.pos.left + 'px',
                    display: 'none'

                };

//console.log( $ui_flagPos );
                if (props.$searchFormErrorHandler.newClass != false) {
                    _flag.addClass(props.$searchFormErrorHandler.newClass);
                }
//console.log( _flag );


                _flag.css($ui_flagPos);
//console.log(_flag.outerHeight())

//console.log(AE.props.siteCode);//this is what I can use to detect the site and make adjustments

// $('label[for="chk-age"]').hide();



                $ui_closeBtn.on('click', function (event) {
                    event.preventDefault();
                    return UI.searchFormErrorHandler._toggleFlag(_el);
                });

                $('.ui-selectmenu-text,.ui-datepicker-trigger').click(function() { 
                    clearFlag()
                });

                /* Text Search */
                if ($(_el).is('.ui-textsearch-input') && $(_el).data('direction') == 'do') {
                    document.querySelector("[tag*='--ae-custom']").addEventListener("focus", clearFlag);
                }
                if ($(_el).is('.ui-textsearch-input') && $(_el).data('direction') == 'pu') {
                    document.querySelector('.ui-textsearch-input[data-direction=pu]').addEventListener('focus', clearFlag);
                }

                /* Menu Search */
                if ($(_el).is('.trg__menusearch--country') && $(_el).data('direction') == 'pu') {
                    document.querySelector('.trg__menusearch--country[data-direction=pu]').addEventListener('focus', clearFlag);
                } else if ($(_el).is('.trg__menusearch--city') && $(_el).data('direction') == 'pu') {
                    document.querySelector('.trg__menusearch--city[data-direction=pu]').addEventListener('focus', clearFlag);
                } else if ($(_el).is('.trg__menusearch--loc') && $(_el).data('direction') == 'pu') {
                    document.querySelector('.trg__menusearch--loc[data-direction=pu]').addEventListener('focus', clearFlag);
                } else if ($(_el).is('.trg__menusearch--country') && $(_el).data('direction') == 'do') {
                    document.querySelector('.trg__menusearch--country[data-direction=pu]').addEventListener('focus', clearFlag);
                } else if ($(_el).is('.trg__menusearch--city') && $(_el).data('direction') == 'do') {
                    document.querySelector('.trg__menusearch--city[data-direction=pu]').addEventListener('focus', clearFlag);
                } else if ($(_el).is('.trg__menusearch--loc') && $(_el).data('direction') == 'do') {
                    document.querySelector('.trg__menusearch--loc[data-direction=pu]').addEventListener('focus', clearFlag);
                } else if ($(_el).is('.trg__bmrsearch--country') && $(_el).data('direction') == 'pu') {
                    document.querySelector('.trg__bmrsearch--country[data-direction=pu]').addEventListener('focus', clearFlag);
                } else if ($(_el).is('.trg__bmrsearch--city') && $(_el).data('direction') == 'pu') {
                    document.querySelector('.trg__bmrsearch--city[data-direction=pu]').addEventListener('focus', clearFlag);
                }
                
                if ($(_el).is('input[name=txt-age]')) {
                    document.querySelector('input[name=txt-age]').addEventListener('focus', clearFlag);
                }

                //WEBAE3-4473 close date warning on any date interaction
                if ($(_el).is('select[id=dropoff-time]')) {
                    document.querySelector('span[id=dropoff-time-button]').addEventListener('focus', clearFlag);
                    /* dropoff-date clearFlag doesn't work but pickup-date and pickup-time-button do, not sure why
                    document.querySelector('input[id=dropoff-date]').addEventListener('focus', clearFlag);
                    document.querySelector('input[name=pickup-date]').addEventListener('focus', clearFlag);
                    document.querySelector('span[id=pickup-time-button]').addEventListener('focus', clearFlag);
                    */
                }
                
                function clearFlag() {
                    
                    document.querySelector("[tag='input--ae-custom']").removeEventListener("focus", clearFlag);
                    return UI.searchFormErrorHandler._hideErrorFlag(_el);
                }

                return UI.searchFormErrorHandler._toggleFlag(_el);
            },
            _toggleFlag: function (el) { 
                var _el = el;
                var _hasFlag = (typeof $(_el).parent().has('[tag=\'warn--ae-custom\']')[0] != 'undefined');
                var $_flag = _hasFlag ? $(_el).prev('[tag=\'warn--ae-custom\']') : void(0);

                if (!_hasFlag) {
                    return UI.searchFormErrorHandler._renderFlag(_el);
                } else {
                    if ($_flag.is(':visible')) { return UI.searchFormErrorHandler._hideErrorFlag(_el); }
                    if (!$_flag.is(':visible')) { return UI.searchFormErrorHandler._showErrorFlag(_el); }
                }

                return false;
            },
            _showErrorFlag: function (el) {
                var _el = el;
                var _hasFlag = (typeof $(_el).parent().has('[tag=\'warn--ae-custom\']')[0] != 'undefined');
                var $_flag = _hasFlag ? $(_el).prev('[tag=\'warn--ae-custom\']') : void(0);
                var $_button = $(_el).parent().find('button');

                return $_flag.stop().fadeIn('slow', function () {
                    $_flag.attr({
                        'visible': true
                    });
                    $_button.addClass('ui-warn-flag-animated-el ui-warn--in');
                });
            },
            _hideErrorFlag: function (el) {
                var _el = el;
                var _hasFlag = (typeof $(_el).parent().has('[tag=\'warn--ae-custom\']')[0] != 'undefined');
                var $_flag = _hasFlag ? $(_el).prev('[tag=\'warn--ae-custom\']') : void(0);
                var $_button = $(_el).parent().find('button');

                if( AE.props.siteCode == 'FCR' ) {
                    var invalidName = $(_el).attr('name');
                    $('#' + invalidName + '-error').hide();
                    if(invalidName == 'pickup-loc') {
                        $('div[name="pickup-input_text_wrapper"]').removeClass('ui--invalid-input');
                    }
                    if(invalidName == 'dropoff-loc') {
                        $('div[name="dropoff-input_text_wrapper"]').removeClass('ui--invalid-input');
                    }
                }




                $_button.addClass('ui-warn--out').removeClass('ui-warn--in');

                return _hasFlag ? $_flag.stop().animate({
                    top: parseInt(props.$searchFormErrorHandler.pos.top - 10) + 'px',
                    opacity: 0
                }, 'slow', function () {
                    $_flag.attr({
                        'visible': false
                    });
                    UI.searchFormErrorHandler._destroy(_el);
                }) : false;
            },
            _destroy: function (el) {
                var _el = el;
                var _hasFlag = (typeof $(_el).parent().has('[tag=\'warn--ae-custom\']')[0] != 'undefined');
                var $_flag = _hasFlag ? $(_el).prev('[tag=\'warn--ae-custom\']') : void(0);
                $(_el).removeClass('ui--invalid-input');

                return _hasFlag ? setTimeout(function () {
                    $_flag.remove();
                }, 500) : false;
            }
        },
        readCookie:function(name) {
            var nameEQ = name.toLowerCase() + "=";
            var ca = document.cookie.split(';');
            for (var i = 0; i < ca.length; i++) {
                var c = ca[i].toLowerCase();
                while (c.charAt(0) == ' ') c = c.substring(1, c.length);
                if (c.indexOf(nameEQ) == 0) return c.substring(nameEQ.length, c.length);
            }
            return null;
        },
        fcrOneWayToggle: function(event) {
            //for some reason, a successful search populates 'oOW', but a failed search populates 'OOW'. So check for both. - Mike
            try {
                if(AEdata.booking && (typeof(AEdata.booking.quote.oQuote.oOW) !== 'undefined') || typeof(AEdata.booking.quote.oQuote.OOW) !== 'undefined') {
                    if( (typeof(AEdata.booking.quote.oQuote.oOW) !== 'undefined' && AEdata.booking.quote.oQuote.oOW.locList) || (typeof(AEdata.booking.quote.oQuote.OOW) !== 'undefined' && AEdata.booking.quote.oQuote.OOW.locList) ) {
                        $("input[name='fcr-oneway_chk']").prop( "checked", true );
                        UI.fcrToggleOnewayOpen();

                    }
                }
            } catch (e) {}
        },
        autocomplete: {
            getInputs: function () {
                return {
                    $puLoc: props.$puLoc,
                    $doLoc: props.$doLoc,
                    $puDate: props.$puDate,
                    $doDate: props.$doDate,
                    $hiddenPuDate: props.$hiddenPuDate,
                    $hiddenDoDate: props.$hiddenDoDate,
                    $puTime: props.$puTime,
                    $doTime: props.$doTime,
                    $hiddenPuTime: props.$hiddenPuTime,
                    $hiddenDoTime: props.$hiddenDoTime,
                    $chkDiff: props.$chkDiff,
                    $btnSubmit: props.$btnSubmit
                };
            },
            setFromQuote: function (options) {
                options = options || {};
                if(AEdata && AEdata.booking && AEdata.booking.quote && AEdata.booking.quote.oQuote){
                    oSubmit.searchAge = AEdata.booking.quote.oQuote.age;
                    if(AEdata.booking.quote.oQuote.oPU){
                        oSubmit.display_label = AEdata.booking.quote.oQuote.oPU.name;
                        oSubmit.city = AEdata.booking.quote.oQuote.oPU.city;
                        oSubmit.puloclist = AEdata.booking.quote.oQuote.oPU.locList;
                        oSubmit.pucode = AEdata.booking.quote.oQuote.oPU.country;
                        oSubmit.puloctype = AEdata.booking.quote.oQuote.oPU.deskType;
                    }
                    if(AEdata.booking.quote.oQuote.oOW){
                        if(AEdata.booking.quote.oQuote.oOW.locList || AEdata.booking.quote.oQuote.oOW.city || AEdata.booking.quote.oQuote.oOW.country){
                            if(AEdata.booking.quote.oQuote.oDO){
                                oSubmit.display_labelr = AEdata.booking.quote.oQuote.oDO.name;
                                oSubmit.cityr = AEdata.booking.quote.oQuote.oDO.city;
                                oSubmit.doloclist = AEdata.booking.quote.oQuote.oDO.locList;
                                oSubmit.docode = AEdata.booking.quote.oQuote.oDO.country;
                                oSubmit.doloctype = AEdata.booking.quote.oQuote.oDO.deskType;
                            }
                        }
                    }
                    if(!_.isEmpty(options)){
                        _.extend(oSubmit,options);
                    }
                }
            },
            setValue: function (options) {
                /*
                    Called from the Autocomplete module when an autocomplete text input value is selected.
                    The parent-level setValue() function is used for all other fields.

                    Autocomplete inputs manage themselves, so we just
                    need for the JSON to keep up. An object is passed in with the required properties for
                    the server-side code. The object must also have a "name" property which contains the
                    HTML name attribute as a string.

                    Property names passed are defined in AE.ui.autocomplete, so this function will need to
                    be kept in sync with that module.

                    If the dropoff property is null, then this is a pickup. We need to clear out the
                    dropoff properties. If there is data, then we just need to add the dropoff properties.
                    By the time a dropoff value is set, the pickup will already be set.
                */
                if (options.pu == null) {
                    oSubmit.display_label = null;
                    oSubmit.city = null;
                    oSubmit.puloclist = null;
                    oSubmit.pucode = null;
                    oSubmit.puloctype = null;
                    oSubmit.puchaos_hub_id = null;
                    return;
                }

                if (!options.drop) {
                    oSubmit.pu = options.pu;
                    oSubmit.display_label = options.pu.display_label;
                    oSubmit.city = options.pu.chaos_city_name;
                    oSubmit.puloclist = options.pu.desk_list;
                    oSubmit.pucode = options.pu.chaos_country_code;
                    oSubmit.puloctype = options.pu.loc_type;
                    oSubmit.puchaos_hub_id = options.pu.chaos_hub_id;

                    // If this is a pickup, clear out the dropoff data
                    if (!options.preserveDO) {
                        oSubmit.drop = false;
                        oSubmit.display_labelr = null;
                        oSubmit.cityr = null;
                        oSubmit.doloclist = null;
                        oSubmit.docode = null;
                        oSubmit.doloctype = null;
                        oSubmit.dochaos_hub_id = null;
                    }
                } else {
                    oSubmit.drop = options.drop;
                    oSubmit.display_labelr = options.drop.display_label;
                    oSubmit.cityr = options.drop.chaos_city_name;
                    oSubmit.doloclist = options.drop.desk_list;
                    oSubmit.docode = options.drop.chaos_country_code;
                    oSubmit.doloctype = options.drop.loc_type;
                    oSubmit.dochaos_hub_id = options.drop.chaos_hub_id;
                }

                oSubmit.tgt = $('[name=tgt]').val();
            }
        }, // END OF autocomplete

        allStorage: function (options) {  

         var archive = [],
            keys = Object.keys(localStorage),
            i = 0, key;

        for (; key = keys[i]; i++) {
            archive.push( key + '=' + localStorage.getItem(key));
        }

        return archive;

            return archive;
        }
    };


    return UI;
})();
;var AE = AE || {}; /* Add to Base object or create it if it doesn't exist. */


/*
The AE.ui object will be the returned result of a self-invoked function. This allows us to expose methods
for use by other modules while protecting some variables in a closure. If the AE.ui object is already
defined then it's not altered. This prevents us from running the entire function each time one of its
internal methods are called.
*/
AE.ui.selectmenu = AE.ui.selectmenu || (function(){

	'use strict';
	/*
	DEPENDENCIES: AE, AE.ui
	*/

	var UI = {
		init:function()  {

			/* Establish the props object only upon init. No need to do the work if the module isn't being called. */
			UI.props = {};

			AE.ui.selectmenu.statesHandled = 0;//flag for statesHandled = 0: not done; 1: done; 2: attempted but failed
			/*	DROP DOWN DATASETS - Arrays to support drop downs whose options need to change based on selections in another dropdown	*/
			// Country/State Dropdowns
			if($('select.state--select')[0] && AEdata.arrstates){
				UI.buildStateArray();
				if ( $('form .state-container')[0] && Array.isArray(UI.props.arrStates) && UI.props.arrStates.length ){
					UI.handleStateMenus($('form'),'div.state-container',true);
				}
				//if initial state menu build fails, try once more
				if(AE.ui.selectmenu.statesHandled !== 1){
					//check for array build fail before trying again
					if(!Array.isArray(UI.props.arrStates) || !UI.props.arrStates.length) {
						UI.buildStateArray();
					}
					if ( $('form .state-container')[0] && UI.props.arrStates.length){
						UI.handleStateMenus($('form'),'div.state-container',true);
					}
				}
			}
		// Motorhome Country/City Dropdowns
			if($('select.motorhome__select--city')[0] && $('select.motorhome__select--city').first().data('arrmhcities')){
				var rawMHCities = $('select.motorhome__select--city').first().data('arrmhcities');
				UI.props.arrMHCities = (rawMHCities.length)? JSON.parse(decodeURIComponent(rawMHCities)) : [];
				if ( UI.props.arrMHCities.length){
					UI.handleMotorHomeCityMenus($('form'),true);
				}
			}
		// Chauffeur Country/City Dropdowns
			if($('select.chauffeur__select--city')[0] && $('select.chauffeur__select--city').first().data('arrcfcities')){
				var rawCFCities = $('select.chauffeur__select--city').first().data('arrcfcities');
				UI.props.arrCFCities = (rawCFCities.length)? JSON.parse(decodeURIComponent(rawCFCities)) : [];
				if ( UI.props.arrCFCities.length){
					UI.handleChauffeurCityMenus($('form'),false,true);// Pick Up Country/City
					UI.handleChauffeurCityMenus($('form'),true,true);// Drop Off Country/City
				}
			}
			AE.ui.addBodyChangeTask({func: UI.onBodyChange});
		},
		buildDynamicOptions:function(arrSrc){
			arrSrc = arrSrc || [];
			var $df = $( document.createDocumentFragment() );
			for(var i=0; i<arrSrc.length;i++){
				var item = arrSrc[i];
				if(item.value === '-'){
					$df.append($(document.createElement('optgroup')).addClass(item.value).attr('label',item.label));
				} else {
					$df.append($(document.createElement('option')).attr('value',item.value).append(item.label));
				}
			}
			return $df;
		},
		buildStateArray:function(){
			//WEBAE3-4036 moved to func so both init and onbodychange can build arrStates, useful in case of init error/race condition building array on init
			if($('select.state--select')[0] && AEdata.arrstates){
				/*
				var rawStates = $('select.state--select').first().data('arrstates');
				UI.props.arrStates = (rawStates.length)? JSON.parse(decodeURIComponent(rawStates)) : [];
				*/
				UI.props.arrStates = (AEdata.arrstates.length)? JSON.parse(AEdata.arrstates) : [];
			}
		},
		handleStateMenus:function($parentForm,stateContainerSelector,preselect){
			$parentForm = $parentForm || $('form');
			stateContainerSelector = stateContainerSelector || 'div.state-container';
			preselect = preselect || false;
			if($parentForm.hasClass('mura-form')) stateContainerSelector = 'div.mura-control-group';
			var $countryDD = $parentForm.find('select.country--select');
			var $stateDD = $parentForm.find('select.state--select');
			var $stateDDContainer = $parentForm.find(stateContainerSelector);
			var $label = $stateDDContainer.find('label');
			//WEBAE3-4036 adding catch so a failure doesn't break validation JS
			try{
				// prevent error if attributes have not been added to state/province label
				if($label.attr('state') !== undefined && $label.attr('province') !== undefined) {
					var $stateLabel = $label.attr('state');
					var $provinceLabel = $label.attr('province');
					// Switch Label for State/Province select
					switch($countryDD.val()){
						case 'CA':
						case 'ZA':
							$label.text($provinceLabel);
							break;
						case 'AU':
						case 'BR':
						case 'US':
							$label.text($stateLabel);
							break;
					}
				}

				var arrTheseStates = _.filter(UI.props.arrStates,function(state){
					return ( state.group === $countryDD.val() );
				});

				$stateDD.empty().addClass('state_dd_hide');
				$stateDD.parent().removeClass('ui-state-invalid ui-state-valid');
				if(arrTheseStates.length){
					$stateDD.append(UI.buildDynamicOptions(arrTheseStates)).removeClass('state_dd_hide');
					if(preselect) $stateDD.find('option[value="'+$stateDD.data('startval')+'"]').prop('selected',true);
					$stateDDContainer.removeClass('state_dd_hide');
				} else {
					$stateDDContainer.addClass('state_dd_hide');
					if(AE.props.funnelPage === '/affaccmgt'){
						$stateDD.append($('<option/>')).change();
					}
				}
				AE.ui.selectmenu.statesHandled = 1;//set to 1 on completion
			} catch (err) {
				AE.ui.selectmenu.statesHandled = 2;//set to 2 on failure
				//console.log(err)
			}			
		},
		handleMotorHomeCityMenus:function($parentForm,preselect){
			$parentForm = $parentForm || $('form');
			preselect = preselect || false;
			var $countryDD = $parentForm.find('select.motorhome__select--country');
			var $cityDD = $parentForm.find('select.motorhome__select--city');
			var $vehTypeBoxes = $parentForm.find('.vehType');
			var arrTheseCities = _.filter(UI.props.arrMHCities,function(city){
				return ( city.group === $countryDD.val() );
			});
			$cityDD.empty();
			$cityDD.parent().removeClass('ui-state-invalid ui-state-valid');
			if(arrTheseCities.length){
				$cityDD.append(UI.buildDynamicOptions(arrTheseCities));
				if(preselect) $cityDD.find('option[value="'+$cityDD.data('startval')+'"]').prop('selected',true);
			}
			$vehTypeBoxes.addClass('trulyhidden');
			$($vehTypeBoxes.filter('.'+$countryDD.val())).removeClass('trulyhidden');
		},
		handleChauffeurCityMenus:function($parentForm,dropoff,preselect){
			$parentForm = $parentForm || $('form');
			dropoff = dropoff || false;
			preselect = preselect || false;
			var selector = (dropoff)? 'select.chauffeur__select--do' : 'select.chauffeur__select--pu';
			var $countryDD = $parentForm.find(selector+'.chauffeur__select--country');
			var $cityDD = $parentForm.find(selector+'.chauffeur__select--city');
			var arrTheseCities = _.filter(UI.props.arrCFCities,function(city){
				return ( city.group === $countryDD.val() );
			});
			$cityDD.empty();
			$cityDD.parent().removeClass('ui-state-invalid ui-state-valid');
			if(arrTheseCities.length){
				$cityDD.append(UI.buildDynamicOptions(arrTheseCities));
				if(preselect) $cityDD.find('option[value="'+$cityDD.data('startval')+'"]').prop('selected',true);
			}
		},
		handleExpiryMenus:function($yearSelect){
			$yearSelect = $yearSelect || $('form select.expyear--select');
			var rightNow = new Date();
			var thisMonth = rightNow.getMonth()+1;// JS Months are 0 Indexed
			var thisYear = rightNow.getFullYear().toString().substring(2);
			if($yearSelect[0]){
				var $monthSelect = $($yearSelect.data('expmonth'));
				if($monthSelect[0]){
					var $monthOptions = $monthSelect.children('option').prop('disabled',false);
					if($yearSelect.val() === thisYear){
						var aPastOptions = _.filter($monthOptions,function(opt){return Number(opt.value) < thisMonth});
						$(aPastOptions).prop('disabled',true).prop('selected',false);
						//console.log(_.filter($monthOptions,function(opt){return Number(opt.value) < thisMonth}));
					}
				}
			}
		},
		/* 
		WEBAE3-3806 
		- IATA input now always shows as optional, regardless of site
		  or of source country.
		- left this in comments in case we need to bring this back
		handleIataInput:function($parentForm,tpiataContainerSelector){
			//this handles IATA input on Travel Partner sign up form when country select 
			$parentForm = $parentForm || $('form');
			tpiataContainerSelector = tpiataContainerSelector || 'div.tpiata';
			var $countryDD = $parentForm.find('select.country--select');
			var $tpiataContainer = $parentForm.find(tpiataContainerSelector);
			var $tpiataInput = $parentForm.find('input#tpiata');
			var $tpiataDiv = $parentForm.find('div.tpiatawrap');
			// show iata field for relevant countries
			var iataShow = false;
			var iataRequired = false;
			switch($countryDD.val()){
				case 'CA':
				case 'US':
					iataShow = true;
					iataRequired = true;
					break;
				case 'ZA':
					iataShow = true;
					iataRequired = false;
					break;
			}
			if(iataShow){
				$tpiataContainer.removeClass('state_dd_hide');
				$tpiataDiv.removeClass('ui-state-invalid ui-state-valid');
				if(iataRequired) {
					$tpiataInput.prop("required", "required");
					$tpiataDiv.addClass('required');
				} else {
					$tpiataInput.prop("required", "");
					$tpiataDiv.removeClass('required');
				}
			} else {
				$tpiataContainer.addClass('state_dd_hide');
				$tpiataInput.prop("required", "");
				$tpiataDiv.removeClass('ui-state-invalid ui-state-valid');
				$tpiataDiv.addClass('required');
				$tpiataInput.val('');
			}
		},
		END COMMENT for WEBAE3-3806 */
		onBodyChange:function(event,$target){

			if(event.target.tagName.toUpperCase() === 'SELECT'){
				if($target.hasClass('expyear--select')) UI.handleExpiryMenus($target);
				if($target.hasClass('country--select'))	{
					//WEBAE3-4036 in case init failed, make sure we have a states array before trying to build menu
					if(!Array.isArray(UI.props.arrStates) || !UI.props.arrStates.length){
						UI.buildStateArray();
					}
					UI.handleStateMenus($target.closest('form'));

					//WEBAE3-4840 hide uplift promo divs if country is not US or CA
					var aUpliftPromoDivs = document.getElementsByClassName('aeUplift-modal-container');
					if(aUpliftPromoDivs.length){
						var upDivDisp = 'inline-block';
						switch($target.val()){
							case 'CA':
							case 'US':
								upDivDisp = 'inline-block';
								break;
							default:
								upDivDisp = 'none';
						}
						for (const upDiv of aUpliftPromoDivs) {
							upDiv.style.display = upDivDisp;
						}
					}				
				}
				// WEBAE3-3806 IATA input always optional for TP signup
				// if($target.hasClass('country--select'))	UI.handleIataInput($target.closest('form'));//added for WEBAE3-3162
				if($target.hasClass('motorhome__select--country')) UI.handleMotorHomeCityMenus($target.closest('form'));
				if($target.hasClass('chauffeur__select--country')){
					if($target.hasClass('chauffeur__select--pu')){
						UI.handleChauffeurCityMenus($target.closest('form'),false,false);
					} else if($target.hasClass('chauffeur__select--do')){
						UI.handleChauffeurCityMenus($target.closest('form'),true,false);
					}
				}
			}
		}
	};
	return UI;
})();

;
var AE = AE || {}; /* Add to Base object or create it if it doesn't exist. */


/*
The AE.ui object will be the returned result of a self-invoked function. This allows us to expose methods
for use by other modules while protecting some variables in a closure. If the AE.ui object is already
defined then it's not altered. This prevents us from running the entire function each time one of its
internal methods are called.
*/
AE.ui.timeselectmenu = AE.ui.timeselectmenu || (function () {

	'use strict';
	/*
	DEPENDENCIES: AE, AE.ui
	*/
	var searchPuTime,
		searchDoTime,
		vouchDateTime = ((typeof (oBKdateTime) != 'undefined') && !_.isEmpty(oBKdateTime)) ? oBKdateTime : false;

	var UI = {
		init: function () {
			// Setup the timeselects
			var GET_INPUTS = AE.ui.search.autocomplete.getInputs();
			/* Establish the props object only upon init. No need to do the work if the module isn't being called. */
			UI.props = {
				$puTime: GET_INPUTS.$puTime,
				$doTime: GET_INPUTS.$doTime,
				$hiddenPuTime: GET_INPUTS.$hiddenPuTime,
				$hiddenDoTime: GET_INPUTS.$hiddenDoTime,
				modElement: $('html, body'),
				modClass: 'ui-timeselect-open'
			};

			UI.mainSearch();
		},
		mainSearch: function () {

			var _tempPuT;
			var _tempDoT;
			var _deeplinkPuT;
			var _deeplinkDoT;

			searchPuTime = UI.props.$hiddenPuTime.val();
			searchDoTime = UI.props.$hiddenDoTime.val();

			/*
			 * Getting the times from stored search if available.
			 * used below in 'timeselectmenucreate'
			 */
			_tempPuT = !vouchDateTime ? searchPuTime : vouchDateTime.bkputime;
			_tempDoT = !vouchDateTime ? searchDoTime : vouchDateTime.bkdotime;

			_deeplinkPuT = UI.props.$hiddenPuTime.attr('data-deeplinkval');
			_deeplinkDoT = UI.props.$hiddenDoTime.attr('data-deeplinkval');


			if (typeof _deeplinkPuT !== typeof undefined && _deeplinkPuT !== false) {
			  _tempPuT = _deeplinkPuT;
			}

			if (typeof _deeplinkDoT !== typeof undefined && _deeplinkDoT !== false) {
			  _tempDoT = _deeplinkDoT;
			}
			// WEBAE3-3327 - Recover Search Times after BK data wiped
			if(_tempPuT === '') _tempPuT = searchPuTime;
			if(_tempDoT === '') _tempDoT = searchDoTime;

			$.widget('custom.timeselectmenu', $.ui.selectmenu, {
				_create: function (event, ui) {
					this._super(event, ui);
					this.element.menu().data('menu', this.menu);
				},
				_renderMenu: function (ul, items) {
					var $widget = this;
					var $menu = ul;
					$.each(items, function (index, item) {
						item.ind = index;
						$widget._renderItemData($menu, item);
					});
					$menu.find("li:odd").addClass("odd");
				},
				_renderItem: function (ul, item) {

					var $widget = this;
					var $select = $widget.element;
					var time = item.label;
					var ind = item.ind;
					var hours = Number(time.match(/^(\d+)/)[1]);
					var minutes = Number(time.match(/:(\d+)/)[1]);
					var AM_PM = time.slice(-2);

					if (AM_PM == "PM" && hours < 12) hours = hours + 12;
					if (AM_PM == "AM" && hours == 12) hours = hours - 12;
					var sHours = hours.toString();
					var sMinutes = minutes.toString();
					if (hours < 10) sHours = "0" + sHours;
					if (minutes < 10) sMinutes = "0" + sMinutes;

					var _updatedTime = sHours + ":" + sMinutes;

					var li = $('<li/>', {
						'data-position': ind,
						class: 'ui-timeselect-rev-opt'
					});

					var innerDiv = $('<div/>', {
						'tabindex': -1,
						role: 'option',
						class: 'ui-menu-item-wrapper ui-timeselect-rev-opt-inner'
					}).text(item.label);

					if (item.disabled) li.addClass('ui-state-disabled');

					if ($select.val() === _updatedTime) li.addClass('ui-time-active');
					li.append(innerDiv);
					return li.appendTo(ul);
				}
				// TODO : remove eventlistener from "open" and access here…
				// ,
				// _customTouchMove: function(event) {
				// 	console.log("doing custom touchmove")
				// 					var $target = $(event.target);
				// 					if ($target.is('[class*=ui-timeselect-rev]')) {
				// 						event.stopPropagation();
				// 					} else {

				// 						$('.' + UI.props.modClass).each(function (ind, item) {
				// 							return item.removeEventListener('touchmove', UI._customTouchMove, {
				// 								passive: true
				// 							});
				// 						});

				// 						$(this).timeselectmenu('close');
				// 					}
				// 				}
			});

			// if(UI.props.$puTime != ''){

			UI.props.$puTime.add(UI.props.$doTime).on('timeselectmenucreate', function (event, ui) {

				var $widget = $(this).timeselectmenu().timeselectmenu('instance');
				var $select = $widget.element;
				var $menu = $widget.menu;
				var $button = $widget.button;
				var $wrap = $widget.menuWrap;
				var _direction = $select.data('direction');
				var _updatedVal = (_direction == 'pu') ? _tempPuT : _tempDoT;

				$select.attr({
					'aria-owns': $widget.menu.attr('id'),
					'aria-labelledby': $widget.button.attr('id') + '-label',
					'aria-autocomplete': 'list',
					'aria-readonly': true,
					role: 'combobox'
				});

				$menu.attr({
					role: 'listbox',
					'tabindex': -1
				}).addClass('ui-timeselect-rev-menu');

				$button.attr({
					'aria-controls': $menu.attr('id'),
					'aria-labelledby': $widget.button.attr('id') + '-label'
				}).addClass('ui-timeselect-trigger ui-timeselect-rev-button');

				$wrap.addClass('ui-timeselect-menu');
				/* *
				* '.ui-ready-waiting' class is used to block text switch on setting value
				* */
				$select.parent('.styled--select').removeClass('ui-ready-waiting');
				/* *
				 * Use the value as defined in UI.mainSearch()
				 * */
				$select.val(_updatedVal).timeselectmenu('refresh');
			});

			UI.props.$puTime.add(UI.props.$doTime).on('timeselectmenuopen', function (event, ui) {
				var $widget = $(this).timeselectmenu().timeselectmenu('instance');
				var $select = $widget.element;
				var $menu = $widget.menu;

				var _selInd = $select.find('option:selected')[0].index + 1;
				var scrollTo = $menu.find('li:nth-child(' + _selInd + ')');

				UI.props.modElement.addClass(UI.props.modClass);

				function tsTouchM(event) {
					var $target = $(event.target);
					if ($target.is('[class*=ui-timeselect-rev]')) {
						event.stopPropagation();
					} else {

						$('.' + UI.props.modClass).each(function (ind, item) {
							return item.removeEventListener('touchmove', tsTouchM, {
								passive: true
							});
						});

						$select.timeselectmenu('close');
					}
				}

				// $( '.' + UI.props.modClass ).each(function(ind, item){
				// 		return item.addEventListener('touchmove', UI._customTouchMove, {
				// 			passive: true,
				// 			capture: true
				// 		});
				// 	});

				$('.' + UI.props.modClass).each(function (ind, item) {
					return item.addEventListener('touchmove', tsTouchM, {
						passive: true,
						capture: true
					});
				});

				// FCR had disabled this for some reason. Putting back so as not to lose it on AE. We can add a condition later if we need to disable this on FCR.
				return $menu.animate({
					scrollTop: scrollTo.offset().top - $menu.offset().top + $menu.scrollTop()
				});

			});

			UI.props.$puTime.add(UI.props.$doTime).on('timeselectmenuclose', function (event, ui) {
				UI.props.modElement.removeClass(UI.props.modClass);
			});

			UI.props.$puTime.add(UI.props.$doTime).on('timeselectmenuselect', function (event, ui) {
				var $widget = $(this).timeselectmenu().timeselectmenu('instance');
				var $select = $widget.element;
				var $menu = $widget.menu;
				var $item = ui.item;
				var $selectPos = $item.index;
				var $selectVal = $item.value;
				var $menuItems = $menu.find('li');

				for (var i = 0; i < $menuItems.length; i++) {
					var $mI = $($menuItems[i]);
					if ($mI.hasClass('ui-time-active')) $mI.removeClass('ui-time-active');
					if ($mI.attr('data-position') == $selectPos) $mI.addClass('ui-time-active');
				}

				$select.val($selectVal);
			});

			$.each(UI.props.$puTime.add(UI.props.$doTime), function (ind, obj) {
				var $select = $(obj);
				$select.timeselectmenu({
					appendTo: AE.ui.props.appendTarget,
					position: {
						my: "left top",
						at: "left bottom+3",
						collision: "none"
					},
					icons: {
						button: "ui-timeselect-icon far fa-clock"
					}
				}).timeselectmenu("menuWidget").addClass("overflow");
			});
		}


		// }
	};
	return UI;
})();
;
var AE = AE || {}; /* Add to Base object or create it if it doesn't exist. */
/*
The AE.ui object will be the returned result of a self-invoked function. This allows us to expose methods
for use by other modules while protecting some variables in a closure. If the AE.ui object is already
defined then it's not altered. This prevents us from running the entire function each time one of its
internal methods are called.
*/
AE.ui.datepicker = AE.ui.datepicker || (function() {
	'use strict';
	/*
	DEPENDENCIES: AE, AE.ui
	*/

	var searchPuDate,
		searchDoDate,
		vouchDateTime = ((typeof(oBKdateTime) !== 'undefined') && !_.isEmpty(oBKdateTime)) ? oBKdateTime : false;

	var UI = {
		init: function() {
			// Setup the datepickers
			var GET_INPUTS = AE.ui.search.autocomplete.getInputs();

			UI.props = {
				$puDate: GET_INPUTS.$puDate,
				$doDate: GET_INPUTS.$doDate,
				$hiddenPuDate: GET_INPUTS.$hiddenPuDate,
				$hiddenDoDate: GET_INPUTS.$hiddenDoDate,
				$puTime: GET_INPUTS.$puTime,
				$doTime: GET_INPUTS.$doTime,
				$hiddenPuTime: GET_INPUTS.$hiddenPuTime,
				$hiddenDoTime: GET_INPUTS.$hiddenDoTime,
				strDateFormat: $.datepicker._defaults.dateFormat, // The format of the date that the user sees
				altFormat: "yy-mm-dd", // The date format that gets passed along when the search form is submitted
				currentWindowSize: AE.getSiteViewType(),
				responsiveNumMonthsToShow: {
					"palm": 1,
					"lap": 2,
					"desk": 2,
					"desk-wide": 2
				},
				datepickerOptions: {},
				isLeaseSearch: (AE.ui.searchType.leasesearch && $(AE.ui.props.$aeSearch[0])
					.find('#locations-wrapper')
					.hasClass('ae__lease_search')),
				isBMRSearch: (isBMRSearch && AE.ui.searchType.bmr)? true : false,
				oSubmit: AE.ui.search.getSubmitValues()
			};

//if (UI.props.isLeaseSearch && AE.props.isAUNZ) {
//	AE.props.buyBackMin = AE.props.buyBackMin + 'T16:00:00.000Z';
//}

			UI.props.numberOfCalendarMonthsToShow = UI.checkCurrentWindowSize(AE.ui.search.$viewSize);

			// Set initial values
			UI.props.datepickerOptions = {
				_isOpen: false,
				firstDay: $.datepicker._defaults.firstDat,
				changeMonth: (UI.props.currentWindowSize === 'palm') ? true : false,
				changeYear: (UI.props.currentWindowSize === 'palm') ? true : false,
				showAnim: "fadeIn",
				showOn: 'button',
				buttonImage: '/plugins/ae3/themes/AE1/images/empty-pixel-datepicker-btn.png',
				buttonImageOnly: false,
				buttonText: '',
				// https://objectpartners.com/2012/06/18/jquery-ui-datepicker-ie-focus-fix/
				fixFocusIE: false,
				// The format of the date that the user sees
				dateFormat: UI.props.strDateFormat,
				onSelect: function(dateText, inst) {
					var _tempPuD;
					var _tempDoD;
					
					// Fixes Datepicker from automatically re-opening after selection is made
					this.fixFocusIE = true;
					$(this).change().focus();
					
					// The datepicker is updating its own input in this case, so we just need to update the JSON object to match
					if (UI.isPickupField('#' + inst.id)) {
						UI.props.oSubmit.puCal = UI.convertDate(UI.props.$puDate);
						_tempPuD = UI.props.oSubmit.puCal + 'T' + UI.props.$puTime.val();
						if (UI.props.isBMRSearch) {
							_tempPuD = UI.props.oSubmit.puCal + 'T05:00:00.000Z';
						}
						searchPuDate = new Date(_tempPuD);
						
						// Because this is a pickup field, we must set a new minimum date and value for the dropoff
						UI.setMinDropoffDate();
						
						if (!UI.isAfterPickup()) {
							UI.setDropoffForward((UI.props.oSubmit.excl_ltr && AE.props.buyBackMin) ? AE.props.buyBackMin : 3);
						}
					} else {
						// This is a dropoff field, so we just need to set the JSON to match the input
						UI.props.oSubmit.doCal = UI.convertDate(UI.props.$doDate);
						_tempDoD = UI.props.oSubmit.doCal + 'T' + UI.props.$doTime.val();
						if (UI.props.isBMRSearch) {
							_tempDoD = UI.props.oSubmit.doCal + 'T05:00:00.000Z';
						}
						searchDoDate = new Date(_tempDoD);
						
						if (!UI.isAfterPickup()) {
							UI.setMinDropoffDate();
						}
						
						if (UI.props.oSubmit.excl_ltr && UI.tooShortForLease()) {
							UI.setMinDropoffDate();
							UI.setDropoffForward((UI.props.oSubmit.excl_ltr && AE.props.buyBackMin) ? AE.props.buyBackMin : 3);
						}
						
						if (UI.props.isBMRSearch && UI.tooShortForBMR()) {
							UI.setMinDropoffDate();
							UI.setDropoffForward(AE.props.bmrMin);
						}
					}
				},
				onClose: function(dateText, inst) {
					var $input = inst.id === 'pickup-date' ? UI.props.$puDate.datepicker() : UI.props.$doDate.datepicker();
					if (!AE.legacy.grief.isIE) {
						$(this)
							.trigger('touchend');
					} else {
						// IE 10 has trouble reopening after hide
						$($input.data('datepicker').trigger).on('click', function() {
							$input.datepicker('show');
						});
					}
					// Fixes Datepicker from automatically re-opening after selection is made
					// this.fixFocusIE = true;
					// this.focus();
				},
				beforeShow: function(input, inst) {
					var direction = $(input)
						.data('direction');
					$(inst.dpDiv)
						.attr('data-direction', direction);
					// If the form is on the main page
					if (AE.ui.props.appendTarget) $(AE.ui.props.appendTarget)
						.append(inst.dpDiv);

					// TODO: UI.highlightSelectionRange(inst);

					var newPuMin = new Date($(input).data('searchmindate'));
					var moddedMinPuDate = AE.ui.search.isValidDate(newPuMin) ? new Date(newPuMin.getUTCFullYear(), newPuMin.getUTCMonth(),
						newPuMin.getUTCDate())
						.toISOString() : false;

					if (moddedMinPuDate && direction === 'pu') {
						UI.props.$puDate.datepicker("option", {
							minDate: new Date(moddedMinPuDate)
						});
					}

					UI.repositionDatepickerArrow(input, inst);

					$(AE.ui.props.scrollContainer)[0].addEventListener('scroll', function() {
						UI.hideOnScrollMove(input);
					}, {
						passive: true
					});

					// Fixes Datepicker from automatically re-opening after selection is made
					var result = AE.legacy.grief.isIE ? !this.fixFocusIE : true;
					this.fixFocusIE = false;
					
					return result;
				},
				beforeShowDay: UI.markDates
			};
			//END OF set initial search form datepicker options
			// Grab the _numberOfCalendarMonthsToShow var when it's set on Datepicker init and add it to options
			UI.props.datepickerOptions.numberOfMonths = UI.props.numberOfCalendarMonthsToShow;
			// Assign new Datepicker options
			UI.props.$puDate.add(UI.props.$doDate)
				.datepicker(UI.props.datepickerOptions)
				.on('touchend', function() {
					return $(this).trigger('blur');
				});

			// if (UI.props.isLeaseSearch) UI.disableWeekendSelection();

			AE.addResizeTask({
				func: function() {
					UI.manageResize();
				},
				args: []
			});

			UI.mainSearch();
		},
		mainSearch: function() {
			var _tempPuD;
			var _tempDoD;
            var _deeplinkPuD;
			var _deeplinkDoD;

			// Set initial PU/DO dates from widget
			searchPuDate = UI.props.$hiddenPuDate.val();
			searchDoDate = UI.props.$hiddenDoDate.val();

			//GET PU DATE FROM STORED SEARCH
			_tempPuD = searchPuDate;
            _tempDoD = searchDoDate;
            if(vouchDateTime){
            	if(vouchDateTime.bkpudate && vouchDateTime.bkpudate !== '') _tempPuD = vouchDateTime.bkpudate;
            	if(vouchDateTime.bkdodate && vouchDateTime.bkdodate !== '') _tempDoD = vouchDateTime.bkdodate;
            }

            _deeplinkPuD = UI.props.$hiddenPuDate.attr('data-deeplinkval');
			_deeplinkDoD = UI.props.$hiddenDoDate.attr('data-deeplinkval');

			if (typeof _deeplinkPuD !== typeof undefined && _deeplinkPuD !== false) {
			  _tempPuD = _deeplinkPuD;
			}

			if (typeof _deeplinkDoD !== typeof undefined && _deeplinkDoD !== false) {
			  _tempDoD = _deeplinkDoD;
			}

			searchPuDate = (_tempPuD !== '')? new Date(_tempPuD) : new Date();
			searchPuDate = new Date(searchPuDate.getUTCFullYear(), searchPuDate.getUTCMonth(), searchPuDate.getUTCDate())
				.toISOString();

			searchDoDate = (_tempDoD !== '')? new Date(_tempDoD) : new Date();
			searchDoDate = new Date(searchDoDate.getUTCFullYear(), searchDoDate.getUTCMonth(), searchDoDate.getUTCDate())
				.toISOString();

			UI.props.$puDate.datepicker("setDate", new Date(searchPuDate));
			UI.props.$doDate.datepicker("setDate", new Date(searchDoDate));

			UI.props.$puDate.parent('.styled--select')
				.removeClass('ui-ready-waiting');
			UI.props.$doDate.parent('.styled--select')
				.removeClass('ui-ready-waiting');

			if (UI.props.isBMRSearch && UI.tooShortForBMR()) {
				UI.setMinDropoffDate();
				UI.setDropoffForward(AE.props.bmrMin);
			}else{
				UI.setMinDropoffDate();
			}

		},
		hideOnScrollMove: function(input) {
			var $target = $(input);

			if ($target.datepicker('widget')
				.is(':visible')) {
				$target.datepicker('hide');

				if (AE.legacy.grief.isIE) {
					$target.on('click', function() {
						$(this)
							.datepicker('show');
					});
				}
				return $(AE.ui.props.scrollContainer)[0].removeEventListener('scroll', function() {
					UI.hideOnScrollMove();
				}, {
					passive: true
				});
			}
			return false;
		},
		disableWeekendSelection: function() {
			var minDate = UI.props.$puDate.datepicker('getDate');

			minDate.setDate(minDate.getDate() + AE.props.buyBackMin);

			switch (minDate.getDay()) {
				case 0:
					// Sunday
					minDate.setDate(minDate.getDate() + 1);
					break;
				case 6:
					// Saturday
					minDate.setDate(minDate.getDate() + 2);
					break;
			}

			var minDoDate = $.datepicker.formatDate(UI.props.strDateFormat, new Date(minDate));
			/* Set the data attribute */
			$(UI.props.$doDate)
				.data('searchmindate', minDoDate);
			/* Set the minDate option */
			UI.props.$doDate.datepicker("option", {
				minDate: minDoDate
			});
		},
		markDates: function(date) {
			var $input = $(this)[0];
			var _selectable = ($($input)
				.data('direction') === 'pu');

			return UI.highlightTripDates(date, $input, _selectable);
		},
		highlightTripDates: function(date, input, selectable) {
			var _selectable = selectable;
			var puVal = _selectable ? new Date(UI.props.$puDate.val()) : new Date(searchPuDate);
			var doVal = _selectable ? new Date(UI.props.$doDate.val()) : new Date(searchDoDate);
			var minDoDateRange = new Date(searchPuDate);
			var markRange = UI.getDatesInRange(puVal, doVal);
			var appliedClass = '';

			if (UI.props.isLeaseSearch) {
				minDoDateRange.setDate(minDoDateRange.getDate() + AE.props.buyBackMin);
			} else if (UI.props.isBMRSearch){
                // No BMR minimum rental range provided
                minDoDateRange.setDate(minDoDateRange.getDate() + 0);
			} else {
				minDoDateRange.setDate(minDoDateRange.getDate());
			}

			for (var i = 0; i < markRange.length; i++) {
				if (date.getMonth() === markRange[i][0] && date.getDate() === markRange[i][1] && date.getUTCFullYear() ===
					markRange[i][2]) {
					if (i === 0 && !UI.props.$doDate) {
						_selectable = true;
						appliedClass = _selectable ? 'date-in-range date-range-start ui-date-highlight' : 'date-range-start';
						return [_selectable, appliedClass, $(UI.props.$puDate)
							.attr('aria-label')];
					} else if (i === markRange.length - 1) {
						appliedClass = 'date-in-range date-range-end ui-date-highlight';
						return [true, appliedClass, $(UI.props.$doDate)
							.attr('aria-label')];
					} else {
						appliedClass = 'date-in-range ui-date-highlight';
						if (new Date(minDoDateRange.getTime()) <= new Date(date.getTime())) _selectable = true;

						// if (UI.props.isLeaseSearch && dayNum == 0 || dayNum == 6) {
						//     appliedClass = 'date-in-range ' + dayNum + '-weekend-date';
						//     _selectable = false;
						// }
						return (UI.props.isLeaseSearch) ? [_selectable, appliedClass] : [true, appliedClass];
					}
				}
			}

			// if (UI.props.isLeaseSearch && (dayNum == 0 || dayNum == 6)) {
			//     appliedClass = dayNum + '-weekend-date';
			//     return [false, appliedClass];
			// }

			appliedClass = 'ui-date-highlight';

			return [true, appliedClass];
		},
		getDatesInRange: function(d0, d1) {
			var start = d0,
				end = d1,
				currentDate = new Date(start.getTime()),
				between = [];

			while (currentDate <= end) {
				var newDate = new Date(currentDate);
				between.push([newDate.getMonth(), newDate.getDate(), newDate.getUTCFullYear()]);
				currentDate.setDate(currentDate.getDate() + 1);
			}
			return between;
		},
		isPickupField: function(selector) {
			var isPickup = ($(selector)
				.data('direction') === 'pu') ? true : false;
			return isPickup;
		},
		setDate: function(name, value) {
			var _val = value;
			var timestamp = Date.parse(_val);

			if (!isNaN(timestamp)) {
				var dateFromPassedInValue = new Date(_val);

				if (name === 'pickup-date') {
					UI.props.$puDate.datepicker("setDate", dateFromPassedInValue);
					UI.props.oSubmit.puCal = UI.convertDate(UI.props.$puDate);
				} else {
					UI.props.$doDate.datepicker("setDate", dateFromPassedInValue);
					UI.props.oSubmit.doCal = UI.convertDate(UI.props.$doDate);
				}
			}
		},
		checkCurrentWindowSize: function(size) {
			return UI.props.responsiveNumMonthsToShow[size];
		},
		convertDate: function($target) {
			/*
				Returns a date string which is formatted for our booking engine. This value is what we need to send
				to the back-end, either through the main search form's prop object or through a hidden field.
			*/
			return $.datepicker.formatDate(UI.props.altFormat, new Date($target.datepicker('getDate')));
		},
		setMinPickupDate: function(){
			var newPuMin = new Date(UI.props.$puDate.data('searchmindate')), moddedMinPuDate = false;

			if(AE.ui.search.isValidDate(newPuMin)){
				moddedMinPuDate = new Date(newPuMin.getUTCFullYear(), newPuMin.getUTCMonth(),	newPuMin.getUTCDate()).toISOString();
			}

			if (moddedMinPuDate) {
				UI.props.$puDate.datepicker("option", {
					minDate: new Date(moddedMinPuDate)
				});
			}
		},
		setMinDropoffDate: function() {
			var _setPuDate = (searchPuDate !== '') ? searchPuDate : UI.props.$puDate.datepicker('getDate');

			var pickupDate = $.datepicker.formatDate(UI.props.strDateFormat, new Date(_setPuDate));
			// If this is a LTR and we have a minimum date delta, enforce it
			if (UI.props.oSubmit.excl_ltr && AE.props.buyBackMin) {
				// Enforce variable minimum duration for Long Term Rentals (LTR)
				var ltrDate = UI.props.$puDate.datepicker('getDate');
				pickupDate = $.datepicker.formatDate(UI.props.strDateFormat, new Date(ltrDate));
			}
			// Get the value of the PU date
			UI.props.$puDate.val(pickupDate);

			// If this is NOT a LTR and the DO date is before the PU date, move the DO date forward 3 days
			if (!UI.props.oSubmit.excl_ltr && !UI.isAfterPickup()) UI.setDropoffForward(3);
			// If this IS a LTR and the delta between the PU & DO dates are too short for a LTR, move the DO date forward
			if (UI.props.oSubmit.excl_ltr && UI.tooShortForLease()) UI.setDropoffForward(AE.props.buyBackMin);

			// If this a LTR, figure out what the new DO date should be
			var _tempNewDoDate = UI.props.$puDate.datepicker('getDate');
			/*_tempNewDoDate.setDate(_tempNewDoDate.getDate() + AE.props.buyBackMin);

			var minDoDate = UI.props.oSubmit.excl_ltr ? _tempNewDoDate : pickupDate;*/
			var overRideMinDoDate = false;
			if(UI.props.isBMRSearch && UI.tooShortForBMR()){
				_tempNewDoDate.setDate(_tempNewDoDate.getDate() + AE.props.bmrMin);
				overRideMinDoDate = true;
			} else if(UI.props.oSubmit.excl_ltr) {
				_tempNewDoDate.setDate(_tempNewDoDate.getDate() + AE.props.buyBackMin);
				overRideMinDoDate = true;
			}
			var minDoDate = (overRideMinDoDate)? _tempNewDoDate : pickupDate;
			/* Set the data attribute */
			UI.props.$doDate.data('searchmindate', minDoDate);

			/* Set the minDate option */
			UI.props.$doDate.datepicker("option", {
				minDate: minDoDate
			});
		},
		setDropoffForward: function(daysToAdd) {
			var dToAdd = daysToAdd || 3;
			var tempDate = UI.props.$puDate.datepicker('getDate');

			// Set dropoff for "dToAdd" days after the pickup
			tempDate.setDate(tempDate.getDate() + dToAdd);

			var futureDate = $.datepicker.formatDate(UI.props.strDateFormat, new Date(tempDate));
			UI.props.$doDate.datepicker("setDate", futureDate);

			return false;
		},
		isAfterPickup: function() {
			var pickupDate = new Date($.datepicker.formatDate(UI.props.altFormat, UI.props.$puDate.datepicker("getDate")) +
				'T' + UI.props.$puTime.val());
			var dropoffDate = new Date($.datepicker.formatDate(UI.props.altFormat, UI.props.$doDate.datepicker("getDate")) +
				'T' + UI.props.$doTime.val());
			var isAfter = (dropoffDate.getTime() < pickupDate.getTime()) ? false : true;

			return isAfter;
		},
		tooShortForLease: function() {
			var minDropoffDate = UI.props.$puDate.datepicker('getDate');
			var dropoffDate = UI.props.$doDate.datepicker('getDate');
			var dropoffTime = UI.props.$doTime.val();
			if(typeof(dropoffTime) === 'string'){
				dropoffTime = dropoffTime.split(':');
			} else {
				dropoffTime = ['0'];
			}

			minDropoffDate.setDate(minDropoffDate.getDate() + AE.props.buyBackMin);
			minDropoffDate.setHours(dropoffTime[0], dropoffTime[1]);
			dropoffDate.setHours(dropoffTime[0], dropoffTime[1]);

			return (dropoffDate.getTime() < minDropoffDate.getTime()) ? true : false;
		},
		tooShortForBMR: function() {
			var BMRmin = AE.props.bmrMin;
			var minDropoffDate = UI.props.$puDate.datepicker('getDate');
			var dropoffDate = UI.props.$doDate.datepicker('getDate');

			minDropoffDate.setDate(minDropoffDate.getDate() + BMRmin);

			return (dropoffDate.getTime() < minDropoffDate.getTime()) ? true : false;
		},
		repositionDatepickerArrow: function(input, inst) {
			// Positions yellow arrow on bottom or top of datepicker widget so its always pointing toward the input
			var $focusInput = $(input);
			var $widget = $focusInput.datepicker("widget");
			var $menu = $(inst.dpDiv);
			var _winH = $(window)
				.height();
			var _formTop = parseInt($focusInput.offset()
				.top) + parseInt($focusInput.outerHeight()) + parseInt($widget.outerHeight());
			var _scrollDist = parseInt($(document)
				.scrollTop());

			return ((_formTop - _scrollDist) > _winH) ? $menu.addClass('reposition-arrow-above-input') : $menu.removeClass(
				'reposition-arrow-above-input');
		},
		// highlightSelectionRange: function(inst) {
		// 	// TODO: This was temporarily(?) abandoned. I'll be back!
		// 	var _input = inst;
		// 	var _menu = _input.dpDiv;
		// 	var _daysToHighlight = document.querySelectorAll('.ui-date-highlight:not(.ui-datepicker-unselectable)');
		// 	$(function() {
		// 		function setDays(days, day) {
		// 			var effectiveDates = [];
		// 			var tD = day.find('a')
		// 				.text();
		// 			var tM = day.attr('data-month');
		// 			var tY = day.attr('data-year');
		// 			for (var i = 0; i < days.length; i++) {
		// 				var _day = $(days[i]);
		// 				var dD = _day.find('a')
		// 					.text();
		// 				var dM = _day.attr('data-month');
		// 				var dY = _day.attr('data-year');
		// 				if (tD === dD && tM === dM && tY === dY) return effectiveDates;
		// 				effectiveDates.push(_day);
		// 			}
		// 			return effectiveDates;
		// 		}
		// 		$(".ui-date-highlight:not(.ui-datepicker-unselectable)")
		// 			.on("mouseenter", function() {
		// 				var _selectedDay = $(this);
		// 				_selectedDay.addClass('ui-new-date-selection');
		// 				if (_selectedDay.parent()
		// 					.has('td.date-range-start')
		// 					.length !== 0) {
		// 					var _children = _selectedDay.parent()
		// 						.find('td');
		// 					var _firstWeek = $('.date-range-start')
		// 						.nextUntil('td.ui-new-date-selection', 'td');
		// 					_children.not(_firstWeek)
		// 						.attr({
		// 							style: 'background-color:unset !important'
		// 						});

		// 					$.each(_firstWeek, function(ind) {
		// 						var d = $(_firstWeek[ind]);
		// 						if (d.hasClass('date-in-range')) d.attr({
		// 							style: 'background-color:red !important'
		// 						});
		// 					});
		// 				}
		// 			});
		// 		$(".ui-date-highlight:not(.ui-datepicker-unselectable)")
		// 			.on("mouseleave", function() {
		// 				var _selectedDay = $(this);
		// 				_selectedDay.removeClass('ui-new-date-selection');
		// 			});
		// 	});
		// },
		resizeDatepicker: function() {
			UI.props.currentWindowSize = AE.getSiteViewType();

			// Hide and destroy the current datepicker to reset settings
			UI.props.$puDate.add(UI.props.$doDate)
				.datepicker("hide")
				.datepicker("destroy")
				.blur();

			// Update global vars
			UI.props.numberOfCalendarMonthsToShow = UI.checkCurrentWindowSize(UI.props.currentWindowSize);
			//  UI.props.responsiveNumMonthsToShow(UI.props.currentWindowSize);
			UI.props.datepickerOptions.numberOfMonths = UI.props.numberOfCalendarMonthsToShow;

			UI.props.$puDate.add(UI.props.$doDate)
				.datepicker(UI.props.datepickerOptions)
				.on('touchend', function() {
					return $(this)
						.trigger('blur');
				});

			// Set the PU minimum date to be today (since you can not pick up in the past)
			UI.props.$puDate.datepicker("option", {
				minDate: new Date()
			});
			UI.setMinPickupDate();
			
			// Set the DO minimum date to be the PU date (because you can not return the car before picking it up)
			UI.props.$doDate.datepicker("option", {
				minDate: UI.props.$puDate.datepicker("getDate")
			});
		},
		manageResize: function() {
			return UI.resizeDatepicker();
		}
	};
	return UI;
})();

;var AE = AE || {}; /* Add to Base object or create it if it doesn't exist. */

AE.ui.searchType = AE.ui.searchType || ( function () {
	/*
	 *DEPENDENCIES: AE, AE.ui. AE.search, AE.utils, AE.legacy
	 */
	'use strict';

	var UI = {
		init: function () {

			UI.props = {
				$siteCode: AE.props.siteCode,
				$viewSize: AE.getSiteViewType(),
				$menusearchEnabled: false,
				LTRLondonSelected: false,
				_searchControllerLocation: '/plugins/ae3/lib/searchController.cfc',
				_searchControllerMethods: {
					textsearch: 'textsearch',
					textsearchPrefill: 'textsearchPrefill',
					textsearchCityLocs: 'textsearchCityLocs',
					menusearchCountryList: 'getLocalizedCountries',
					menusearchCityList: 'getLocalizedCities',
					get_operatorIdListByCountry: 'getOperatorIDsByCountry',
					get_operatorIdListByCity: 'getOperatorIDsByCity',
					get_countriesActiveBySitecode: 'getCountriesActiveBySitecode',
					sClick: 'incrementHubClick'
				}
			};

			UI.props.$menusearchEnabled = prepMenusearch;//WEBAE3-4074 prepMenusearch will always be a boolean from CF now
			if ( AE.ui.timeselectmenu ) AE.ui.timeselectmenu.init();
			if ( AE.ui.datepicker ) AE.ui.datepicker.init();

			/*Modfiies search input behavior for devices*/
			if ( (AE.getSiteViewType() == 'palm') && AE.ui.devices ) {
				AE.ui.devices.init();
			}

			/* MAIN SEARCH FORM: If the main search form is defined, then set up search*/
			UI.mainSearch();
		},

		mainSearch: function () {
			if ( !isLTRSearch && !isBMRSearch ){
				if(AE.ui.searchType.text) AE.ui.searchType.text.init();
				if(AE.ui.searchType.menu && UI.props.$menusearchEnabled ) AE.ui.searchType.menu.init();
			}
			if ( isLTRSearch && AE.ui.searchType.leasesearch ) AE.ui.searchType.leasesearch.init();
			if ( isBMRSearch && AE.ui.searchType.bmr ) AE.ui.searchType.bmr.init();
		},

		_toggleAccordions: function ( activeAccordion ) {
			/*
			 * After city accordions are initiated,
			 * toggles any open accordions to keep only one open at a time.
			 */
			var $enabledAccordion = activeAccordion;
			var $disableAccordions = $( '.ui-textsearch-accordion' ).not( $enabledAccordion );

			$enabledAccordion.addClass( 'ui-textsearch-accordion-active' );
			$disableAccordions.not( $enabledAccordion ).removeClass( 'ui-textsearch-accordion-active ui-state-active' );

			$disableAccordions.not( $enabledAccordion ).accordion( {
				collapsible: true,
				active: false
			} );
			$enabledAccordion.accordion( {
				collapsible: false,
				active: 0
			} );

			UI._scrollToTopOfContainer( $enabledAccordion );
		},

		_scrollToTopOfContainer: function ( target ) {
			var $target = target;
			var $menu = $target.closest( '.ui-textsearch-accordion-list' );
			var _customOffset = ( $menu.find( '.ui-textsearch-accordion' ).length == 1 ) ? 70 : 35

			return $menu.animate( {
				scrollTop: $target.offset().top - $menu.offset().top + $menu.scrollTop() - _customOffset
			} );
		},

		_scrollToListTop: function ( dl ) {
			var $_menu = dl;
			return $_menu.stop().animate( {
				scrollTop: 0
			}, 500 );
		},

		_throwWarningFlag: function ( input, title, msg, pos, newClass ) {
			input.addClass( 'ui--invalid-input' );
			return AE.ui.search.searchFormErrorHandler.init( title, msg, pos, newClass );
		},

		_updateInputValue: function ( input, str ) {
			var $input = input;
			var $widget = $input.textsearch().textsearch( 'instance' );
			var $clearButton = $widget.targetActionButton;
			var _direction = $input.data( 'direction' );
			var _displayString = str;
			var _hasSetValue = _displayString != '';

			var $fn_getInputs = AE.ui.search.autocomplete.getInputs();
			var $puLoc = $fn_getInputs.$puLoc;
			var $doLoc = $fn_getInputs.$doLoc;
			var $chkDiff = $fn_getInputs.$chkDiff;
			var _updatePlaceholderTo;

			if ( !AE.props.isIE ) $input.data( 'placeholderVal', $input.attr( 'data-placeholder' ) );

			if ( _hasSetValue ) {
				$input.data( { 'hasVal': _hasSetValue, 'savedVal': _displayString } );
				if ( _direction == 'pu' ) $doLoc.data( { 'hasVal': _hasSetValue, 'savedVal': _displayString } );
			} else {
				/*CLEARING THE INPUTS*/
				$input.data( { 'hasVal': _hasSetValue, 'savedVal': ( _direction == 'pu' ) ? $input.attr( 'data-placeholder-static' ) : $puLoc.attr( 'data-placeholder' ) } );
				/*RESET DROP WITH NEW PICKUP*/
				if ( _direction == 'pu' ) {
					$( '#locations-wrapper' ).removeClass( 'both' );
					$chkDiff.prop( 'checked', false );
					$doLoc.data( { 'hasVal': _hasSetValue, 'savedVal': $doLoc.attr( 'data-placeholder-static' ) } );
				}
			}

			_updatePlaceholderTo = _hasSetValue ? ( $input.data( 'savedVal' ) ) : $input.attr( 'data-placeholder-static' );

			$input.attr( 'data-placeholder', _updatePlaceholderTo );
			if ( _direction == 'pu' ) $doLoc.attr( 'data-placeholder', _updatePlaceholderTo ).text( '' );
			if ( $puLoc.text() == $doLoc.text() )$doLoc.attr( 'data-placeholder', $puLoc.data( 'savedVal' ) ).text( '' );
			if ( !$clearButton.is(':visible') && (AE.getSiteViewType() != 'palm') ) $clearButton.show().removeClass( $input.data( 'hasVal' ) ? 'rotate-scale-out-center' : 'rotate-scale-in-center' ).addClass( $input.data( 'hasVal' ) ? 'rotate-scale-in-center' : 'rotate-scale-out-center' );

			if ( !$input.data( 'hasVal' ) ) setTimeout( function () {
				if ( AE.getSiteViewType() != 'palm' ) $clearButton.hide();
			}, 500 );

			$input.text( _hasSetValue ? _displayString : '' );

			// if(AE.props.isIE){
				return UI._forceInputBlur( $input );
			// }

		},

		_clearInput: function ( input ) {

			return UI._updateInputValue( input, false, '' );
		},

		_forceInputBlur: function ( input ) {
			/* Prevents voucher page from scrolling to search form */
			if (window.devicePixelRatio >= 1 && AE.url.props.path !== "/my-booking/") {
				/* STORE-1671: CLAUDE FIX
				   input.focus() can synchronously re-enter jQuery UI's
				   Menu._scrollIntoView and throw if its activeMenu element is stale/
				   missing. That must not abort _updateInputValue() before it commits
				   the selected location, so the exception is caught and swallowed. */
				try {
					input.focus().blur();
				} catch ( e ) {}
			};

			return input.trigger('blur');
		},

		_cursorToEndOfString: function ( input ) {

			var editableElem = input,
				str = $( editableElem ).text(),
				endOffset = editableElem.childNodes.length,
				range,
				selection;

			if ( document.createRange ) {
				/*Firefox, Chrome, Opera, Safari, IE 9+*/
				range = document.createRange();
				range.selectNodeContents( editableElem );
				range.collapse( false );
				selection = window.getSelection();
				selection.removeAllRanges();
				selection.addRange( range );

			} else if ( document.selection ) {
				/*IE 8 and lower*/
				range = document.body.createTextRange();
				range.moveToElementText( editableElem );
				range.collapse( false );
				range.select();
			}
		},

		_objHoverHelper: function (obj, toggleClass) {
			/*
			 * jQuery.hover() is deprecated
			 */
			var $obj = obj;
			var $toggleClass = toggleClass || 'ui-state-hover';
			return $obj.on('mouseenter', function () {
				return $(this).addClass($toggleClass);
			}).on('mouseleave', function () {
				return $(this).removeClass($toggleClass);
			});
		},

		_hideDeviceKeyboard: function () {
			/*
			 * For mobile UI, once textsearch becomes a selectable menu - as opposed to textsearch.
			 * We can force the 'select' to 100% vh and suppress the keyboard.
			 */
			$( 'input' ).blur();
			return false;
		}

	};
	return UI;
} )();

;
var AE = AE || {}; /* Add to Base object or create it if it doesn't exist. */

AE.ui.searchType.text = AE.ui.searchType.text || (function () {
    /***
     * DEPENDENCIES: AE, AE.ui. AE.search, AE.utils, AE.legacy
     ***/
    'use strict';

    var _fetchPuCityName,
        _fetchPuIso,
        _fetchPuCategory,
        _fetchDoCityName,
        _fetchDoIso,
        _fetchDoCategory,
        vouchDateTime = ((typeof (oBKdateTime) != 'undefined') && !_.isEmpty(oBKdateTime)) ? oBKdateTime : false,
        AFFILIATE_NAME = typeof (affiliateName) != 'undefined' ? affiliateName : 'AUTOEUROPE',
        DISPLAY_TOP_COUNTRIES = typeof (returnTopCountries) != 'undefined' ? returnTopCountries : true,
        DISPLAY_TOP_CITIES = typeof (returnTopCities) != 'undefined' ? returnTopCities : true;

    /* Use to prefill "manage my booking" if all properties exist. */
    if (vouchDateTime)
        for (var i in vouchDateTime) {
            var testProp = vouchDateTime[i] || '';
            vouchDateTime = !_.isEmpty(testProp) ? vouchDateTime : false;
        }

    var UI = {
        init: function () {

            var GET_INPUTS = AE.ui.search.autocomplete.getInputs();
            
            UI.props = {
                $puLoc: GET_INPUTS.$puLoc,
                /* Local ref to pickup location, defined in AE.ui module. */
                _puLocHasData: false,
                /* Tracking whether PU input has been filled. */
                $doLoc: GET_INPUTS.$doLoc,
                /* Local ref to dropoff location, defined in AE.ui module. */
                _doLocHasData: false,
                /* Tracking whether DO has been filled. */
                $tempDoDataHolder: {},
                /* If PU hasn't been set and DO fires first - put it in this temporary container object. */
                $chkDiff: GET_INPUTS.$chkDiff,
                $arr_isoCountryList: (typeof activatedCountries != 'undefined') ? activatedCountries : {},
                _textsearchPrefillObj: {
                    'pu': {
                        'chaos_city_name': (typeof searchPuCity != 'undefined') ? searchPuCity : false,
                        'chaos_country_code': (typeof searchPuCountry != 'undefined') ? searchPuCountry : false,
                        'category': (typeof searchPuCategory != 'undefined') ? searchPuCategory : false
                    },
                    'drop': {
                        'chaos_city_name': (typeof searchDoCity != 'undefined') ? searchDoCity : false,
                        'chaos_country_code': (typeof searchDoCountry != 'undefined') ? searchDoCountry : false,
                        'category': (typeof searchDoCategory != 'undefined') ? searchDoCategory : false
                    },
                },
                /* Warning flag error message - pick-up first. */
                msg_pickupFirst: $('#locations-wrapper').data('pufirst'),
                /* Warning flag error message - input cannot be empty. */
                msg_inputEmpty: $('#locations-wrapper').data('inputempty'),
                _LAUNCH_MENUSEARCH: false,
                _DISPLAY_ALPHA_LIST: true,
                _READY_TO_CLOSE: false,
                _OVERRIDE_MENU_ANIMATION: false,
                _DISPLAY_COUNTRY_LIST: false,
                _DISPLAY_COUNTRY_CITIES_LIST: false,
                $RES_OBJ_FOR_BOOKING: {
                    pu: false,
                    drop: false
                },
                _activeMenu: null,
                _shadeStyle: {}
            };

            $.extend(UI.props, AE.ui.searchType.props);

            UI.props._LAUNCH_MENUSEARCH = UI.props.$menusearchEnabled;

            if (!UI.props._LAUNCH_MENUSEARCH) {
                AE.ui.addBodyClickTask({
                    func: UI.onBodyClick
                });
            }

            AE.addResizeTask({
                func: function (event) {
                    UI.manageResize(event);
                },
                args: [{
                    pu: UI.props.$puLoc,
                    do: UI.props.$doLoc
                }]
            });

            UI.mainSearch();
        },

        mainSearch: function () {

            var TRY_LOCAL_STORAGE = AE.ui.search.useStoredSearch() && !vouchDateTime,
                PREFILL_STORAGE_STR = TRY_LOCAL_STORAGE ? localStorage.getItem('aeSearch') : false,
                USE_PAGE_PREFILL = ((typeof (searchPuCity) != 'undefined') && (searchPuCity!='' || searchPuOAG!='')),
                USE_STORED_SEARCH = (PREFILL_STORAGE_STR != false);

                if (USE_PAGE_PREFILL)
                    USE_STORED_SEARCH = false;


            /* Reference to searchcontroller location and methods. */
            var $CF_SEARCH_CONTROLLER_REF = UI.props._searchControllerLocation;
            var $CF_SEARCH_METHOD = UI.props._searchControllerMethods;
            /* Setting some default properties to check over in textsearchcreate. */
            var OPERATOR_ID_LIST_TO_FILTER_DO = [];
            var PREVENT_INPUT_BLUR = false;
            var TRY_PREFILL_PICKUP = false;
            var TRY_PREFILL_DROPOFF = false;
            /* Menu open/close animation. */
            var _showMenuClass = 'scale-in-ver-top';
            var _hideMenuClass = 'scale-out-ver-top';
            /* Override menu open/close animation. */
            var _hideMenuClass_alt = 'fade-out';
            /*
             * US alphabet for city lists.
             * TODO: Figure out how to integrate language.
             * */
            var _alphaList = ['A', 'B', 'C', 'D', 'E', 'F', 'G', 'H', 'I', 'J', 'K', 'L', 'M', 'N', 'O', 'P', 'Q', 'R', 'S', 'T', 'U', 'V', 'W', 'X', 'Y', 'Z'];

            /* Set up a few default objects to be reused within the search menus. */
            var $ui_badge = $('<span/>').attr({
                'class': 'ui-textsearch-badge'
            });
            var $ui_textsearchMenuFooter = $('<footer/>', {
                'class': 'ui-textsearch-menu-footer'
            });
            var $ui_textsearchScrollBtn = $('<button/>', {
                'class': 'ui-textsearch-btn-sm ui-textsearch-scroll-btn',
                role: 'button'
            });
            var $button_back_to_list = $('<button/>', {
                'class': 'ui-textsearch-btn-med',
                role: 'button'
            });
            var $button_reset_input = $('<button/>', {
                'class': 'ui-textsearch-btn-med',
                role: 'button'
            });

            /*Displays country name and flag.*/
            var $textsearchAccordionHead = $('<a/>', {
                'class': 'ui-textsearch-accordion-head'
            });
            /*Base accordion body structure.*/
            var $textsearchAccordionBody = $('<dl/>', {
                'class': 'ui-textsearch-accordion-body'
            });


            /* Hub categories as defined in searchcontroller. */
            var _CNT = 'COUNTRY',
                _CTY = 'CITY',
                _APT = 'AIRPORT',
                _ATERM = 'AIRPORT_TERMINAL--ITEM',
                _RWY = 'RAIL',
                _FRY = 'FERRY',
                _OTH = 'OTHER',
                _TOP = 'TOP',
                _ERR = 'ERROR';
            /* Default icons for hub types. */
            var _hubCases = {};
            
                // _hubCases[_CNT] = {
                //     icon: 'fa-location-arrow',
                //     behavior: false
                // };
                _hubCases[_APT] = {
                    icon: 'fa-plane',
                    behavior: false
                };
                _hubCases[_ATERM] = {
                    icon: 'fa-angle-right',
                    behavior: false
                };
                _hubCases[_ATERM.replace('--ITEM', '--LIST')] = {
                    icon: 'fa-plane',
                    behavior: false
                };
                _hubCases[_RWY] = {
                    icon: 'fa-train',
                    behavior: false
                };
                _hubCases[_FRY] = {
                    icon: 'fa-ship',
                    behavior: false
                };
                _hubCases[_OTH] = {
                    icon: 'fa-map-pin',
                    behavior: false
                };
                _hubCases[_CTY] = {
                    icon: 'fa-map-marker',
                    behavior: false
                };
                _hubCases[_ERR] = {
                    icon: 'fa-exclamation-triangle',
                    behavior: false
                };
                _hubCases[_TOP] = {
                    icon: 'fa-star',
                    behavior: false
                };
            
                if(AE.props.siteCode == 'FCR') {
                    _hubCases[_APT] = {
                        icon: 'fcr-flight',
                        iconType: '',
                        behavior: false
                    };
                    _hubCases[_ATERM] = {
                        icon: 'fcr-chevron-right',
                        iconType: '',
                        behavior: false
                    };
                    _hubCases[_ATERM.replace('--ITEM', '--LIST')] = {
                        icon: 'fcr-flight',
                        iconType: '',
                        behavior: false
                    };
                    _hubCases[_RWY] = {
                        icon: 'fcr-train',
                        iconType: '',
                        behavior: false
                    };
                    _hubCases[_CTY] = {
                        icon: 'fcr-place',
                        iconType: '',
                        behavior: false
                    };
                    _hubCases[_FRY] = {
                        icon: 'fcr-boat',
                        iconType: '',
                        behavior: false
                    };
                    _hubCases[_CNT] = {
                        icon: 'fcr-nearby',
                        iconType: '',
                        behavior: false
                    };
                    _hubCases[_OTH] = {
                        icon: 'fcr-place',
                        iconType: '',
                        behavior: false
                    };
                }

            $ui_textsearchScrollBtn.html('<i class="fa fa-chevron-up"></i>');
            $ui_textsearchMenuFooter.append($ui_textsearchScrollBtn);


            UI.props.$chkDiff.on('change', function (event) {
                var $btn = $(this);
                var _checked = $btn.is(':checked');

                if (UI.props.$menusearchEnabled) {
                    if (!_checked) {
                        $('#locations-wrapper .dropoff-wrapper .trg__menusearch--country-x').click();
                    }
                } else {

                    if (UI.props.$RES_OBJ_FOR_BOOKING.pu == false) {
                        $('#locations-wrapper').removeClass('both');
                        $btn.prop('checked', false);
                        return AE.ui.searchType._throwWarningFlag(UI.props.$puLoc, UI.props.msg_pickupFirst, UI.props.msg_inputEmpty, {
                            top: 50,
                            left: 50
                        }, 'arrow-left');
                    }

                    if (!_checked) {
                        AE.ui.searchType._updateInputValue(UI.props.$doLoc, '');
                        UI.props.$RES_OBJ_FOR_BOOKING.drop = false;
                        AE.ui.search.autocomplete.setValue(UI.props.$RES_OBJ_FOR_BOOKING);
                    }
                }
            });





            $.widget('custom.textsearch', $.ui.autocomplete, {
                    
            
                _create: function (event, ui) {

                    this._super();
                    this.menu = $('<dl/>').hide().appendTo(this._appendTo()).menu({
                        role: null
                    }).menu('instance');
                    this.element.data('input', this.element).addClass('ui-textsearch-input');


                    this.element.menu().data('menu', this.menu);
                    this.widget().menu('option', 'items', '.ui-menu-item, > :not(.ui-menu-item-error, .ui-menu-item-disabled, .ui-textsearch-label, .ui-textsearch-category, .ui-textsearch-accordion-wrapper, .ui-accordion-header, .ui-textsearch-error-msg-title, .ui-textsearch-error-msg)').addClass('ui-textsearch');
                    
                    this.menu.activeMenu = this.widget().menu();
             
                },

                _sortHubsToDisplay: function (dl, direction, items, addClass) {

                    var $widget = this;
                    var $arr_items = [];
                    var _addClassToListItem = addClass;
                    var _dd;
                    /* Temporary arrays to sort locations by hub type. */
                    var $arr_airport = [];
                    var $arr_airport_terminals = [];
                    var $arr_rail = [];
                    var $arr_ferry = [];
                    var $arr_city = [];
                    var $arr_country = [];
                    var $arr_error = [];
                    var $arr_other = [];
                    var $arr_hubArrays = {};
                    $arr_hubArrays[_CNT] = $arr_country;
                    $arr_hubArrays[_APT] = $arr_airport;
                    $arr_hubArrays[_ATERM] = $arr_airport_terminals;
                    $arr_hubArrays[_RWY] = $arr_rail;
                    $arr_hubArrays[_FRY] = $arr_ferry;
                    $arr_hubArrays[_OTH] = $arr_other;
                    $arr_hubArrays[_ERR] = $arr_error;
                    $arr_hubArrays[_CTY] = $arr_city;
                    
                    for (var i in items) {
                        var _loc = items[i];
                        var _type = _loc.category || _ERR;
                        if ((_type != 'INVISIBLE') && $arr_hubArrays[_type]) $arr_hubArrays[_type].push(_loc);
                    }

                    $arr_hubArrays[_ATERM] = AE.utils._sortPropByAlphaInArray($arr_hubArrays[_ATERM], 'display_label');

                    for (var j in $arr_hubArrays) {
                        var hType = j;
                        if ($arr_hubArrays[j].length != 0 && (j != _ATERM)) {
                            var _hubArray = AE.utils._sortPropByAlphaInArray($arr_hubArrays[j], 'click_count').reverse();
                            _hubArray = AE.utils._removeDuplicateObjectsFromArray(_hubArray, 'display_label');

                            for (var k in _hubArray) {
                                var _locToDisplay = _hubArray[k];

                                if (hType == _APT && $arr_hubArrays[_ATERM].length != 0) {
                                    var chaos_hub_id = _locToDisplay.chaos_hub_id;
                                    var association_array = [];

                                    for (var l in $arr_hubArrays[_ATERM]) association_array.push($arr_hubArrays[_ATERM][l].parent_hub_id);

                                    if ($arr_items.indexOf(_locToDisplay) == -1) {
                                        if (association_array.indexOf(chaos_hub_id) != -1) _locToDisplay.category += '_TERMINAL--LIST';
                                        $arr_items.push(_locToDisplay);
                                    }

                                    for (var m in $arr_hubArrays[_ATERM]) {
                                        var _terminal = $arr_hubArrays[_ATERM][m];
                                        var parent_hub_id = _terminal.parent_hub_id || 0;
                                        if (parent_hub_id == chaos_hub_id) $arr_items.push(_terminal);
                                    }
                                } else {
                                    if ($arr_items.indexOf(_locToDisplay) == -1) $arr_items.push(_locToDisplay);
                                }
                            }
                        }
                    }

                    for (var n in $arr_items) {
                        var _location = $arr_items[n];
                        _dd = $widget._renderItemData(dl, _location).addClass(_addClassToListItem);
                    }
                    return false;
                },

                _renderMenu: function (dl, items) {
                    /*
                     * Renders menu
                     */
                    var $widget = this;
                    var $input = this.element;
                    var $menu = dl;
                    var _direction = $input.data('direction');
                    var list_length = 0;
                    var $items = items;
                    var $menu_header_label = $('<h1/>').addClass('ui-textsearch-shade-header-title');
                    var $number_matches_badge = $ui_badge.clone().addClass('ui--badge-total-locations');
                    var $icon_menu_item = $('<i/>', {
                        'aria-hidden': true
                    });
                    var _addClassToListItem = '';
                    var _breakTopLocsAt;
                    var _headerID;
                    var _dt;
                    var _dd;
                    
                    $menu.empty();

                    if (UI.props._DISPLAY_ALPHA_LIST && !AE.props.isIE) $widget._buildListIndexHelper($menu, 'destroy');
                    if (UI.props._DISPLAY_COUNTRY_LIST || UI.props._DISPLAY_COUNTRY_CITIES_LIST) {
                        $menu.addClass('ui-textsearch-accordion-list');
                        $items = AE.utils._sortPropByAlphaInArray(items, 'sequence');
                    } else {
                        $items = AE.utils._sortPropByAlphaInArray(items, 'click_count').reverse();
                    }

                    if (UI.props._DISPLAY_COUNTRY_LIST) {
                        _addClassToListItem = 'ui-menu-item';

                        if (DISPLAY_TOP_COUNTRIES) {
                            var $arr_topCountries = [];

                            for (var i in $items)
                                if ($items[i].chaos_country_code == '--') _breakTopLocsAt = $items[i].sequence;

                            for (var j in $items) {
                                var $newCountryLoc = $items[j];
                                if ($newCountryLoc.sequence < _breakTopLocsAt) {
                                    $newCountryLoc.click_count = _TOP;
                                    $arr_topCountries.push($newCountryLoc);
                                }
                            }

                            $items.splice(0, _breakTopLocsAt);

                            $.each($arr_topCountries, function (index, item) {
                                _dd = $widget._renderItemData($menu, item).addClass(_addClassToListItem + ' ui-top-location').uniqueId();
                            });
                        }

                        $.each($items, function (index, item) {
                            _dd = $widget._renderItemData($menu, item).addClass(_addClassToListItem).uniqueId();
                        });

                        $menu.removeClass('ui-textsearch-hide-flags');

                    } else if (UI.props._DISPLAY_COUNTRY_CITIES_LIST) {

                        $menu.addClass('ui-textsearch-hide-flags');
                        _addClassToListItem = !$menu.hasClass('ui-textsearch-accordion-body') ? 'ui-menu-item fa-override-icon' : 'ui-menu-item';

                        if (!$menu.hasClass('ui-textsearch-accordion-body')) {

                            var _chaosCountryCode = $items[0].chaos_country_code || false;
                            var _listTitle = $items[0].country_label || false;

                            if (DISPLAY_TOP_CITIES) {
                                var $arr_topCities = [];

                                for (var k in $items)
                                    if ($items[k].chaos_country_code == '--') _breakTopLocsAt = $items[k].sequence;

                                for (var l in $items) {
                                    var $newLoc = $items[l];
                                    if ($newLoc.sequence < _breakTopLocsAt) {
                                        $newLoc.click_count = _TOP;
                                        $arr_topCities.push($newLoc);
                                    }
                                }

                                $items.splice(0, _breakTopLocsAt);

                                $.each($arr_topCities, function (index, item) {
                                    _dt = $widget._renderItemData($menu, item).addClass(_addClassToListItem + ' ui-top-location').uniqueId();
                                    _headerID = _dt.attr('id');
                                });
                            }

                            $.each($items, function (index, item) {
                                _dt = $widget._renderItemData($menu, item).addClass(_addClassToListItem).uniqueId();
                                _headerID = _dt.attr('id');
                            });

                        } else {

                            $widget._sortHubsToDisplay($menu, _direction, $items, _addClassToListItem);
                        }

                    } else {

                        _addClassToListItem = '';

                        $.each($items, function (index, item) {

                            var $item = item;
                            var $arr_sub_locations = $item.locations;
                            var master_click_count = $item.click_count;
                            var master_display_label = $item.display_label;
                            var master_category = $item.category;
                            var master_city_name = $item.chaos_city_name || false;
                            var master_chaos_country_code = !$item.chaos_country_code ? 'NO' : $item.chaos_country_code;
                            var master_add_header = true;
                            var $number_matches_badge = $ui_badge.clone().addClass('ui--badge-locations').text($arr_sub_locations.length);

                            if (master_category == 'ERROR') return $widget._renderMenuErrorNoMatches($menu, $item);
                            master_chaos_country_code = master_chaos_country_code.trim();

                            if (master_add_header) {
                                _dt = $('<dt/>').attr({
                                    'aria-label': master_city_name,
                                    'data-weight': master_click_count,
                                    'data-country-code': master_chaos_country_code,
                                    'role': 'separator'
                                }).addClass('ui-textsearch-category').text(master_display_label).uniqueId();
                                if (master_category != _CNT) _dt.append($number_matches_badge);
                                _dt.appendTo($menu);
                                _headerID = _dt.attr('id');
                            }

                            $widget._sortHubsToDisplay($menu, _direction, $arr_sub_locations, _addClassToListItem);
                        });

                        list_length = $menu.find('dd').not('.ui-textsearch-error-msg').length;
                        list_length += (list_length != 1) ? ' ' + matchPlural : ' ' + matchSingular;

                        $number_matches_badge.text(list_length);
                        $menu_header_label.text(txtInitialheader);

                        _dt = $('<dt/>').addClass('ui-textsearch-label').attr({
                            role: 'menubar'
                        }).append($menu_header_label, $number_matches_badge).prependTo($menu);
                        $menu.removeClass('ui-textsearch-hide-flags');
                    }

                    /*ADDING BUTTONS TO THE MENU, BUTTON TO RESET DROPOFF*/
                    if (UI.props._DISPLAY_COUNTRY_LIST) {
                        $menu_header_label.text(txtPUheader);
                        _dt = $('<dt/>').addClass('ui-textsearch-label').attr({
                            role: 'menubar'
                        }).append($menu_header_label).uniqueId();

                        if (_direction == 'do') {
                            $menu_header_label.text(txtDOheader);
                            $button_reset_input.prependTo($menu);
                            $icon_menu_item.addClass('fas fa-sync right');
                            $button_reset_input.text(txtSameAsPu).addClass('ui-reset-input').append($icon_menu_item);
                            _dt.append($button_reset_input);

                            AE.ui.searchType._objHoverHelper($button_reset_input);
                        }

                        _dt.prependTo($menu);
                        _headerID = _dt.attr('id');
                    }

                    /* ADDING BUTTONS TO THE MENU, BUTTON TO RETURN TO COUNTRY LIST */
                    if (UI.props._DISPLAY_COUNTRY_CITIES_LIST && !UI.props._DISPLAY_COUNTRY_LIST) {
                        $icon_menu_item.addClass('fa fa-chevron-left left');
                        $button_back_to_list.text(txtAllCountries).addClass('ui-back-to-list').prepend($icon_menu_item);
                        $menu_header_label.addClass('ui-menu-item-wrapper').text(_listTitle);
                        //VM
                        if (!$menu.hasClass('ui-textsearch-accordion-body')) {
                            _dt = $('<dt/>').attr({
                                role: 'menubar',
                                'data-country-code': _chaosCountryCode
                            }).addClass('ui-textsearch-label').append($menu_header_label, $button_back_to_list).uniqueId();
                            _dt.prependTo($menu);
                            _headerID = _dt.attr('id');

                            AE.ui.searchType._objHoverHelper($button_back_to_list);
                        }
                    }

                    if (UI.props._DISPLAY_ALPHA_LIST && !AE.props.isIE && (UI.props._DISPLAY_COUNTRY_CITIES_LIST || UI.props._DISPLAY_COUNTRY_LIST) && !$menu.hasClass('ui-textsearch-accordion-body') && ($items.length > 10)) $widget._buildListIndexHelper($menu, 'init');

                    var _headers = $menu.find('dt');
                    var _topLocs = $menu.find('dd.ui-top-location');

                    $(_topLocs[(_topLocs.length) - 1]).addClass('last');

                    /* GRAB ODD DD FROM EACH DT ~ DD LIST RATHER THAN ASSIGN ODD TO EVERY OTHER ITEM*/
                    for (var m = 0; m < _headers.length; m++) {
                        var _head = $(_headers[m]);
                        var _newID = _head.attr('id');
                        if (_newID != 'undefined') $('#' + _newID).nextUntil('dt', 'dd:odd').addClass('odd');
                    }

                    if ($menu.find('dd.ui-textsearch-error-msg').length) $number_matches_badge.hide();

                    if (!AE.props.isIE) $widget._scrollMenu($menu);
                },

                _renderMenuErrorNoMatches: function (dl, item) {

                    var $menu = dl;
                    var $item = item;
                    var _message = warnNoLocationsSpecific;
                    _message = _message.replace(/[+/'::REQUEST::/'+'\[\]']+/g, '<mark class="ui-textsearch-highlight">' + $item.label + '<mark/>');
                    var _dt = $('<dt/>').attr({
                        class: 'ui-textsearch-error-msg-title'
                    });
                    var _dd = $('<dd/>').attr({
                        class: 'ui-textsearch-error-msg'
                    }).html(_message);

                    $menu.append(_dt, _dd);
                },

                _renderItem: function (dl, item) {
                    /*
                     * Renders result items
                     */
                    var $icon_menu_item = $('<i/>').attr({
                        'aria-hidden': true,
                        class: 'fa pull-right'
                    });
                    var $itemWrapper = $('<div/>').attr({
                        'tabindex': -1,
                        class: 'ui-menu-item-wrapper'
                    });

                    var $menu = dl;
                    var $item = item;
                    var _category = $item.category;
                    var _chaosCountryCode = $item.chaos_country_code;
                    var item_click_count = $item.click_count;
                    var item_display_label = item.display_label;
                    var icon_style;
                    var icon_type;
                    var $dd = $('<dd/>', {
                        "aria-label": item_display_label,
                        "data-weight": item_click_count,
                        "data-category": _category,
                        "data-country-code": _chaosCountryCode,
                        role: 'menuitem'
                    }).append($itemWrapper);

                    if (_hubCases[_category]) icon_style = _hubCases[_category].icon;

                    //VM WEBAE3-5384
                    if (typeof icon_type === "undefined" && AE.props.siteCode != 'FCR') {
                        icon_type = 'NA'
                    } else {icon_type = _hubCases[_category].iconType}

                    //VM WEBAE3-5384 -- Error was in below if else
                    //console.log(item.category)
                    //if (_hubCases[_category].iconType){ icon_type = _hubCases[_category].iconType
                    //}else{ icon_type = ''};
                    if (item_click_count == _TOP) icon_style = _hubCases[item_click_count].icon;
                    if (AE.props.siteCode == 'FCR') {
                        if (_hubCases[_category].iconType === 'flight') {
                            var $icon_menu_item = $('<i>' + icon_type +'</i>').attr({
                                'aria-hidden': true,
                                class: 'display-none fcr-text_search_icon pull-right fcr-rotate45'
                            });
                        } else {
                            var $icon_menu_item = $('<i>' + icon_type + '</i>').attr({
                                'aria-hidden': true,
                                class: 'display-none fcr-text_search_icon pull-right'
                            });
                        }
                    }
                    $itemWrapper.text(item_display_label).append($icon_menu_item.addClass(icon_style));

                    //VM WEBAE3-5384 Prevent drill down in search
                    if (_category == 'COUNTRY') {
                        $dd.css('display', 'none');
                        //$dd.addClass('ui-menu-item-disabled').attr({'aria-disabled': true})
                    }

                    if (_category.indexOf('_TERMINAL--LIST') != -1) {
                        $dd.addClass('ui-menu-item-disabled').attr({
                            'aria-disabled': true
                        });

                        $itemWrapper.data('initialContent', $itemWrapper.html());

                        $dd.on('mouseenter', function () {
                            //if the initial content wraps, and 'select a terminal below' does not, the menu 'jumps' when the div resizes on mouseover. So make it retain the original div height.
                            var originalheight = $itemWrapper.height();
                            $itemWrapper.height(originalheight);
                            return $itemWrapper.text('select a terminal below').append($icon_menu_item.addClass('fa-level-down'));
                            
                        }).on('mouseleave', function () {
                            return $itemWrapper.html($itemWrapper.data('initialContent'));
                        });

                    } else if (_category == 'ERROR') {
                        $dd.addClass('ui-menu-item-error').removeClass('ui-menu-item');
                    } else {
                        $dd.data('iObj', $item);
                    }

                    return $dd.appendTo($menu);
                },

                _populateMenusearchCountryList: function (dl) {
                    /*
                     * Populating the all country list
                     */
                    var $widget = this;
                    var $menu = dl;
                    var $input = $widget.element;
                    var _direction = $input.data('direction');

                    $.ajax({
                        url: $CF_SEARCH_CONTROLLER_REF,
                        dataType: 'json',
                        data: {
                            method: $CF_SEARCH_METHOD.menusearchCountryList,
                            returnTopCountries: DISPLAY_TOP_COUNTRIES,
                            affiliateName: AFFILIATE_NAME,
                            operator_id_list: (_direction == 'pu') ? '' : OPERATOR_ID_LIST_TO_FILTER_DO
                        },
                        success: function (data) {
                            var $arr_matchedLocations = [];
                            $arr_matchedLocations = data;
                            $widget._renderMenu($menu, $arr_matchedLocations);
                        }
                    });
                    return AE.ui.searchType._scrollToListTop($menu);
                },

                _populateMenusearchCityList: function (dl, item, country) {
                    /*
                     * When viewing country list - or clicking through results to a country
                     * will display all cities in country Returning featured cities first
                     */

                    var $widget = this;
                    var $menu = dl;
                    var $item = item;
                    var $input = $widget.element;
                    var _direction = $input.data('direction');
                    var _iso = $item.chaos_country_code;

                    $.ajax({
                        url: $CF_SEARCH_CONTROLLER_REF,
                        dataType: 'json',
                        data: {
                            method: $CF_SEARCH_METHOD.menusearchCityList,
                            chaos_country_code: _iso,
                            returnTopCities: DISPLAY_TOP_CITIES,
                            affiliateName: AFFILIATE_NAME,
                            operator_id_list: (_direction == 'pu') ? '' : OPERATOR_ID_LIST_TO_FILTER_DO
                        },
                        success: function (data) {
                            var $arr_matchedLocations = [];

                            for (var i in data) {
                                var cityListing = data[i];
                                cityListing.country_label = country;
                                $arr_matchedLocations.push(cityListing);
                            }
                            $widget._renderMenu($menu, $arr_matchedLocations);
                        }
                    });

                    return AE.ui.searchType._scrollToListTop($menu);
                },

                _operatorIdListByCity: function (chaos_city_id) {
                    return $.getJSON($CF_SEARCH_CONTROLLER_REF, {
                        method: $CF_SEARCH_METHOD.get_operatorIdListByCity,
                        chaos_city_id: chaos_city_id
                    }).done(function (data) {
                        return data;
                    });
                },

                _operatorIdListByCountry: function (chaos_country_id) {
                    return $.getJSON($CF_SEARCH_CONTROLLER_REF, {
                        method: $CF_SEARCH_METHOD.get_operatorIdListByCountry,
                        chaos_country_id: chaos_country_id
                    }).done(function (data) {
                        return data;
                    });
                },

                _scrollMenu: function (dl) {
                    /*
                     * Watches menu scroll event.
                     */
                    var $menu = dl;

                    $menu.on('scroll', function () {
                        // var $aside = $($menu.parent('.ui-textsearch-menu-wrapper').find('.ui-textsearch-alpha-index-helper')[0]);
                        /*If menu is scrolled to the top of its parent, disable scroll-to-top button by unbind*/
                        if ($(this).scrollTop() < 100 && $menu.hasClass('scrolling')) $menu.removeClass('scrolling');
                        /*If menu has been scrolled within its parent, enable scroll-top-top button*/
                        if ($(this).scrollTop() > 100 && !$menu.hasClass('scrolling')) $menu.addClass('scrolling');
                        return false;
                    });
                },

                _buildListIndexHelper: function (dl, callback) {
                    /*AN ALPHA LIST DISPLAY NEXT TO LONG SCROLLING LISTS, TOGGLED FROM UI.props._DISPLAY_ALPHA_LIST*/
                    var $menu = dl;
                    var $arrAlphaHelper = [];
                    var $elemArr = [];
                    var $items = $menu.find('dd:not(.ui-top-location)');
                    var $displayList = $('<aside/>', {
                        class: 'ui-textsearch-alpha-index-helper',
                        role: 'navigation'
                    });
                    var $list = $('<ul/>', {
                        class: 'ui-textsearch-alpha-index-list'
                    });
                    var $listItem = $('<li/>', {
                        class: 'ui-textsearch-alpha-index-list-item'
                    });

                    var _destroyHelper = function () {
                        var $aside = $($menu.parent('.ui-textsearch-menu-wrapper').find('.ui-textsearch-alpha-index-helper')[0]);
                        return $aside.length > 0 ? $aside.remove() : false;
                    };

                    var _initHelper = function () {
                        for (var i = 0; i < $items.length; i++) {
                            var $item = $items[i];
                            var _startsWith = $($item).text().toUpperCase().substring(0, 1);
                            if ($arrAlphaHelper.indexOf(_startsWith) == -1) {
                                $arrAlphaHelper.push(_startsWith);
                                $elemArr.push($item);
                            }
                        }

                        for (var j in _alphaList) {
                            var _ind = _alphaList[j];
                            var $entry = $listItem.clone().text(_ind).uniqueId();

                            if ($arrAlphaHelper.indexOf(_ind) != -1) {
                                var _charPosition = $arrAlphaHelper.indexOf(_ind);
                                var $target = $($elemArr[_charPosition]);

                                $entry.attr({
                                    'aria-controls': $target.attr('id'),
                                    'data-value': _ind
                                }).addClass('ui-state-available');
                            } else {
                                $entry.attr({
                                    'data-value': _ind
                                });
                            }
                            $list.append($entry);
                        }
                        if ($menu.parent('.ui-textsearch-menu-wrapper').find('.ui-textsearch-alpha-index-helper').length == 0) {
                            $displayList.append($list);
                            $displayList.insertBefore($menu);
                        }

                        AE.ui.searchType._objHoverHelper($('.ui-textsearch-alpha-index-list-item'));

                    };
                    return (callback == 'init') ? _initHelper() : (callback == 'destroy') ? _destroyHelper() : false;
                },

                _setMenuItemAccordion: function (target, chaosCityId, chaosCityName, chaosCountryCode) {
                    /*
                     * Builds Country/city accordions.
                     */

                    var $widget = this;
                    var $menu;
                    var _direction = $(this.element).data('direction');
                    var $accordionContainer = $(target);
                    var $accordionContainerTriggerElement = $accordionContainer.find('.ui-menu-item-wrapper');
                    var _doAccordionInit = !$accordionContainer.hasClass('ui-textsearch-accordion');

                    AE.ui.searchType._objHoverHelper($textsearchAccordionHead);

                    $accordionContainerTriggerElement.addClass('ui-show-flag');
                    var $activeAccordion = $accordionContainer;

                    if (_doAccordionInit) {
                        $menu = $textsearchAccordionBody.uniqueId();
                        $accordionContainer.addClass('ui-textsearch-accordion');
                        $accordionContainerTriggerElement.wrap($textsearchAccordionHead);
                        $accordionContainer.append($menu);
                        $textsearchAccordionHead.attr({
                            'aria-owns': $menu.attr('id')
                        });

                        return $.ajax({
                            url: $CF_SEARCH_CONTROLLER_REF,
                            dataType: 'json',
                            data: {
                                method: $CF_SEARCH_METHOD.textsearchCityLocs,
                                chaos_city_id: chaosCityId,
                                affiliateName: AFFILIATE_NAME,
                                operator_id_list: (_direction == 'pu') ? '' : OPERATOR_ID_LIST_TO_FILTER_DO
                            },
                            success: function (data) {
                                var $arr_matchedLocations = [];
                                for (var i in data) {
                                    var $item = data[i];

                                    for (var j in Object.keys($item)) {
                                        var locations = $item[j].locations;
                                        for (var k in locations) {
                                            var location = locations[k];
                                            var locCity = location.chaos_city_name || false;
                                            var locCCC = location.chaos_country_code || false;

                                            if (locCity && (locCity.toUpperCase() == chaosCityName.toUpperCase()) && (location.category != _CNT) && locCCC && (locCCC.toUpperCase() == chaosCountryCode.toUpperCase())) $arr_matchedLocations.push(location);
                                        }
                                    }
                                }

                                if (!$arr_matchedLocations.length) {
                                    $arr_matchedLocations[0] = {
                                        category: 'ERROR',
                                        chaos_city_name: '',
                                        chaos_country_code: '',
                                        chaos_hub_id: '',
                                        city_hub_list: [],
                                        click_count: 0,
                                        country_label: '',
                                        desk_list: '',
                                        display_label: warnNoLocationsVague,
                                        hubtype_id: 0,
                                        iata: '',
                                        oag: '',
                                        operator_id_list: [],
                                        title: ''
                                    };
                                }

                                $arr_matchedLocations = AE.utils._removeDuplicateObjectsFromArray($arr_matchedLocations, 'display_label');
                                $widget._renderMenu($menu, $arr_matchedLocations);

                                return $accordionContainer.accordion({
                                    header: $textsearchAccordionHead,
                                    active: 0,
                                    collapsible: false,
                                    animate: true,
                                    heightStyle: 'content',
                                    create: function (event, ui) {
                                        return AE.ui.searchType._toggleAccordions($activeAccordion);
                                    }
                                });
                            }
                        });

                    } else {
                        return AE.ui.searchType._toggleAccordions($activeAccordion);
                    }
                },

                _resizeWidgetMenu: function (menu) {
                    var $menu = menu;
                    var $menuStyle = $menu.attr('style');
                    var $shadeStyleObj = {};

                    $menuStyle = $menuStyle.split(';');

                    for (var i in $menuStyle) {
                        var _style = $menuStyle[i].split(':');
                        if (typeof _style[1] != 'undefined') {
                            var _prop = _style[0].trim();
                            var _val = _style[1].trim();
                            $shadeStyleObj[_prop] = _val;
                        }
                    }

                    delete $shadeStyleObj.position;
                    delete $shadeStyleObj.top;
                    delete $shadeStyleObj.display;

                    return $shadeStyleObj;
                },

                _customTextsearchFnHandler: function (event, ui) {

                    /* Supplements for the default autocomplete functions. */
                    event.preventDefault ? event.preventDefault() : (event.returnValue = false);
                    var ev = event;
                    var evType = ev.type;
                    var $widget = $(ev.target).textsearch().textsearch('instance');
                    var $input = $widget.element;
                    var $menu = $widget.menu.element;
                    var _direction = $input.data('direction');
                    var $wrap = $('.ui-textsearch-menu-wrapper[data-direction=' + _direction + ']');
                    var $clearButton = $widget.targetActionButton;
                    var _removeClasses = _hideMenuClass + ' ' + _hideMenuClass_alt;

                    

                    switch (evType) {
                        case 'textsearchopen':

                            $wrap.attr({
                                'aria-expanded': true,
                                'data-open': true
                            }).addClass('ui-front ui-display-absolute-block opening');

                            UI.props._activeMenu = $wrap;

                            if (AE.getSiteViewType() != 'palm') $clearButton.show().removeClass('rotate-scale-out-center').addClass('rotate-scale-in-center');
                            UI.props._shadeStyle = $widget._resizeWidgetMenu($menu);

                            if (_direction == $wrap.attr('data-direction')) $wrap.css(UI.props._shadeStyle).removeClass(_removeClasses);

                            if(AE.props.siteCode == 'FCR') {
                                $wrap.position({
                                    my: 'left top',
                                    at: 'left-10 bottom',
                                    of: $input,
                                    collision: 'none'
                                });
                            }else{
                                $wrap.position({
                                    my: 'left top',
                                    at: 'left bottom',
                                    of: $input,
                                    collision: 'none'
                                });
                            }

                            $menu.css({
                                'top': 0,
                                'left': 0
                            });

                            AE.ui.searchType._scrollToListTop($menu);
                            /* For menusearch variant. */
                            if (UI.props._LAUNCH_MENUSEARCH) $wrap.css('width', $input.outerWidth());
                            if (($wrap.has($menu).length == 0) && ($wrap.attr('data-direction') == $menu.attr('data-direction'))) $wrap.prepend($menu);
                            if ($(AE.ui.props.appendTarget).has($wrap).length == 0) $wrap.appendTo(AE.ui.props.appendTarget);

                            $wrap.addClass(_showMenuClass);

                            return;

                        case 'textsearchclose':

                            $wrap.removeClass(_showMenuClass + ' ' + 'fs-menu' + ' ' + _hideMenuClass_alt).addClass(UI.props._OVERRIDE_MENU_ANIMATION ? _hideMenuClass_alt : _hideMenuClass);

                            if (AE.getSiteViewType() != 'palm') {
                                if (!$input.data('hasVal')) $clearButton.addClass('rotate-scale-out-center').removeClass('rotate-scale-in-center');
                            }

                            UI.props._OVERRIDE_MENU_ANIMATION = false;

                            return setTimeout(function () {
                                if (!$input.data('hasVal') && (AE.getSiteViewType() != 'palm')) $clearButton.hide();
                                $wrap.attr({
                                    'aria-expanded': false,
                                    'data-open': false
                                }).removeClass('ui-display-absolute-block');

                            }, 500);

                        case 'textsearchenable':
                            $input.removeClass('ui-state-disabled').attr({
                                contentEditable: true
                            });
                            return;
                        case 'textsearchdisable':
                            $input.addClass('ui-state-disabled').attr({
                                contentEditable: false
                            });
                            return;
                    }
                }
                
            });


            /***End of $.widget***/
            /*^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^*/
            /*^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^*/
            /*^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^*/

            UI.props.$puLoc.add(UI.props.$doLoc).on('textsearchcreate', function (event, ui) {

                var $item = {};
                var $this = $(this);
                var $widget = $this.data('customTextsearch');
                var _hasVal = $this.data('hasVal');
                var _savedVal = $this.data('savedVal');
                var _placeholder = _hasVal ? _savedVal : $this.attr("data-placeholder-static");
                var $input = $this.data('customTextsearch').element.attr({
                    role: 'textbox',
                    'data-placeholder': _placeholder
                });
                var _direction = $input.data('direction');
                var $searchMenuWrap = $('<div/>').attr({
                    class: 'ui-textsearch-menu-wrapper',
                    id: (_direction == 'pu') ? 'pickup-search-wrapper' : 'dropoff-search-wrapper',
                    'data-direction': _direction,
                    role: 'dialog',
                    'aria-expanded': false,
                    'data-open': false
                });
                var $menu = $this.data('customTextsearch').menu.element.attr({
                    role: 'menu',
                    'data-direction': _direction
                }).wrap($searchMenuWrap);
                var $menuFooter = $ui_textsearchMenuFooter.clone();
                var $icon_clear_input = $('<i/>', {
                    'class': 'ui-textsearch-clear-icon fa',
                    'aria-hidden': true
                });
                var $button_target_input = $('<button/>', {
                    class: 'ui-textsearch-btn-sm ui-textsearch-target-input',
                    role: 'button',
                    title: AE.props.oSearch.TXT_CLEAR_INPUT,
                    'data-direction': _direction,
                    'tabindex': -1
                });


                AE.ui.searchType._objHoverHelper($input);


                var $ev = $.Event('select');
                var _iconClass = 'fa-times fa-2';

                this._isOpen = false;

                $widget.wrapper = $searchMenuWrap;
                $widget.targetActionButton = $button_target_input;
                $menuFooter.insertAfter($menu);

                if (AE.getSiteViewType() == 'palm') {
                    $button_target_input.append($icon_clear_input).insertAfter($input);
                } else {
                    $button_target_input.append($icon_clear_input).hide().insertAfter($input);
                }

                if (UI.props._DISPLAY_ALPHA_LIST && !AE.props.isIE && (UI.props._DISPLAY_COUNTRY_CITIES_LIST || UI.props._DISPLAY_COUNTRY_LIST)) $menu.addClass('ui-append-list-index-helper');
                /* Remove the default autocomplete list. */
                $('ul.ui-autocomplete').remove();

                _iconClass = (AE.getSiteViewType() == 'palm') ? 'fa-times-circle fa-2' : _iconClass;
                $icon_clear_input.addClass(_iconClass);

                if (AE.getSiteViewType() != 'palm') AE.ui.searchType._objHoverHelper($button_target_input);

                var IS_PICKUP = (_direction == 'pu');
                var IS_DROPOFF = (_direction == 'do');
                var $JSON_PREFILL_OBJ = {};
                var $JSON_PICKUP_OBJ = {};
                var $JSON_DROPOFF_OBJ = {};

                var PREFILL_PAGE_DATA = {};
                var CHECK_PU_ISO = '';
                var CHECK_PU_CITY = '';

                var CHECK_DO_ISO = '';
                var CHECK_DO_CITY = '';
                var ALLOW_DROPOFF = false;

                if (USE_STORED_SEARCH) {
                    $JSON_PREFILL_OBJ = (typeof (PREFILL_STORAGE_STR) == 'string') ? JSON.parse(PREFILL_STORAGE_STR) : false;
                    $JSON_PICKUP_OBJ = $JSON_PREFILL_OBJ ? $JSON_PREFILL_OBJ.pu : false;
                    $JSON_DROPOFF_OBJ = $JSON_PREFILL_OBJ ? $JSON_PREFILL_OBJ.drop : false;
                    TRY_PREFILL_PICKUP = false;
                    TRY_PREFILL_DROPOFF = false;
                    if (PREFILL_STORAGE_STR && !$JSON_PREFILL_OBJ.excl_ltr) {
                        TRY_PREFILL_PICKUP = $JSON_PICKUP_OBJ && IS_PICKUP;
                        TRY_PREFILL_DROPOFF = $JSON_DROPOFF_OBJ && IS_DROPOFF;
                    }
                    if($JSON_PREFILL_OBJ.excl_ltr){// Stored LTR Searches have fewer properties WEBAE3-3408 LW
                        var dspLTRlbl = 'Leasing Locations';
                        if($JSON_PICKUP_OBJ && !$JSON_PICKUP_OBJ.display_label) $JSON_PICKUP_OBJ.display_label = $JSON_PICKUP_OBJ.chaos_city_name+' '+dspLTRlbl;
                        if($JSON_DROPOFF_OBJ && !$JSON_DROPOFF_OBJ.display_label) $JSON_DROPOFF_OBJ.display_label = $JSON_DROPOFF_OBJ.chaos_city_name+' '+dspLTRlbl;
                    }   
                } else {
                    PREFILL_PAGE_DATA = UI.props._textsearchPrefillObj;
                    CHECK_PU_ISO = PREFILL_PAGE_DATA.pu.chaos_country_code;
                    CHECK_PU_CITY = PREFILL_PAGE_DATA.pu.chaos_city_name;
                    switch (CHECK_PU_ISO) {
                        case 'UK':
                            CHECK_PU_ISO = 'GB';
                            break;
                    }
                    _fetchPuIso = CHECK_PU_ISO;
                    _fetchPuCityName = CHECK_PU_CITY;
                    _fetchPuCategory = PREFILL_PAGE_DATA.pu.category;
                    TRY_PREFILL_PICKUP = true;
                    CHECK_DO_ISO = PREFILL_PAGE_DATA.drop.chaos_country_code;
                    CHECK_DO_CITY = PREFILL_PAGE_DATA.drop.chaos_city_name;
                    ALLOW_DROPOFF = (CHECK_DO_ISO != '') && (CHECK_DO_CITY != '') && !((CHECK_DO_ISO == CHECK_PU_ISO) && (CHECK_DO_CITY == CHECK_PU_CITY));
                    if (ALLOW_DROPOFF) {
                        _fetchDoIso = CHECK_DO_ISO;
                        _fetchDoCityName = CHECK_DO_CITY;
                        _fetchDoCategory = PREFILL_PAGE_DATA.drop.category;
                        TRY_PREFILL_DROPOFF = true;
                    }
                }

                if (TRY_PREFILL_PICKUP && IS_PICKUP) {
                    $item = (USE_STORED_SEARCH && PREFILL_STORAGE_STR) ? $JSON_PICKUP_OBJ : {
                        display_label: _fetchPuCityName,
                        chaos_country_code: _fetchPuIso,
                        oag: searchPuOAG, 
                        category: _fetchPuCategory
                    }; 
                }

                if (TRY_PREFILL_DROPOFF && IS_DROPOFF) {
                    $item = (USE_STORED_SEARCH && PREFILL_STORAGE_STR) ? $JSON_DROPOFF_OBJ : {
                        display_label: _fetchDoCityName,
                        chaos_country_code: _fetchDoIso,
                        oag: searchDoOAG,
                        category: _fetchDoCategory
                    };
                }

                return (USE_STORED_SEARCH && PREFILL_STORAGE_STR) ? $widget._trigger('select', $ev, {
                    type: 'textsearchselect',
                    item: $item
                }) : $.getJSON($CF_SEARCH_CONTROLLER_REF, {
                    method: $CF_SEARCH_METHOD.textsearchPrefill,
                    city: $item.display_label,
                    countrycode: $item.chaos_country_code,
                    oag: $item.oag

                }).done(function (data) {
                    /* WEBAE3-1201 - prevent DO from attempting fill before PU
                     * Related JS can be found at the bottom of "textsearchselect" */
                    if (_direction == 'pu') {
                        /* Always fill pick-up… */
                        UI.props._puLocHasData = true;
                        return $widget._trigger('select', $ev, {
                            type: 'textsearchselect',
                            item: data.pickupLocation
                        });
                    }

                    if (_direction == 'do' && UI.props._puLocHasData) {
                        /* Fill drop-ff as long as pick-up is already set. */
                        UI.props._doLocHasData = true;
                        return $widget._trigger('select', $ev, {
                            type: 'textsearchselect',
                            item: data.pickupLocation
                        });
                    }

                    if (_direction == 'do' && !UI.props._puLocHasData) {
                        /* If pick-up is not filled - then store the drop-off location in a temp object and trigger it again after pick-up has been selected */
                        return UI.props.$tempDoDataHolder = data;
                    }

                });
            });

            UI.props.$puLoc.add(UI.props.$doLoc).on('textsearchopen', function (event, ui) {

                if (!UI.props._LAUNCH_MENUSEARCH) {
                    if (this._isOpen) return;
                } else {
                    if (UI.props._READY_TO_CLOSE) return;
                }

                this._isOpen = true;
                UI.props._READY_TO_CLOSE = false;

                var $widget = $(this).textsearch().textsearch('instance');
                return $widget._customTextsearchFnHandler(event, ui);
            });

            UI.props.$puLoc.add(UI.props.$doLoc).on('textsearchclose', function (event, ui) {

                if (!this._isOpen) return;
                if (!UI.props._READY_TO_CLOSE) return;
                this._isOpen = false;
                UI.props._READY_TO_CLOSE = true;

                var $widget = $(this).textsearch().textsearch('instance');
                return $widget._customTextsearchFnHandler(event, ui);
            });

            UI.props.$puLoc.add(UI.props.$doLoc).on('textsearchenable', function (event, ui) {
                var $widget = $(this).textsearch().textsearch('instance');
                return $widget._customTextsearchFnHandler(event, ui);
            });

            UI.props.$puLoc.add(UI.props.$doLoc).on('textsearchdisable', function (event, ui) {
                var $widget = $(this).textsearch().textsearch('instance');
                return $widget._customTextsearchFnHandler(event, ui);
            });

            UI.props.$puLoc.add(UI.props.$doLoc).on('textsearchsearch', function (event, ui) {

                var $input = $(this).data('customTextsearch').element;
                var $menu = $(this).data('customTextsearch').menu.element;
                var _inDialog = $('body').find('.ui-dialog');
                var _dialog;

                UI.props._READY_TO_CLOSE = false;
                UI.props._OVERRIDE_MENU_ANIMATION = false;

                if (_inDialog.length != 0) {
                    _dialog = AE.ui.dialog.instance();
                    _dialog.on("dialogclose", function (event, ui) {
                        _dialog.off("dialogclose");
                        UI.props._READY_TO_CLOSE = true;
                        UI.props._OVERRIDE_MENU_ANIMATION = true;
                        return $input.textsearch('close');
                    });
                }

                AE.ui.searchType._scrollToListTop($menu);
            });

            UI.props.$puLoc.add(UI.props.$doLoc).textsearch({
                delay: 0,
                minLength: 3,
                appendTo: AE.ui.props.appendTarget,
                autoFill: true,
                source: function (request, response) {
                    var _request = request.term;
                    var _direction = this.element.data('direction');
                    $.ajax({
                        type: 'GET',
                        url: $CF_SEARCH_CONTROLLER_REF,
                        dataType: 'json',
                        data: {
                            method: $CF_SEARCH_METHOD.textsearch,
                            criteria: _request,
                            affiliateName: AFFILIATE_NAME,
                            operator_id_list: (_direction == 'pu') ? '' : OPERATOR_ID_LIST_TO_FILTER_DO
                        },
                        success: function (data) {
                            var $arr_matches = data.locations;
                            var list_length = Object.keys($arr_matches).length;

                            if (!list_length) {
                                var result = [{
                                    display_label: 'No matches found',
                                    label: response.term,
                                    value: request.term,
                                    category: 'ERROR',
                                    click_count: 0,
                                    locations: {}
                                }];
                                $arr_matches = result;
                            }
                            var gaActionString = ($arr_matches[0].category != 'ERROR') ? 'searchFormLoadSuccess' : 'searchFormLoadError';
                            /* Successful/Failed search term tracking. */
                            AE.ga.gaArrayProcess([{
                                GACATEGORY: 'carTextSearch',
                                GAACTION: gaActionString,
                                GALABEL: _request
                            }]);
                            return response($arr_matches);
                        }
                    });
                },
                select: function (event, ui) {
                    UI.props._DISPLAY_COUNTRY_LIST = false;
                    UI.props._DISPLAY_COUNTRY_CITIES_LIST = false;
// RETURNING TO HOME PAGE AFTER LTR SEARCH NEEDS TO REPOPULATE TEXT SEARCH BETTER
                    if ((typeof (ui.item) == 'undefined') || (!Object.keys(ui.item).length)) { return false; }

                    var $widget = $(this).textsearch().textsearch('instance');
                    var $input = $(this).data('customTextsearch').element;
                    var $menu = $(this).data('customTextsearch').menu.element;
                    var $event = event || window.event;
                    var $item = ui.item;
                    var _direction = $input.data('direction');
                    var displayLabel = $item.display_label;
                    var category = $item.category;
                    var chaosCityName = $item.chaos_city_name;
                    var chaosCountryCode = $item.chaos_country_code;
                    var countryLabel = $item.country_label;
                    var chaosCityId = $item.chaos_city_id || false;
                    var _triggerCountryList = (category == _CNT);
                    var _triggerCityList = (category == _CTY + '-EXPANDABLE');
                    var operatorIdList = $item.operator_id_list;
                    var evTarget = $event.currentTarget;
                    var addCogToListItem = $(evTarget).attr('data-city') == 'false' ? true : false;
                    var chaosCountryLabel;

                    $item.loc_type = category;

                    PREVENT_INPUT_BLUR = (_triggerCountryList || _triggerCityList) ? true : false;

                    if (addCogToListItem) { $(evTarget).find('.ui-menu-item-wrapper i').addClass('fa-cog fa-spin'); }

                    // Initiate country or city lists - Exit textsearchselect as these are tiered lists
                    if (PREVENT_INPUT_BLUR) {
                        UI.props._READY_TO_CLOSE = false;
                        UI.props._DISPLAY_COUNTRY_LIST = false;
                        UI.props._DISPLAY_COUNTRY_CITIES_LIST = true;

                        chaosCountryLabel = (category == _CNT) ? countryLabel : '';

                        // Initiate country list
                        if (_triggerCountryList) { return $widget._populateMenusearchCityList($menu, $item, chaosCountryLabel); }
                        // Initiate city list (accordions)
                        if (_triggerCityList) { return $widget._setMenuItemAccordion(evTarget, chaosCityId, chaosCityName, chaosCountryCode); }
                    }

                    // Set up the returned object
                    if (_direction == 'pu') {
                        // Set to sort operator IDs in DO
                        OPERATOR_ID_LIST_TO_FILTER_DO = operatorIdList;
                        UI.props.$RES_OBJ_FOR_BOOKING.pu = $item;
                        UI.props.$RES_OBJ_FOR_BOOKING.drop = false;
                    } else if (_direction == 'do') {
                        UI.props.$RES_OBJ_FOR_BOOKING.drop = $item;

                        var puDisplayLabel = false;
                        if (_.has(UI.props.$RES_OBJ_FOR_BOOKING, 'pu')) {
                            if (_.has(UI.props.$RES_OBJ_FOR_BOOKING.pu, 'display_label')) {
                                puDisplayLabel = UI.props.$RES_OBJ_FOR_BOOKING.pu.display_label;
                            } else if (_.has(UI.props.$RES_OBJ_FOR_BOOKING.pu, 'locations')) {
                                puDisplayLabel = UI.props.$RES_OBJ_FOR_BOOKING.pu.locations.display_label || false;
                            }
                        }

                        var doDisplayLabel = false;
                        if($item.loc_type === undefined){
                            doDisplayLabel = $item.chaos_city_name || false;
                        } else {
                            doDisplayLabel = $item.display_label || $item.locations.display_label;
                        }
                        
                        puDisplayLabel = puDisplayLabel ? puDisplayLabel : false;
                        doDisplayLabel = doDisplayLabel ? doDisplayLabel : false;

                        if (!puDisplayLabel && searchPuCity && searchPuCity !== '') { puDisplayLabel = searchPuCity; }
                        if (!doDisplayLabel && searchDoCity && searchDoCity !== '') { doDisplayLabel = searchDoCity; }

                        if (puDisplayLabel == doDisplayLabel) { UI.props.$RES_OBJ_FOR_BOOKING.drop = false; }
                        if (doDisplayLabel && (puDisplayLabel != doDisplayLabel) && !UI.props.$chkDiff.is(':checked')) { UI.props.$chkDiff.trigger('click'); }
                    }

                    UI.props._READY_TO_CLOSE = true;
                    UI.props._OVERRIDE_MENU_ANIMATION = false;

                    AE.ui.searchType._updateInputValue($input, displayLabel);
                    // Pickup has been changed, reset dropoff
                    if (_direction == 'do' && !UI.props.$RES_OBJ_FOR_BOOKING.drop) { AE.ui.searchType._updateInputValue($input, ''); }
                    // Set itinerary value to hand off to booking
                    AE.ui.search.autocomplete.setValue(UI.props.$RES_OBJ_FOR_BOOKING);

                    $input.textsearch('close');

                    $('#grab-focus').trigger('focus');

                    AE.ga.gaArrayProcess([{
                        GACATEGORY: 'carTextSearch',
                        GAACTION: 'searchFormSelect',
                        GALABEL: ($item.loc_type == 'CITY') ? 'ALL Downtown' : $item.loc_type
                    }]);
                    if (!UI.props.$RES_OBJ_FOR_BOOKING.drop) AE.ga.gaArrayProcess([{
                        GACATEGORY: 'carSearch',
                        GAACTION: 'oneWaySelect'
                    }]);

                    /* WEBAE3-1201 - prevent DO from attempting fill before PU
                     * Related JS can be found in "done()" function of textsearchcreate */
                    if (_direction == 'pu' && UI.props._puLocHasData && !UI.props._doLocHasData && UI.props.$tempDoDataHolder.hasOwnProperty('pickupLocation')) {
                        var $ev = $.Event('select');
                        $ev.target = UI.props.$doLoc;
                        UI.props._doLocHasData = true;
                        return $widget._trigger('select', $ev, {
                            type: 'textsearchselect',
                            item: UI.props.$tempDoDataHolder.pickupLocation
                        });
                    }
                }
            });


            UI.props.$puLoc.add(UI.props.$doLoc).on('keydown', function (event) {
                    /*KeyDown because KeyUp cannot be assigned to contentEditable*/
                    var input = event.target;
                    var key = event.charCode ? event.charCode : event.keyCode ? event.keyCode : 0;

                    switch (key) {
                        /* quote/apostrophe - simari 12/15/17 */
                        /* case 222:
                             event.preventDefault ? event.preventDefault() : ( event.returnValue = false );
                             return false; */
                        /* space - simari 12/15/17
                         * jQuery autocomplete was not handling the space correctly x-browser,
                         * [case 32] should be left in here. */
                        case 32:
                            var _updateTextString = input.innerHTML.replace(/<br\s*\/?>/gi, '') + '&nbsp;';
                            _updateTextString = _updateTextString.replace('&nbsp;&nbsp;', '&nbsp;');
                            _updateTextString = encodeURIComponent(_updateTextString);

                            event.preventDefault ? event.preventDefault() : (event.returnValue = false);
                            event.originalEvent.returnValue = true;

                            _updateTextString = decodeURIComponent(_updateTextString);
                            input.innerHTML = _updateTextString;
                            return AE.ui.searchType._cursorToEndOfString(input);
                        default:
                            return true;
                    }
                })
                .on('input', function (event) {
                    var $input = $(event.target);
                    var _direction = $input.data('direction');

                    UI.props._DISPLAY_COUNTRY_LIST = false;
                    UI.props._DISPLAY_COUNTRY_CITIES_LIST = false;

                    if ((_direction == 'do') && !UI.props.$puLoc.data('hasVal')) {
                        UI.props.$doLoc.text('');
                        return UI.props.$puLoc.trigger('customFocus');
                    }

                    return true;
                })
                .on('focus', function (event) {

                    UI.props._DISPLAY_COUNTRY_LIST = false;
                    UI.props._DISPLAY_COUNTRY_CITIES_LIST = false;
                    UI.props._LAUNCH_MENUSEARCH = false;
                    if (AE.legacy.grief.whichIE.isIE9 || AE.legacy.grief.whichIE.isIE10) {
                        $(this).addClass('hide-cursor-ie-patch');
                    }
                    event.stopPropagation();
                    return $(this).trigger('customFocus');
                })
                .on('blur', function (event) {
                    event.stopPropagation();
                    return $(this).trigger('customBlur');
                })
                .on('customFocus', function (event) {
                    var $input = $(event.target);
                    var _direction = $input.data('direction');

                    $input.addClass('ui-state-focus');
                    $input.attr({
                        'data-placeholder': $input.data('savedVal'),
                        tabindex: 0
                    });

                    if (AE.getSiteViewType() == 'palm') {

                        if ($input.hasClass('ui-state-disabled')) {
                            event.preventDefault ? event.preventDefault() : (event.returnValue = false);
                            event.stopPropagation();
                            return false;
                        }

                        if( AE.props.siteCode !== 'FCR' ) {
                            AE.ui.devices._show($input);
                        } else {
                            
                            // scroll to pickup field then stop the page from scrolling to ensure menu is visible
                            var pukeycount = 0;
                            $('div[name^="pickup-wrapper"]').keydown(function() { 
                                pukeycount =  pukeycount + 1
                                if (pukeycount === 1) {
                                    
                                    var $container = $('div'),
                                    $scrollTo = $('div[name^="pickup-input_text_wrapper"]');
                                    $container.scrollTop(
                                        $scrollTo.offset().top - $container.offset().top + $container.scrollTop()
                                    );
                                    
                                    $("#scroll-content").css("overflow", "hidden");
                                    $("#pickup-search-wrapper").css("max-height", "200px");
                                    $("#pickup-search-wrapper").css("overflow", "scroll");
                                }

                               
                
                            });

                            $('div[name^="pickup-wrapper"]').click(function() { 
                                pukeycount = 0
                            });


                            // scroll to dropoff field then stop the page from scrolling to ensure menu is visible
                            var dokeycount = 0;
                            $('div[name^="dropoff-wrapper"]').keydown(function() { 
                                dokeycount =  dokeycount + 1
                                if (dokeycount === 1) {
                                    
                                    var $container = $('div'),
                                    $scrollTo = $('div[name^="dropoff-input_text_wrapper"]');
                                    $container.scrollTop(
                                        $scrollTo.offset().top - $container.offset().top + $container.scrollTop()
                                    );
                                    
                                    $("#scroll-content").css("overflow", "hidden");
                                    $("#dropoff-search-wrapper").css("max-height", "200px");
                                    $("#dropoff-search-wrapper").css("overflow", "scroll");
                                }

                               
                
                            });

                            $('div[name^="dropoff-wrapper"]').click(function() { 
                                dokeycount = 0
                            });

                            // cleanup after menu selection is made
                            $("body").click(function() { 
                                $("#scroll-content").css("overflow", "");
                                $("#pickup-search-wrapper").css("max-height", "");
                                $("#pickup-search-wrapper").css("overflow", "");
                                $("#scroll-content").css("overflow", "");
                                $("#dropoff-search-wrapper").css("max-height", "");
                                $("#dropoff-search-wrapper").css("overflow", "");
                            });


                        
                        }
                        
                        


                    }

                    if ($input.data('hasVal')) $input.text('');

                    $input.attr({
                        'data-placeholder': ($input.attr('data-placeholder') == '') ? $input.attr('data-placeholder-static') : $input.data('savedVal')
                    });

                    if ((_direction == 'do') && !UI.props.$puLoc.data('hasVal')) {
                        $input.attr({
                            'data-placeholder': $input.attr('data-placeholder-static')
                        });
                        return AE.ui.searchType._throwWarningFlag($input, UI.props.msg_pickupFirst, UI.props.msg_inputEmpty, {
                            top: 50,
                            left: -5
                        }, 'arrow-left');
                    }
                })
                .on('customBlur', function (event) {
                    var $input = $(event.target);
                    var _direction = $input.data('direction');

                    if (PREVENT_INPUT_BLUR) {
                        event.stopPropagation();
                        return $input.trigger('customFocus');
                    }

                    if ((AE.getSiteViewType() == 'palm') && UI.props._READY_TO_CLOSE) AE.ui.devices._hide($input);

                    $input.removeClass('ui-state-focus');
                    $input.data('hasVal') ? $input.text($input.data('savedVal')) : $input.text('');
                    $input.attr({
                        'data-placeholder': ($input.attr('data-placeholder') == '') ? $input.attr('data-placeholder-static') : $input.data('savedVal'),
                        tabindex: -1
                    });

                    if (_direction == 'do' && (UI.props.$puLoc.text() == UI.props.$doLoc.text())) {
                        $input.text('');
                    }
                });

        },

        onBodyClick: function (event, target) {

            var $target = $(target);
            var $wrap = $('.ui-textsearch-menu-wrapper[aria-expanded=true]');
            var _direction = ($wrap.length != 0) ? $wrap.attr('data-direction') : $target.attr('data-direction');
            var $input = (_direction == 'pu') ? UI.props.$puLoc : UI.props.$doLoc;
            var $widget = $input.data('customTextsearch');
            var $menu = $widget.menu.element;
            var isBtn = $target.prop("tagName").toLowerCase() == 'button';
            var isTextsearchInput = $target.hasClass('ui-textsearch-input');
            var isTextsearchMenuItem = $target.parent('dd').is('[role=menuitem]');
            var isInputResetBtn = $target.hasClass('ui-reset-input');
            var isScrollToTopBtn = $target.hasClass('ui-textsearch-scroll-btn');
            var isBackToListBtn = $target.hasClass('ui-back-to-list');
            var isTargetInputBtn = $target.hasClass('ui-textsearch-target-input');
            var isAlphaListHelperBtn = $target.hasClass('ui-textsearch-alpha-index-list-item');
            var _preventDefault = (isBtn && (isInputResetBtn || isBackToListBtn || isScrollToTopBtn || isTargetInputBtn)) || isAlphaListHelperBtn || isTextsearchMenuItem;
            var wrapDir, inputDir, dontClose;

           
            if (_preventDefault) {
                event.preventDefault ? event.preventDefault() : (event.returnValue = false);
            }

            if (isTextsearchInput) {
                /* Target is a search input, setting some variables. */
                wrapDir = $wrap.data('direction');
                inputDir = $target.data('direction');
                dontClose = (wrapDir == inputDir);
            }

            if (isBtn) {

                if (isInputResetBtn) {
                    // event.preventDefault ? event.preventDefault() : (event.returnValue = false);
                    /* Target is reset-input button in DO menu. */
                    $input = UI.props.$doLoc;
                    AE.ui.searchType._updateInputValue($input, '');
                    UI.props.$RES_OBJ_FOR_BOOKING.drop = false;
                    UI.props._READY_TO_CLOSE = true;
                    UI.props._OVERRIDE_MENU_ANIMATION = false;
                    AE.ui.search.autocomplete.setValue(UI.props.$RES_OBJ_FOR_BOOKING);
                    return $input.textsearch('close');
                }

                if (isBackToListBtn) {
                    // event.preventDefault ? event.preventDefault() : (event.returnValue = false);
                    /* Target is back-to-list (country) button. */
                    UI.props._DISPLAY_COUNTRY_LIST = true;
                    return $widget._populateMenusearchCountryList($menu);
                }

                if (isScrollToTopBtn) {
                    // event.preventDefault ? event.preventDefault() : (event.returnValue = false);
                    /* Target is scroll-to-top button in menu footer. */
                    return AE.ui.searchType._scrollToListTop($menu);
                }

                if (isTargetInputBtn) {
                    // event.preventDefault ? event.preventDefault() : (event.returnValue = false);
                    /* Target is the clear-input button. */
                    UI.props.$RES_OBJ_FOR_BOOKING = (_direction == 'pu') ? {
                        'pu': false,
                        'drop': false
                    } : {
                        'pu': UI.props.$RES_OBJ_FOR_BOOKING.pu,
                        'drop': false
                    };
                    if (UI.props._LAUNCH_MENUSEARCH) {
                        UI.props._READY_TO_CLOSE = false;
                        $input.textsearch('open');
                    } else {
                        UI.props._READY_TO_CLOSE = true;
                        UI.props._OVERRIDE_MENU_ANIMATION = false;
                        AE.ui.searchType._clearInput($input);
                        /* If target attempts to clear the PU input, hide the button in DO as well. */
                        if (_direction == 'pu') UI.props.$doLoc.textsearch().textsearch('instance').targetActionButton.hide();
                        $input.textsearch('close');
                    }
                    return AE.ui.search.autocomplete.setValue(UI.props.$RES_OBJ_FOR_BOOKING);
                }
            } else {
                if (isAlphaListHelperBtn) {
                    // event.preventDefault ? event.preventDefault() : (event.returnValue = false);
                    /* Target is a character in the right-side alphabetical menu, visible on city lists per country. */
                    var $scrollTarget = $(target).attr('aria-controls');
                    var $scrollObj = $('#' + $scrollTarget);
                    return AE.ui.searchType._scrollToTopOfContainer($scrollObj);
                }
            }

            if (isTextsearchMenuItem) {
                // event.preventDefault ? event.preventDefault() : (event.returnValue = false);
                /* Target is a search menu-item. */
                var $this = $target.parent('dd');
                var $item = $this.data('iObj');
                var $event = event || window.event;
                var $ev = $.Event($event);

                $ev.target = $this;
                $ev.currentTarget = $this;

                return $widget._trigger('select', $ev, {
                    type: 'textsearchselect',
                    item: $item
                });
            }

            if (dontClose) {
                /* Target is a search input, don't hide the menu. */
            } else if (UI.props._activeMenu && target && $wrap.length && UI.props._activeMenu.has(target).length) {
                /* Target is contained in the active menu, okay to hide the menu. */
            } else {
                UI.props._OVERRIDE_MENU_ANIMATION = !target.is('[class^=ui-textsearch]');
                UI.props._READY_TO_CLOSE = true;
                return $input.textsearch('close');
            }

            if (isTextsearchInput && (UI.props._LAUNCH_MENUSEARCH || (!UI.props._LAUNCH_MENUSEARCH && !AE.props.isIE))) {
                UI.props._DISPLAY_COUNTRY_LIST = true;
                UI.props._DISPLAY_COUNTRY_CITIES_LIST = true;
                return $target.trigger('customFocus');
            }
        },
        manageResize: function (event) {

            var $wrap = $('.ui-textsearch-menu-wrapper[aria-expanded=true]') || UI.props._activeMenu;
            var _direction = $wrap.attr('data-direction');
            var $input = (_direction == 'pu') ? UI.props.$puLoc : UI.props.$doLoc;
            var $viewSize = AE.getSiteViewType();

            if ($viewSize === 'palm' && AE.ui.searchType.props.$viewSize !== $viewSize) location.reload();

            if ($wrap.length) {
                UI.props._OVERRIDE_MENU_ANIMATION = true;
                UI.props._READY_TO_CLOSE = true;
                return $input.textsearch('close');
            } else {
                return false;
            }
        }
    };

    return UI;
})();
;var AE = AE || {}; /* Add to Base object or create it if it doesn't exist. */

AE.ui.searchType.menu = AE.ui.searchType.menu || (function () {
    'use strict';

    var vouchDateTime = ((typeof (oBKdateTime) != 'undefined') && !_.isEmpty(oBKdateTime)) ? oBKdateTime : false;

    /* Use to prefill "manage my booking" if all properties exist. */
    if (vouchDateTime)
        for (var i in vouchDateTime) {
            var testProp = vouchDateTime[i] || '';
            vouchDateTime = !_.isEmpty(testProp) ? vouchDateTime : false;
        }
    /*
    DEPENDENCIES: AE, AE.ui, AE.ui.searchType
    */
    var UI = {
        init: function () {
            UI.props = {
                cfcRef: '/plugins/ae3/lib/searchController.cfc',
                oPrefill: {
                    PU: {
                        ran: false,
                        country: '',
                        city: '',
                        loclist: ''
                    },
                    DO: {
                        ran: false,
                        country: '',
                        city: '',
                        loclist: ''
                    },
                    OW: {
                        city: false,
                        country: false
                    }
                },
                inModify: false,
                $do: $('div[name="dropoff-wrapper"].menusearch'),
                $chkDiffs: $('input.chk-diff-linked')
            };

            UI.props.$chkDiffs.prop('checked', false);
            var $voucherNewSearchContainer = $('#toggleeNewSearch');
            if ($voucherNewSearchContainer[0]) {
                UI.props.inModify = true;
            }
            UI.state = {
                synchingChkDiff: false,
                operator_id_list: '',
                PU: {
                    country: '',
                    city: '',
                    loc: '',
                    cities: {},
                    hubs: []
                },
                DO: {
                    country: '',
                    city: '',
                    loc: '',
                    cities: {},
                    hubs: []
                },
                OW: {
                    country: false,
                    city: false
                }
            };
            $('#locations-wrapper .menusearch').css('paddingLeft', '3px');
            $('#locations-wrapper .menusearch label.location-label').css('marginLeft', '-3px');
            $('#locations-wrapper .menusearch .menusearch--container .styled--select select option').removeClass('visuallyhidden');
            AE.ui.addBodyChangeTask({
                func: UI.onBodyChange
            });
            AE.ui.addBodyClickTask({
                func: UI.onBodyClick
            });
            UI.prefill();
        },
        menuSearchSelectInit: function ($target) {
            var oProps = {
                direction: $target.attr('name').substring(0, 2),
                splitID: $target.attr('id').split('_'),
                value: $target.val(),
                display_label: $target.val(),
                selectType: '',
                ID: 0,
                baseID: $target.attr('id')
            };
            if (oProps.splitID.length > 1) {
                oProps.selectType = oProps.splitID[0];
                oProps.baseID = oProps.splitID[1];
            }
            if (oProps.value === null) {
                oProps.value = UI.props.oPrefill[oProps.direction][oProps.selectType];
                if ($target.hasClass('trg__menusearch--city')) {
                    oProps.value = UI.state[oProps.direction].cities[oProps.value] || '--';
                }
            }
            var $selected = $($target).find('option[value="' + oProps.value + '"]');
            oProps.display_label = $selected.html();
            oProps.ID = $selected.attr('id');
            $('#' + oProps.baseID + ' .ui-state-invalid').removeClass('ui-state-invalid');
            if (oProps.direction === 'PU' && oProps.selectType !== 'country') {
                UI.state.operator_id_list = $selected.data('opid-list');
            }
            if (oProps.value !== null) {
                UI.state[oProps.direction][oProps.selectType] = oProps.value || '';
            }
            if (UI.props.oPrefill[oProps.direction].ran) {
                UI.clearInput(oProps.direction, $target);
            }
            if (!$target.hasClass('trg__menusearch--loc')) {
                // $target.parent('.styled--select').addClass('visuallyhidden');
                if (UI.state.PU.country !== '' && UI.state.DO.country !== '' && UI.state.PU.country !== UI.state.DO.country) {
                    UI.state.OW.country = true;
                }
                if (UI.state.PU.city !== '' && UI.state.DO.city !== '' && UI.state.PU.city !== UI.state.DO.city) {
                    UI.state.OW.city = true;
                }
                if (UI.state.OW.country || (!UI.state.OW.country && UI.state.OW.city)) {
                    if (UI.state.DO.loc !== '') {
                        UI.checkTheOneWayBox();
                    }
                }
            }

            return oProps;
        },
        handleCountryMenuSelect: function ($target) {
            var oProps = UI.menuSearchSelectInit($target);
            $.ajax({
                url: UI.props.cfcRef,
                dataType: 'json',
                data: {
                    method: 'getLocalizedCities',
                    chaos_country_code: oProps.value,
                    returnTopCities: AEdata.returnTopCities,
                    affiliateName: AEdata.affiliateName,
                    operator_id_list: (oProps.direction === 'PU') ? '' : UI.state.operator_id_list || ''
                },
                beforeSend: function(){
                    //WEBAE3-4265
                    UI.resetInput('country',oProps.direction,oProps.baseID);
                },
                success: function (data) {
                    var $citySelect = $('#city_' + oProps.baseID),
                        $df = $(document.createDocumentFragment());
                        if(UI.props.$chkDiffs.prop('checked') && oProps.direction =='DO' && oProps.selectType == 'country'){searchPuCity='';}

                        _.each(data, function (tempCity) {
                            UI.state[oProps.direction].cities[tempCity.chaos_city_name] = tempCity.chaos_city_id;
                            if (  tempCity.hasOwnProperty("optgroup") && tempCity.optgroup ) {
                                $df.append($('<option disabled>' + tempCity.display_label + '</option>', { label: tempCity.display_label }));
                                //$df.append($('<optgroup/>', { label: tempCity.display_label }));
                            } else {
                                $df.append($('<option/>', {
                                    'id': tempCity.chaos_city_id + '-' + tempCity.chaos_city_name + oProps.direction,
                                    'value': tempCity.chaos_city_id,
                                    'data-opid-list': tempCity.operator_id_list,
                                    'html': tempCity.display_label,
                                    'selected': (searchPuCity != '') ? (tempCity.chaos_city_name.toUpperCase() == searchPuCity.toUpperCase() ? tempCity.chaos_city_name : false) : false
                                }));
                            }
                        });

                        var _baseId = $target.closest('.menusearch--container').attr('id');
                        $('#city_' + _baseId).change();

                    if (data.length == 0)
                        $target.val('--');


                    /*$('#searchcrumbs_'+oProps.baseID+' .searchcrumbs--country').addClass('trg__menusearch--country-x').html(
                    	$( document.createDocumentFragment() ).append(
                    		$('<img/>',{
                    			src:AE.props.muraThemePath+'/images/flags/'+oProps.value+'.png',
                    			alt:oProps.display_label
                    		}),
                    		'&nbsp;'+oProps.display_label+'&nbsp;'
                    	)
                    );
                    AE.heightAdjust('.searchcrumbs_container');*/
                    UI.state[oProps.direction].city = '';
                    $citySelect.empty().append($('<option/>', {
                        value: '--',
                        html: AEdata.menuPrompts[oProps.direction].CITY
                    }), $df);
                   
                    $('#loc_' + oProps.baseID).empty().append($('<option/>', {
                        value: '--',
                        html: AEdata.menuPrompts[oProps.direction].HUB
                    }));
                

                    if (!UI.props.oPrefill[oProps.direction].ran) {
                        if (oProps.direction !== 'DO' || UI.props.oPrefill.OW.country || (!UI.props.oPrefill.OW.country && UI.props.oPrefill.OW.city)) {
                            $citySelect.val(UI.state[oProps.direction].cities[UI.props.oPrefill[oProps.direction].city.toUpperCase()] || '--');
                            $citySelect.change();
                        } else {
                            UI.props.oPrefill[oProps.direction].ran = true;
                        }
                    }
                }

            });
        },
        handleCityMenuSelect: function ($target) {
            var oProps = UI.menuSearchSelectInit($target),
                $locSelect = $('#loc_' + oProps.baseID),
                locPrompt = AEdata.menuPrompts[oProps.direction].HUB;
            
            if (oProps.value !== '--') {
                $.ajax({
                    url: UI.props.cfcRef,
                    dataType: 'json',
                    data: {
                        method: 'textsearchCityLocs',
                        sitecode: AE.props.siteCode,
                        affiliateName: AEdata.affiliateName,
                        chaos_city_id: oProps.value,
                        oag: searchPuOAG,
                        operator_id_list: (oProps.direction === 'PU') ? '' : UI.state.operator_id_list
                    },
                beforeSend: function(){
                    //WEBAE3-4265
                    UI.resetInput('city',oProps.direction,oProps.baseID);
                },
                    success: function (data) {
                        data.locations = data.locations || {};
                        var $df = $(document.createDocumentFragment()),
                            oCity = data.locations[0] || {},
                            activatedHubs = [],
                            labelHtmlTxt;

                        if (oCity && oCity.locations && oCity.locations.length) {
                            activatedHubs = _.filter(oCity.locations, function (tempLoc) {
                                return !_.isEmpty(tempLoc.desk_list.toString());
                            });
                        }
                        if (activatedHubs.length) {
                            UI.state[oProps.direction].hubs = _.sortBy(activatedHubs, function (tempLoc) {
                                return tempLoc.click_count;
                            }).reverse();
                            var groupedHubs = _.groupBy(UI.state[oProps.direction].hubs, 'category');
                            var aMissingParentHubs = [];
                            if (groupedHubs['AIRPORT_TERMINAL--ITEM']){
                                groupedHubs.TERMINALS = _.groupBy(groupedHubs['AIRPORT_TERMINAL--ITEM'], 'parent_hub_id');
                                _.each(_.keys(groupedHubs.TERMINALS), function (tempKey){
                                    aMissingParentHubs.push(Number(tempKey));
                                });
                                aMissingParentHubs = _.difference(aMissingParentHubs,_.pluck(groupedHubs.AIRPORT,'chaos_hub_id'));
                            }
                            if (groupedHubs.AIRPORT) {
                                labelHtmlTxt = AE.ui.decodeHtml(AEdata.hubLabels.AIRPORT);
                                var $airHubs = $('<optgroup/>', {
                                    'label': labelHtmlTxt
                                });
                                $df.append($airHubs);

                                $airHubs.attr('label', decodeURI(labelHtmlTxt)); //decodeURI(enc);
                                _.each(groupedHubs.AIRPORT, function (tempAirHub) {
                                    if (groupedHubs.TERMINALS && groupedHubs.TERMINALS[tempAirHub.chaos_hub_id]) {

                                        _.each(groupedHubs.TERMINALS[tempAirHub.chaos_hub_id], function (tempTerminal) {
                                            $airHubs.append($('<option/>', {
                                                'id': tempTerminal.chaos_hub_id,
                                                'value': tempTerminal.desk_list,
                                                'data-opid-list': tempTerminal.operator_id_list,
                                                'html': tempTerminal.display_label
                                            }));
                                        });
                                    } else {
                                        $airHubs.append($('<option/>', {
                                            'id': tempAirHub.chaos_hub_id,
                                            'value': tempAirHub.desk_list,
                                            'data-opid-list': tempAirHub.operator_id_list,
                                            'html': tempAirHub.display_label
                                        }));
                                    }
                                });
                                if(aMissingParentHubs.length) {
                                    _.each(aMissingParentHubs, function (tempParentID) {
                                        _.each(groupedHubs.TERMINALS[tempParentID], function (tempTerminal){
                                            $airHubs.append($('<option/>', {
                                                'id': tempTerminal.chaos_hub_id,
                                                'value': tempTerminal.desk_list,
                                                'data-opid-list': tempTerminal.operator_id_list,
                                                'html': tempTerminal.display_label
                                            }));
                                        });
                                    });
                                }
                            }
                            // WEBAE3-4649 There are orphaned terminals and no airport hubs, so we create a home for them
                            if(aMissingParentHubs.length && !groupedHubs.AIRPORT) {
                                labelHtmlTxt = AE.ui.decodeHtml(AEdata.hubLabels.AIRPORT);
                                var $airHubs = $('<optgroup/>', {
                                    'label': labelHtmlTxt
                                });
                                $df.append($airHubs);
                                _.each(aMissingParentHubs, function (tempParentID) {
                                    _.each(groupedHubs.TERMINALS[tempParentID], function (tempTerminal) {
                                        $airHubs.append($('<option/>', {
                                            'id': tempTerminal.chaos_hub_id,
                                            'value': tempTerminal.desk_list,
                                            'data-opid-list': tempTerminal.operator_id_list,
                                            'html': tempTerminal.display_label
                                        }));
                                    });
                                });
                            }
                            if (groupedHubs.RAIL) {
                                labelHtmlTxt = AE.ui.decodeHtml(AEdata.hubLabels.RAIL);
                                var $railHubs = $('<optgroup/>', {
                                    'label': labelHtmlTxt
                                });
                                $df.append($railHubs);
                                _.each(groupedHubs.RAIL, function (tempRailHub) {
                                    $railHubs.append($('<option/>', {
                                        'id': tempRailHub.chaos_hub_id,
                                        'value': tempRailHub.desk_list,
                                        'data-opid-list': tempRailHub.operator_id_list,
                                        'html': tempRailHub.display_label
                                    }));
                                });
                            }
                            if (groupedHubs.FERRY) {
                                labelHtmlTxt = AE.ui.decodeHtml(AEdata.hubLabels.FERRY);
                                var $ferryHubs = $('<optgroup/>', {
                                    'label': labelHtmlTxt
                                });
                                $df.append($ferryHubs);
                                _.each(groupedHubs.FERRY, function (tempFerryHub) {
                                    $ferryHubs.append($('<option/>', {
                                        'id': tempFerryHub.chaos_hub_id,
                                        'value': tempFerryHub.desk_list,
                                        'data-opid-list': tempFerryHub.operator_id_list,
                                        'html': tempFerryHub.display_label
                                    }));
                                });
                            }
                            if (groupedHubs.CITY) {
                                labelHtmlTxt = AE.ui.decodeHtml(AEdata.hubLabels.CITY);
                                var $cityHubs = $('<optgroup/>', {
                                    'label': labelHtmlTxt
                                });
                                $df.append($cityHubs);
                                _.each(groupedHubs.CITY, function (tempCityHub) {
                                    $cityHubs.append($('<option/>', {
                                        'id': tempCityHub.chaos_hub_id,
                                        'value': tempCityHub.desk_list,
                                        'data-opid-list': tempCityHub.operator_id_list,
                                        'html': tempCityHub.display_label
                                    }));
                                });
                            }
                            /*$('#searchcrumbs_'+oProps.baseID+' .searchcrumbs--city').addClass('trg__menusearch--city-x').html(
                            	$( document.createDocumentFragment() ).append(
                            		'&nbsp;',
                            		$('<i/>',{
                            			class:'fa fa-angle-double-right'
                            		}),
                            		'&nbsp;'+oProps.display_label+'&nbsp;'
                            	)
                            );
                            AE.heightAdjust('.searchcrumbs_container');*/
                        } else {
                            locPrompt = warnNoLocationsVague || '-----';
                        }
                        $locSelect.empty().append($('<option/>', {
                            value: '--',
                            html: locPrompt
                        }), $df);
                        
                        if (!UI.props.oPrefill[oProps.direction].ran && _.has(AEdata, 'menuPrefill') && _.has(AEdata.menuPrefill, 'LOCLIST') && _.has(AEdata.menuPrefill, 'DOLOCLIST')) {
                            if (oProps.direction !== 'DO' || UI.props.oPrefill.OW.country || (!UI.props.oPrefill.OW.country && UI.props.oPrefill.OW.city)) {
                                var compareLocList = (oProps.direction !== 'DO') ? AEdata.menuPrefill.LOCLIST.toString() : AEdata.menuPrefill.DOLOCLIST.toString();
                                var compareLocId = (oProps.direction !== 'DO') ? AE.ui.search.getStoredSearch().puchaos_hub_id : AE.ui.search.getStoredSearch().dochaos_hub_id;
                                var optionToSelect = _.filter($locSelect.find('optgroup option'), function (thisOption) {
                                    var thisLocList = $(thisOption).attr('value');
                                    var commonLocList = _.intersection(thisLocList.split(','), compareLocList.split(','));
                                    var thisLocId = (typeof thisOption === 'undefined') ? 0 : thisOption.getAttribute( 'id' );
                                    
                                    var matchMaker = false;
                                    if (thisLocId != 0) {
                                        matchMaker = (compareLocId == thisLocId) ? true : false ;
                                    } else {
                                        matchMaker = (commonLocList.length > 0) ? true : false ;
                                    }
                                   
                                    return matchMaker;
                                });
                                if (optionToSelect[0]) {
                                    $locSelect.val(optionToSelect[0].value);
                                    $locSelect.change();
                                }
                            }
                        }
                        UI.props.oPrefill[oProps.direction].ran = true;
                    }
                });
            } else {
                $locSelect.empty().append($('<option/>', {
                    value: '--',
                    html: locPrompt
                }));
            }
        },
        handleLocMenuSelect: function ($target) {
            var oProps = UI.menuSearchSelectInit($target);
            
            if (oProps.value !== '--' && oProps.value !== '') {
                var oHub = _.findWhere(UI.state[oProps.direction].hubs, {
                        chaos_hub_id: Number(oProps.ID)
                    }),
                    oValues = {
                        chaos_hub_id: oHub.chaos_hub_id,
                        chaos_city_name: oHub.chaos_city_name,
                        chaos_country_code: oHub.chaos_country_code,
                        iso_country_code: oHub.chaos_country_code,
                        desk_list: oHub.desk_list,
                        hub_name: oHub.title,
                        loc_type: oHub.category,
                        display_label: oHub.display_label
                    };
                AE.ui.search.setValue({
                    name: (oProps.direction === 'DO') ? 'dropoff-loc' : 'pickup-loc',
                    item: {
                        pu: (oProps.direction === 'DO') ? false : oValues,
                        drop: (oProps.direction === 'DO') ? oValues : false,
                        preserveDO: (oProps.direction === 'PU' && !UI.props.oPrefill.PU.ran && UI.props.oPrefill.DO.ran) ? true : false
                    }
                });
            }
        },
        handleCountryCrumbClick: function ($target) {
            // $target.removeClass('trg__menusearch--country-x').empty();
            var parentID = $target.parent().attr('id');
            var splitID = parentID.split('_');
            if (splitID[1]) {
                var baseID = splitID[1];
                /*$('#searchcrumbs_'+baseID+' .trg__menusearch--city-x').removeClass('trg__menusearch--city-x').empty();
                $('#loc_'+baseID).parent('.styled--select').addClass('visuallyhidden');
                $('#city_'+baseID).parent('.styled--select').addClass('visuallyhidden');
                $('#country_'+baseID).parent('.styled--select').removeClass('visuallyhidden');*/
                $('#country_' + baseID).val('--');
                UI.clearInput(baseID.substring(0, 2), $target);
            }
            AE.heightAdjust('.searchcrumbs_container');
        },
        handleCityCrumbClick: function ($target) {
            // $target.removeClass('trg__menusearch--city-x').empty();
            var parentID = $target.parent().attr('id');
            var splitID = parentID.split('_');
            if (splitID[1]) {
                var baseID = splitID[1];
                /*$('#loc_'+baseID).parent('.styled--select').addClass('visuallyhidden');
                $('#city_'+baseID).parent('.styled--select').removeClass('visuallyhidden');*/
                $('#city_' + baseID).val('--');
                UI.clearInput(baseID.substring(0, 2), $target);
            }
            AE.heightAdjust('.searchcrumbs_container');
        },
        clearInput: function (direction, $target) {
            direction = direction || 'PU';
            $target = $target || $('.trg__menusearch--country-x,.trg__menusearch--city-x');
            if (direction !== 'DO') {
                if(!$target.hasClass('trg__menusearch--loc')) UI.state.operator_id_list = '';
                UI.state.DO.loc = '';
                // $target.closest('#locations-wrapper').find('.dropoff-wrapper .trg__menusearch--country-x').click();
                UI.props.$do.find('.trg__menusearch--loc').val('--');
            }

            AE.ui.search.setValue((direction !== 'DO') ? {
                name: 'pickup-loc',
                item: {
                    pu: false,
                    drop: false
                }
            } : {
                name: 'dropoff-loc',
                item: {
                    pu: AE.ui.search.getSubmitValues().pu,
                    drop: false
                }
            });
        },
        prefill: function () {
            var $menus = $('#locations-wrapper .menusearch--container');
            if ($menus[0]) {
                var puMenu = _.filter($menus, function (tempMenu) {
                    return $(tempMenu).attr('id').substring(0, 2) === 'PU';
                });
                var doMenu = _.filter($menus, function (tempMenu) {
                    return $(tempMenu).attr('id').substring(0, 2) === 'DO';
                });
                var $puMenu = $(puMenu),
                    $doMenu = $(doMenu);
                var puBaseID = $puMenu.attr('id'),
                    doBaseID = $doMenu.attr('id');
                UI.props.oPrefill.PU.city = searchPuCity || '';
                UI.props.oPrefill.PU.country = searchPuCountry || '';
                UI.props.oPrefill.PU.loclist = searchPuLoclist || '';
                UI.props.oPrefill.DO.city = searchDoCity || '';
                UI.props.oPrefill.DO.country = searchDoCountry || '';
                UI.props.oPrefill.DO.loclist = searchDoLoclist || '';

                var TRY_LOCAL_STORAGE = AE.ui.search.useStoredSearch() && !vouchDateTime,
                    PREFILL_STORAGE_STR = TRY_LOCAL_STORAGE ? localStorage.getItem('aeSearch') : false,
                    USE_PAGE_PREFILL = ((typeof (searchPuCity) != 'undefined') && searchPuCity != ''),
                    USE_STORED_SEARCH = (PREFILL_STORAGE_STR != false);
                if (USE_PAGE_PREFILL) {
                    USE_STORED_SEARCH = false;
                    TRY_LOCAL_STORAGE = false;
                }

                if (TRY_LOCAL_STORAGE) {
                    UI.props.oPrefill.PU.city = AE.ui.search.getStoredSearch().city || searchPuCity || '',
                        UI.props.oPrefill.PU.country = AE.ui.search.getStoredSearch().pucode || searchPuCountry || '',
                        UI.props.oPrefill.PU.loclist = AE.ui.search.getStoredSearch().puloclist || '',
                        UI.props.oPrefill.DO.city = AE.ui.search.getStoredSearch().cityr || '',
                        UI.props.oPrefill.DO.country = AE.ui.search.getStoredSearch().docode || '',
                        UI.props.oPrefill.DO.loclist = AE.ui.search.getStoredSearch().doloclist || '';
                    if (UI.props.oPrefill.DO.city === null) UI.props.oPrefill.DO.city = UI.props.oPrefill.PU.city;
                    if (UI.props.oPrefill.DO.country === null) UI.props.oPrefill.DO.country = UI.props.oPrefill.PU.country;
                    if (UI.props.oPrefill.DO.loclist === null) UI.props.oPrefill.DO.loclist = UI.props.oPrefill.PU.loclist;
                    AEdata.menuPrefill = AEdata.menuPrefill || {};
                    AEdata.menuPrefill.LOCLIST = AEdata.menuPrefill.LOCLIST || AE.ui.search.getStoredSearch().puloclist || {};
                    AEdata.menuPrefill.DOLOCLIST = AEdata.menuPrefill.DOLOCLIST || AE.ui.search.getStoredSearch().doloclist;
                }

                if (USE_STORED_SEARCH && !USE_PAGE_PREFILL) {
                    /* Prefills last submitted search criteria. */
                    var $storeObj = JSON.parse(PREFILL_STORAGE_STR);

                    if (!_.isEmpty($storeObj)) {
                        UI.props.oPrefill.PU.city = $storeObj.city;
                        UI.props.oPrefill.PU.country = $storeObj.pucode;
                        AEdata.menuPrefill.LOCLIST = $storeObj.puloclist;

                        if ($storeObj.cityr == 'null' || $storeObj.docode == 'null') {
                            UI.props.oPrefill.DO.city = $storeObj.cityr;
                            UI.props.oPrefill.DO.country = $storeObj.docode;
                            AEdata.menuPrefill.DOLOCLIST = $storeObj.doloclist;
                        }
                    }
                }

                if (UI.props.oPrefill.DO.country !== '') UI.props.oPrefill.OW.country = (UI.props.oPrefill.DO.country === UI.props.oPrefill.PU.country) ? false : true;
                if (UI.props.oPrefill.DO.city !== '') {
                    UI.props.oPrefill.OW.city = (UI.props.oPrefill.DO.city === UI.props.oPrefill.PU.city && UI.props.oPrefill.PU.loclist === UI.props.oPrefill.DO.loclist) ? false : true;
                }
                if (UI.props.oPrefill.PU.country === '') UI.props.oPrefill.PU.ran = true;
                if (UI.props.oPrefill.DO.country === '') UI.props.oPrefill.DO.ran = true;
                var isOW = (UI.props.oPrefill.OW.country || (!UI.props.oPrefill.OW.country && UI.props.oPrefill.OW.city)) ? true : false;

                if (isOW) UI.checkTheOneWayBox();

                if (($puMenu[0] && TRY_LOCAL_STORAGE) || ($puMenu[0] && !UI.props.oPrefill.PU.ran && $('#country_' + puBaseID).find('option[value="' + UI.props.oPrefill.PU.country + '"]').length)) {
                    if (UI.props.oPrefill.PU.country !== '') {
                        $('#country_' + puBaseID).val(UI.props.oPrefill.PU.country);
                        $('#country_' + puBaseID).change();
                    } else if (TRY_LOCAL_STORAGE) {
                        /* Prefills destination page location criteria. */

                        $('#country_' + puBaseID).val(searchPuCountry);
                        $('#country_' + puBaseID).change();

                        UI.props.oPrefill.PU.city = searchPuCity;
                        $('#city_' + puBaseID).val(searchPuCity);
                        $('#city_' + puBaseID).change();
                    }
                }
                if ($doMenu[0] && !UI.props.oPrefill.DO.ran && $('#country_' + doBaseID).find('option[value="' + UI.props.oPrefill.DO.country + '"]').length) {
                    if (UI.props.oPrefill.DO.country !== '' && isOW) {
                        $('#country_' + doBaseID).val(UI.props.oPrefill.DO.country);
                        $('#country_' + doBaseID).change();
                    }
                }

            }
            
            /* if stored menu selections aren't present in this menu, set to default */
            if ($('#country_' + puBaseID).val() === null) {
                $('#country_' + puBaseID).val('--');
                $('#country_' + puBaseID).change();
                UI.props.oPrefill.PU.city = '--';
            }
        },
        checkTheOneWayBox: function () {
            if (!AE.ui.search.autocomplete.getInputs().$chkDiff.prop('checked')) AE.ui.search.autocomplete.getInputs().$chkDiff.click();
        },
        resetInput: function (inputChanged,direction,baseID) {
            /* WEBAE3-4265 set inputs to 1st item when parent input changes
            to prevent unintended form submits while waiting on XHR data to
            come back 
            inputChanged = country or city
            direction = PU or DO 
            baseID = used to target select IDs*/
            //only reset city on country change
            if (inputChanged === 'country') {
                $('#city_' + baseID).prop("selectedIndex", 0).find("option:not(:first)").remove();
            }
            //loc gets cleared on city or country change
            $('#loc_' + baseID).prop("selectedIndex", 0).find("option:not(:first)").remove();
            //if loc options get cleared, remove optgroup labels
            $('#loc_' + baseID).children().remove("optgroup");
        },
        onBodyClick: function (event, $target) {
            //WEBAE3-4646------------------------------------------ 
           /*the last error message needs to be adjusted for optimal hieght position depending on how many characters there are which chnages the height of the div which also will change depending on the screen width*/
            var flagHeight= $(".ui-warn-flag").height();
            var flagTop= $(".ui-warn-flag").css("top");

            //console.log(flagHeight);
           // console.log(flagTop);
            if (flagHeight>20 ){
               // console.log("move it up >20");
                $(".ui-warn-flag").addClass("custHt");
                $(".ui-warn-flag").removeClass("custHtb"); 
                $(".ui-warn-flag").removeClass("custHtc");
                $(".ui-warn-flag").removeClass("custHtd");
            }
            if (flagHeight>40 ){
               // console.log("move it up >40");
                $(".ui-warn-flag").removeClass("custHt");
                $(".ui-warn-flag").removeClass("custHtc");
                $(".ui-warn-flag").removeClass("custHtd");
                $(".ui-warn-flag").addClass("custHtb");
            }
            if (flagHeight>50){
              //  console.log("move it up >50");
                $(".ui-warn-flag").removeClass("custHt");
                $(".ui-warn-flag").removeClass("custHtb");
                $(".ui-warn-flag").removeClass("custHtd");
                $(".ui-warn-flag").addClass("custHtc");
            }
            if (flagHeight>60){
              //  console.log("move it up >50");
                $(".ui-warn-flag").removeClass("custHt");
                $(".ui-warn-flag").removeClass("custHtb");
                $(".ui-warn-flag").removeClass("custHtc");
                $(".ui-warn-flag").addClass("custHtd");
            }if(flagHeight< 20 ){
              // console.log("leave it alone");
                $(".ui-warn-flag").removeClass("custHtb");
                $(".ui-warn-flag").removeClass("custHt");
                $(".ui-warn-flag").removeClass("custHtc");
                $(".ui-warn-flag").removeClass("custHtd");
            }
       

            if ($target.attr('name') === 'btn-submit') {
                var $puMenu = $('#locations-wrapper [name="pickup-wrapper"] .menusearch--container');
                var $doMenu = $('#locations-wrapper [name="dropoff-wrapper"] .menusearch--container');

  //------------------------------------------    
        

                /*
                                if (UI.state.PU.country === '' || UI.state.PU.country === '--') {
                                    $puMenu.find('.trg__menusearch--country').parent('.styled--select').addClass('ui-state-invalid');
                                }
                                if (UI.state.PU.city === '' || UI.state.PU.city === '--') {
                                    $puMenu.find('.trg__menusearch--city').parent('.styled--select').addClass('ui-state-invalid');
                                }
                                if (UI.state.PU.loc === '' || UI.state.PU.loc === '--') {
                                    $puMenu.find('.trg__menusearch--loc').parent('.styled--select').addClass('ui-state-invalid');
                                }
                                if (UI.state.OW.country || UI.state.OW.city) {
                                    if (UI.state.DO.country === '' || UI.state.DO.country === '--') {
                                        $doMenu.find('.trg__menusearch--country').parent('.styled--select').addClass('ui-state-invalid');
                                    }
                                    if (UI.state.DO.city === '' || UI.state.DO.city === '--') {
                                        $doMenu.find('.trg__menusearch--city').parent('.styled--select').addClass('ui-state-invalid');
                                    }
                                    if (UI.state.DO.loc === '' || UI.state.DO.loc === '--') {
                                        $doMenu.find('.trg__menusearch--loc').parent('.styled--select').addClass('ui-state-invalid');
                                    }
                                }
                */
            }
            /*if($target.hasClass('trg__menusearch--country-x')) UI.handleCountryCrumbClick($target);
            if($target.hasClass('trg__menusearch--city-x')) UI.handleCityCrumbClick($target);
            if(UI.props.inModify && $target.data('togglee') && $target.data('togglee') === '#toggleeNewSearch'){
            	AE.heightAdjust('.searchcrumbs_container');
            }*/

        },
        onBodyChange: function (event, $target) {






            if (event.target.tagName.toUpperCase() === 'SELECT') {
//console.log("select");

                //4646

                if($target.data('direction') === 'do'){

                    if($('.ui-warn-flag-close-btn')[0]) $('.ui-warn-flag-close-btn').click();
                    
                }


//4646-----
/*              if($target.val() !== '--'){


}*/
                    if($target.val() == '--'){
//console.log("blank");


                    }

                    //--------
                if ($target.hasClass('trg__menusearch--country')) {
                   UI.handleCountryMenuSelect($target);
                }
                if ($target.hasClass('trg__menusearch--loc')) {
                    UI.handleLocMenuSelect($target);
                }
                // }
                if ($target.hasClass('trg__menusearch--city')) {
                    UI.handleCityMenuSelect($target);
                }
            }
            if (!UI.state.synchingChkDiff && $target.hasClass('chk-diff-linked')) {
                UI.state.synchingChkDiff = true;
                var thisState = $target.prop('checked');
                UI.props.$chkDiffs.prop('checked', thisState);
                UI.props.$chkDiffs.not($target).change();
                UI.state.synchingChkDiff = false;
                if ($target.prop('checked')) {
                    UI.props.$do.removeClass('visuallyhidden');
                } else {
                    UI.props.$do.addClass('visuallyhidden');
                    UI.clearInput('DO');
                    UI.props.$do.find('.trg__menusearch--loc').val('--');
                }

            }
        }
    };
    return UI;
})();

;
var AE = AE || {};

AE.ui.searchType.leasesearch = AE.ui.searchType.leasesearch || ( function () {
	/*
	DEPENDENCIES: AE, AE.ui, AE.ui.search
	*/
	var UI = {
		init: function () {
			UI.props = {
				$ltrpu: $( 'select#ltrpu.lease__select' ),
				$ltrdo: $( 'select#ltrdo.lease__select' ),
				$chkDiff: $( 'input[id*="chk-diff"]' ),
				dolock: false
			};
			// if(UI.props.$ltrpu.val() !== UI.props.$ltrdo.val()) UI.props.dolock = false;
			if ( ( UI.props.$ltrpu.val() === '' ) && ( UI.props.$ltrpu.val() !== UI.props.$ltrdo.val() ) ) UI.props.dolock = false;
			if ( UI.props.$ltrpu.val() !== '' ) UI.props.dolock = false;

			if ( AE.ui.search.useStoredSearch() && !_.isEmpty( AE.ui.search.getStoredSearch() ) ) {
				var oStoredSearch = AE.ui.search.getStoredSearch();
				if ( oStoredSearch.excl_ltr ) {
					if ( oStoredSearch.pu ) UI.props.$ltrpu.val( (oStoredSearch.pu.hasOwnProperty('desk_list'))? oStoredSearch.pu.desk_list : '');
					if ( oStoredSearch.drop ) {
						UI.props.dolock = false;
						UI.props.$ltrdo.val( (oStoredSearch.drop.hasOwnProperty('desk_list'))? oStoredSearch.drop.desk_list : '');
					}
				}
			}


			// UI.props.$chkDiff.prop('checked',!UI.props.dolock);
			UI.setValue( 'pu' );
			UI.setValue( 'do' );
			// UI.props.$chkDiff.on('click',function(){UI.lockDropoff();});
			UI.props.$ltrpu.on( 'change', function () {
				UI.setValue( 'pu' );
				// Set Drop off to Match Pickup on pickup selection
				UI.props.$ltrdo.val( UI.props.$ltrpu.val() );
				UI.setValue( 'do' );
			});
			UI.props.$ltrdo.on( 'change', function () {
				UI.setValue( 'do' );
				// UI.lockDropoff();
			});
			// Turn off Disabling Drop off so lease search will always work (patch)
			//UI.props.$ltrdo.on( 'change', function () { UI.setValue( 'do' ); } ).prop( 'disabled', UI.props.dolock );

				// Palm only Task
				// AE.addTransitionTask({
				// 	func:function() {
						// Handle different drop off checkbox on mobile if PU neq DO
						if( (UI.props.$ltrdo.val() != UI.props.$ltrpu.val()) && !UI.props.$chkDiff.is(':checked') ){
							UI.props.$chkDiff.trigger('click');
						}
				// 	}
				// });
		},
		setValue: function ( direction ) {
			var _direction = direction || 'pu';
			var $selectedLoc, _doDisplayLabel, _puDisplayLabel;

			if ( _direction == 'do' ) { // && !UI.props.dolock
				$selectedLoc = UI.props.$ltrdo.find( 'option[value="' + UI.props.$ltrdo.val() + '"]' );
				var selData = $selectedLoc.data();
				var validSelect = ($selectedLoc.hasOwnProperty('text'))? true : false;
				if(!_.isEmpty(selData)){
					if(!validSelect) validSelect = (_.has(selData,'city'))? true : false;
				} else {
					validSelect = false;
				}
				if(validSelect){
					_doDisplayLabel = ($selectedLoc.hasOwnProperty('text'))? $selectedLoc.text : selData.city;//( UI.props.$ltrdo.val() != '' ) ? AE.props.oSearch.TXT_ALL_LOCATIONS.replace('[CITY]', UI.props.$ltrdo.val().replace('PGT','').trim()): null;
					AE.ui.search.setValue( {
						name: 'dropoff-loc',
						item: {
							pu: false,
							drop: {
								chaos_city_name: $selectedLoc.data().city,
								chaos_country_code: $selectedLoc.data().country,
								iso_country_code: $selectedLoc.data().isocode,
								desk_list: UI.props.$ltrdo.val(),//( UI.props.$ltrdo.val() != '' ) ? 'allDowntown' : null,
								hub_name: $selectedLoc.text,
								display_label:  _doDisplayLabel
							}
						}
					});
				}

			} else if ( _direction == 'pu' ) {
				$selectedLoc = UI.props.$ltrpu.find( 'option[value="' + UI.props.$ltrpu.val() + '"]' );
				var selData = $selectedLoc.data();
				var validSelect = ($selectedLoc.hasOwnProperty('text'))? true : false;
				if(!_.isEmpty(selData)){
					if(!validSelect) validSelect = (_.has(selData,'city'))? true : false;
				} else {
					validSelect = false;
				}
				if(validSelect){
					_puDisplayLabel  = ($selectedLoc.hasOwnProperty('text'))? $selectedLoc.text : selData.city;//( UI.props.$ltrpu.val() != '' ) ? AE.props.oSearch.TXT_ALL_LOCATIONS.replace('[CITY]', UI.props.$ltrpu.val().replace('PGT','').trim()): null;
					AE.ui.search.setValue( {
						name: 'pickup-loc',
						item: {
							drop: false,
							pu: {
								chaos_city_name: $selectedLoc.data().city,
								chaos_country_code: $selectedLoc.data().country,
								iso_country_code: $selectedLoc.data().isocode,
								desk_list: UI.props.$ltrpu.val(),//( UI.props.$ltrpu.val() != '' ) ? 'allDowntown' : null,
								hub_name: $selectedLoc.text,
								display_label:   _puDisplayLabel
							}
						}
					} );
				}


			}
		},
		lockDropoff: function () {
			UI.props.dolock = !UI.props.dolock;
			UI.props.$ltrdo.prop( 'disabled', UI.props.dolock );
			if ( !UI.props.dolock ) {
				AE.ga.gaArrayProcess( [ { GACATEGORY: 'carSearch', GAACTION: 'oneWaySelect' } ] );
				AE.ui.props.$locationsWrapper.addClass( 'both' );
			} else {
				AE.ui.props.$locationsWrapper.removeClass( 'both' );
				UI.setValue( 'pu' );
			}
		}
	};
	return UI;
} )();

;var AE = AE || {}; /* Add to Base object or create it if it doesn't exist. */

AE.ui.searchType.bmr = AE.ui.searchType.bmr || (function () {
    'use strict';

    /*
    DEPENDENCIES: AE, AE.ui, AE.ui.search, AE.ui.searchType
    */
    var oBMR = {
        cfc: '/plugins/ae3/lib/bookmyride.cfc',
        agency: 'eu',
        locale: 'en',
        url: 'autoeurope-motorhome.com',
        conversion: 'AUTOEUROPE',
        campaign: 0
    };
    var ajaxInitRan = false, puPrefillRan = false, doPrefillRan = false, oDOlocs = {};

    var UI = {
        init: function () {
            UI.props = {
                oPrefill: { pickUpCountry: '--', pickUpCity: '--', dropOffCountry: '--', dropOffCity: '--' },
                synchingChkDiff: false,
                $do: $('.bmr__item--do'),
                $chkDiffs: $('input.chk-diff-linked'),
                $dfd: $.Deferred(),
                isAUNZ: AE.props.isAUNZ
            };
            UI.props.$chkDiffs.prop('checked', false);

            oBMR.conversion = AE.props.affiliate;
            oBMR.campaign = AE.props.campaign;
            if(!ajaxInitRan){
                ajaxInitRan = true;
                // AJAX to update oBMR from bookmyride.cfc
                $.ajax({
                    url: oBMR.cfc,dataType: 'json',
                    data: {method: 'getProps'},
                    success: function (data){
                        _.extendOwn(oBMR,data);
                    }
                });

                // AJAX to get countries from BMR and build dropdown
                $.ajax({
                    url: oBMR.cfc,dataType: 'json',
                    data: {method: 'getCountries'},
                    success: function (data){
                        var o$Regions = {};
                        _.each(data,function(thisCountry){
                            if(thisCountry.region){
                                if(!o$Regions[thisCountry.region.code]){
                                    o$Regions[thisCountry.region.code] = $('<optgroup/>',{
                                        label:thisCountry.region.text,class:thisCountry.region.code
                                    });
                                }
                                o$Regions[thisCountry.region.code].append(
                                    $('<option/>',{
                                        value:(thisCountry.code === false)? 'NO' : thisCountry.slug,
                                        html: thisCountry.text
                                    })
                                );
                            }
                        });
                        //VM
                        //WEBAE3-5374
                        
                        if (AE.props.isAUNZ == true) {
                            _.each('OCE,NAM,SAM,EUR,ASA,SAF'.split(','),function(regKey){
                                $('select.trg__bmrsearch--country').append(o$Regions[regKey]);
                            });
                        }
                        else {
                        _.each('NAM,SAM,EUR,OCE,ASA,SAF'.split(','),function(regKey){
                            $('select.trg__bmrsearch--country').append(o$Regions[regKey]);
                        });
                    }

                        if(AE.ui.search.useStoredSearch()){
                            var oPrefill = localStorage.getItem('aeBMRsearch');
                            if( oPrefill !== null && _.isString(oPrefill) && oPrefill != ''){
                                UI.props.oPrefill = JSON.parse(oPrefill);
                                $('select.trg__bmrsearch--country').val(UI.props.oPrefill.pickUpCountry);
                            }
                        } else {
                            puPrefillRan = true;
                            doPrefillRan = true;
                        }
                        $('select.trg__bmrsearch--country').change();
                    }
                });
            }
            AE.ui.addBodyChangeTask({ func: UI.onBodyChange });

            if(UI.props.isAUNZ){
                $('input#chk-age').hide();
                $('label[for="chk-age"]').click().hide();
                $('input[name="txt-age"]').addClass('flush').prop('required',true).attr('max',1000);
                $('#bmr__aunz--age').removeClass('visuallyhidden');
                $('input[name="txt-age"]').show();
                $('#bmr__aunz--age').show();               
                // if(AE.ui.search.getmemberage() && AE.ui.search.getmemberage() != ''){
                //     $('input[name="txt-age"]').val(AE.ui.search.getmemberage());
                // } 
                // else if(UI.props.oPrefill.driverAge){
                //     $('input[name="txt-age"]').val(UI.props.oPrefill.driverAge);

                // }       
            }


        },
        getSubmitTarget: function() {
            return 'https://'+oBMR.url+'/quotes';
        },
        getSubmitValues: function (oSearch) {
            // tgt = "1";// WEABE3-2259 Don't open a new window
            oSearch = oSearch || AE.ui.search.getSubmitValues();
            var oSubmit = {locale: oBMR.locale, agency: oBMR.agency};
            oSubmit.conversion = oBMR.conversion;
            oSubmit.campaign = oBMR.campaign;
            oSubmit.pickUpDate = oSearch.puCal;
            oSubmit.dropOffDate = oSearch.doCal;
            if(oSite.bIsDapTpDomain) {
                oSubmit.agencyCode = oSite.affiliateIATA;
            }
           
            var rawAge = $('input[name=txt-age]').val();
            if(!$('#chk-age').prop('checked') || (UI.props.isAUNZ && rawAge !== '')){
                oSubmit.driverAge = rawAge;
            }
            oSubmit.passengers = $('#bmr__passengers').val();
            oSubmit.pickUpCountry = $('#bmr__country').val();
            oSubmit.pickUpCity = $('#bmr__city').val();
            _.extend(oSubmit,UI.getDOValues(oSubmit.pickUpCountry,oSubmit.pickUpCity));
            _.extend(oSubmit,UI.getAUNZValues());

            if(AE.ui.search.useStoredSearch()){
                localStorage.setItem('aeBMRsearch',JSON.stringify(oSubmit));
            }

            return oSubmit;
        },
        getCheckValues: function (oSearch) {
            oSearch = oSearch || AE.ui.search.getSubmitValues();
            var oCheckParams = UI.getSubmitValues(oSearch);
            oCheckParams.method = 'checkResults';
            var oAjax = {
                url: oBMR.cfc,
                dataType: 'json',
                data: oCheckParams,
                success: function (data){
                    // console.log(data);
                }
            };
            return oAjax;
        },
        handleCountryMenuSelect: function ($target) {
            $.ajax({
                url: oBMR.cfc,
                dataType: 'json',
                data: {
                    method: 'getCities',
                    code: $target.val()
                },
                success: function (data) {
                    var $promptOptionPU = $('#city-0-0').detach(), $promptOptionDO = $('#cityr-0-0').detach();
                    $('#bmr__city,#bmr__cityr').empty();
                    _.each(data,function(thisCity){
                        $('#bmr__city').append($('<option/>',{value:thisCity.slug,html:thisCity.text}));
                    });
                    var puPrefill = '--', doPrefill = '--';
                    if(!puPrefillRan && AE.ui.search.useStoredSearch()){
                        puPrefill = UI.props.oPrefill.pickUpCity;
                        doPrefill = UI.props.oPrefill.dropOffCity || '--';
                        puPrefillRan = true;
                    }
                    $('#bmr__cityr').prepend($promptOptionDO);
                    $('#bmr__city').prepend($promptOptionPU).val(puPrefill).change();
                    if(puPrefill !== '--' && doPrefill !== '--' && puPrefill !== doPrefill){
                        UI.props.$chkDiffs.prop('checked', true);
                        UI.props.$chkDiffs.change();
                    }
                }
            });
        },
        handlePickupSelect: function ($target) {
            if($target.val() !== '--' && $target.val() !== ''){
            $.ajax({
                url: oBMR.cfc,
                dataType: 'json',
                data: {
                    method: 'getDropoffCities',
                    puCity: $target.val()
                },
                success: function (data) {
                    var $promptOptionDOcountry = $('#countryr-0-0').detach(),
                        $promptOptionDOcity = $('#cityr-0-0').detach();
                    $('#bmr__cityr,#bmr__countryr').empty();
                    oDOlocs = {};
                    _.each(data,function(thisCity){
                        if(!oDOlocs.hasOwnProperty(thisCity.country.slug)){
                            oDOlocs[thisCity.country.slug] = {
                                value:thisCity.country.slug, html:thisCity.country.text, aLocs:[]
                            };
                        }
                        oDOlocs[thisCity.country.slug].aLocs.push({value:thisCity.slug,html:thisCity.text});
                    });
                    var aDOlocs = _.sortBy(_.keys(oDOlocs),function(kLoc){return oDOlocs[kLoc].html;});
                    _.each(aDOlocs,function(thisCountryKey){
                        var thisCountry = oDOlocs[thisCountryKey];
                        $('#bmr__countryr').append($('<option/>',{value:thisCountry.value,html:thisCountry.html}));
                    });
                    var doPrefill = '--',doPrefillCountry = '--';
                    if(!doPrefillRan && AE.ui.search.useStoredSearch()){
                        if(oDOlocs.hasOwnProperty(UI.props.oPrefill.dropOffCountry)){
                            doPrefillCountry = UI.props.oPrefill.dropOffCountry;
                        } else if(oDOlocs.hasOwnProperty(UI.props.oPrefill.pickUpCountry)) {
                            doPrefillCountry = UI.props.oPrefill.pickUpCountry;
                        } else {
                            doPrefillRan = true;
                        }

                        if(!doPrefillRan && UI.props.oPrefill.dropOffCity !== UI.props.oPrefill.pickUpCity){
                            var aDOcityCheck = _.find(oDOlocs[doPrefillCountry].aLocs, 
                                function(thisLoc){ return thisLoc.value === UI.props.oPrefill.dropOffCity;}
                            );
                            if(!_.isObject(aDOcityCheck)){
                                doPrefillRan = true;
                                doPrefillCountry = '--';
                            }
                        } else {
                            doPrefillCountry = '--';
                        }
                    }
                    $('#bmr__cityr').prepend($promptOptionDOcity).val(doPrefill).change();
                    $('#bmr__countryr').prepend($promptOptionDOcountry).val(doPrefillCountry).change();
                }
            });
            }
        },
        handleDropoffCountrySelect: function ($target) {
            if(oDOlocs.hasOwnProperty($target.val())){
                var doPrefill = '--', useStoredSearch = AE.ui.search.useStoredSearch(),
                    $promptOptionDOcity = $('#cityr-0-0').detach();
                    $('#bmr__cityr').empty();
                _.each(oDOlocs[$target.val()].aLocs,function(thisCity){
                    $('#bmr__cityr').append($('<option/>',{
                        value:thisCity.value,html:thisCity.html
                    }));
                    if(!doPrefillRan && useStoredSearch && thisCity.value === UI.props.oPrefill.dropOffCity){
                        doPrefill = UI.props.oPrefill.dropOffCity;
                        doPrefillRan = true;
                    }
                });
                $('#bmr__cityr').prepend($promptOptionDOcity).val(doPrefill).change();
            }
        },
        getDOValues: function (puCountry,puCity) {
            var oDO={}, city = $('#bmr__cityr').val(), country = $('#bmr__countryr').val();
            if(city !== '--' && city !== '') oDO.dropOffCity = city;
            if(country !== '--' && country !== '' && puCountry !== city) oDO.dropOffCountry = country;
            return oDO;
        },
        getAUNZValues: function () {
            var oAUS={};
            if(UI.props.isAUNZ){
                var lic = $('#bmr__lic').val();
                if(lic && lic !== ''){
                    oAUS.domestic = lic;
                }
            }
            return oAUS;
        },
        handleSubmit: function (oSearch) {
            oSearch = oSearch || AE.ui.search.getSubmitValues();
            var oCheckParams = UI.getSubmitValues(oSearch);
            oCheckParams.method = 'checkResults';
            UI.props.$dfd = $.Deferred();
            UI.props.$dfd.done(function(){
                AE.ui.search.setValue({name:'txt-age',resetAge:true});
                $("form#ae-search button[name='btn-submit']")
                    .removeClass('ui--btn-submit-wait')
                    .attr({'disabled': false})
                    .find('.ui--loading-results').remove();
            });
            $.ajax({
                url: oBMR.cfc,
                dataType: 'json',
                data: oCheckParams,
                success: function (data){
                    UI.props.$dfd.resolve();
                    if(data.ST){
                        return AE.ui.search.postToForm(
                            UI.getSubmitTarget(), 
                            UI.getSubmitValues(oSearch), 
                            'get'
                        );
                    } else {
                        AE.ui.dialog.launch({
                            titleBar:true,
                            id:"noResultWarning",
                            // dialogClass: 'top-dialog',
                            content: AE.ui.searchType.bmr.buildNoResultMarkup(data.HD,data.MSG,data.META),
                            applyUI: true,
                            width: ($(window).width() > 600) ? 500 : '70%'
                        });
                        
                        return false;
                    }
                },
                failure: function (){
                    UI.props.$dfd.resolve();
                    return false;
                }
            });
        },
        buildNoResultMarkup: function (HD,MSG,META) {
            HD = HD || '';
            MSG = MSG || '';
            var docFrag = $(document.createDocumentFragment());
            docFrag.append($(document.createElement('h3')).append(HD));
            docFrag.append($(document.createElement('div')).append(MSG));
            if(META && !AE.props.isLiveServer) docFrag.append($(document.createElement('h4')).append(META));
            return docFrag;
        },
        onBodyChange: function (event, $target) {
            if (event.target.tagName.toUpperCase() === 'SELECT') {
                if ($target.hasClass('trg__bmrsearch--country')) {
                    UI.handleCountryMenuSelect($target);
                }
                if ($target.hasClass('trg__bmrsearch--city')) {
                    UI.handlePickupSelect($target);
                }
                if ($target.hasClass('trg__bmrsearch--countryr')) {
                    UI.handleDropoffCountrySelect($target);
                }
            }
            if (!UI.props.synchingChkDiff && $target.hasClass('chk-diff-linked')) {
                UI.props.synchingChkDiff = true;
                var thisState = $target.prop('checked');
                UI.props.$chkDiffs.prop('checked', thisState);
                UI.props.$chkDiffs.not($target).change();
                UI.props.synchingChkDiff = false;
                if ($target.prop('checked')) {
                    UI.props.$do.removeClass('visuallyhidden');
                } else {
                    UI.props.$do.addClass('visuallyhidden');
                    $('#bmr__cityr,#bmr__countryr').val('--');
                }

            }
        }
    };
    return UI;
})();

;
var AE = AE || {}; /* Add to Base object or create it if it doesn't exist. */

AE.ui.devices = AE.ui.devices || ( function () {
	/***
	DEPENDENCIES: AE, AE.ui
	***/
	'use strict';

	var UI = {
		init: function () {

			var $fn_getInputs = AE.ui.search.autocomplete.getInputs();
			var $puLoc = $fn_getInputs.$puLoc;
			var $doLoc = $fn_getInputs.$doLoc;
			var $chkDiff = $fn_getInputs.$chkDiff;

				UI.props = {
							softKeyboardActive: false,
							navigatorUA: navigator.userAgent,
							viewport: document.querySelector( "meta[name=viewport]" ),
							toggleKeyboardElem: $( '<menu/>', { class: 'ui-toggle-keyboard', type: 'toolbar' } ),
							modElement: $( 'html' ),
							modClass: 'ui-soft-kb-active',
							$puLoc : $fn_getInputs.$puLoc,
							$doLoc : $fn_getInputs.$doLoc,
							$chkDiff : $fn_getInputs.$chkDiff
				};
				UI.features = {};
				UI.elements = {};

				if( AE.props.siteCode !== 'FCR' ) {
					UI.mainSearch();
				/*!
					* IE10 viewport hack for Surface/desktop Windows 8 bug
					* Copyright 2014-2017 The Bootstrap Authors
					* Copyright 2014-2017 Twitter, Inc.
					* Licensed under MIT (https://github.com/twbs/bootstrap/blob/master/LICENSE)
					*/
					(function (d) {
					if (UI.props.navigatorUA.match(/IEMobile\/10\.0/)) {
						var msViewportStyle = d.createElement('style');
						msViewportStyle.appendChild( d.createTextNode('@-ms-viewport{width:auto!important}') );
						d.head.appendChild(msViewportStyle);
					}
					/* Set border-top to <2px to workaround WEBAE3-4182
					* This will cause jquery-ui _hasScroll() to return false to jquery-ui _scrollIntoView()
					* avoiding an uncaught exception inside the latter where the passed element is empty. 
					*/
					if (UI.props.navigatorUA.match(/Chrome\/9[\d]\.[\d]+\.[\d]+\.[\d]+ Mobile/)) {
						var fractionalScrollHeightStyle = d.createElement('style');
						fractionalScrollHeightStyle.appendChild( d.createTextNode('#ui-id-99{border-top-width:1.999px!important}') );
						d.head.appendChild(fractionalScrollHeightStyle);
					}
					})(document);
			
				}
				
		},
		
		mainSearch: function () {
			this._isOpen = false;
			// console.log( UI.props.navigatorUA );
			// if(_.contains(UI.props.navigatorUA.split(' '),'Android') ) UI.props.modClass += ' ui-sticky-menu-android-offset';
		},
		onShow: function ( input ) {
			
			this._isOpen = true;

			var _offsetT = input.offset().top;
			var inputId = input.attr( 'id' );
			var $widget = input.data( 'customTextsearch' );
			var $button = $widget.targetActionButton;
			var $scrollToInput = document.getElementById( inputId );
			var $input = $widget.element;
			var $overlay = $( '<div/>', { class: 'ui-mobile-overlay' } );

			// console.log( $widget.status );


			function touchM( event ) {
					var $target = $( event.target );

					if ( $target.hasClass( 'ui-mobile-overlay' ) || $target.is( '[class*=ui-textsearch]' ) ) {
							event.stopPropagation();
					}
			}

			$( '.' + UI.props.modClass ).each(function(ind, item){
					return item.addEventListener( 'touchmove', touchM, {passive:true, capture:true});
			});

			return setTimeout( function () {

				$scrollToInput.scrollIntoView( { behavior: 'instant', block: 'start', inline: 'start' } );

				if ( !$overlay.is( ':visible' ) ) {
						$overlay.insertAfter( $button ).addClass( 'fade-in' );

						$overlay.on( 'click', function ( event ) {
									$overlay.addClass('ui-state-active').off( 'click' );
									return AE.ui.devices._hide( $input );
						} )
				}

				var scrolledY = window.scrollY;
				// if ( scrolledY ) window.scrollTo( 0, scrolledY - _offsetT );
				if ( scrolledY ) window.scrollTo( 0, 1 );

				// $input.trigger('customFocus');
				// $input.attr({autofocus:"autofocus"});

			}, 200 );
		},
		onHide: function ( event, ui ) {
			var _openMenu = $( '[data-open=true]' )
			_openMenu.addClass( 'fs-menu' );

			this._isOpen = false;

			$( '.' + UI.props.modClass ).each( function ( ind, item ) {
					return item.removeEventListener( 'touchmove', touchM, { passive: true } );
			} );

			return $( '.ui-mobile-overlay' ).animate( { opacity: 0 }, 'fast', function () {
					UI.props.modElement.find( '.ui-mobile-overlay' ).remove();
					return false;
			} );
		},
		_show: function ( input ) {
			var $input = input;
			var _direction = $input.data( 'direction' );
			var _addClass = ( _direction == 'pu' ) ? 'ui-pu-input-focus' : 'ui-do-input-focus';
			var _removeClass = ( _direction == 'pu' ) ? 'ui-do-input-focus' : 'ui-pu-input-focus';

			switch(_direction){
						case 'pu':
								UI.props.$doLoc.textsearch().trigger('textsearchdisable');
						break;
						case 'do':
								UI.props.$puLoc.textsearch().trigger('textsearchdisable');
						break;
			}

			UI.props.softKeyboardActive = true;
			UI.props.modElement.addClass( UI.props.modClass + ' ' + _addClass ).removeClass( _removeClass );

			
			return !this._isOpen ? UI.onShow( $input ) : false;

		},
		_hide: function ( input ) {
			var $input = input;
			var _direction = $input.data( 'direction' );
			var _removeClass = 'ui-pu-input-focus ui-do-input-focus';

			UI.props.softKeyboardActive = false;
			UI.props.modElement.removeClass( UI.props.modClass + ' ' + _removeClass );

			switch(_direction){
						case 'pu':
								UI.props.$doLoc.textsearch().trigger('textsearchenable');
						break;
						case 'do':
								UI.props.$puLoc.textsearch().trigger('textsearchenable');
						break;
			}

			$input.trigger('textsearchclose');

			return UI.onHide( input );
		},
		_hideDeviceKeyboard: function () {
			/***
				* For mobile UI, once textsearch becomes a selectable menu - as opposed to textsearch.
				* We can force the 'select' to 100% vh and suppress the keyboard.
				***/
			$( 'input' ).blur();
			return false;
		}
	}
	return UI;
	
} )();

;
var AE = AE || {}; /* Add to Base object or create it if it doesn't exist. */
AE.ui.carousel = AE.ui.carousel || (function() {
    'use strict';
    /*
    DEPENDENCIES: AE, AE.ui, mura, looper.js

    Although this module is always present, it doesn't run unless there's a carousel on the page. If we do have a carousel,
    then we still don't want to run it until after the global deferred object is resolved by the main AE object. For this
    reason, the init function will be run by the display object which loads it rather than by AE.init.
    /*


    /*
    Full Looper.js Docs: http://rygine.com/projects/looper.js/docs/
    EXAMPLE LOOPER MARKUP -- classes and data attributesneed to be in markup before .looper() can be called
    	TRANSITIONS: slide {up, down}, xfade
    	INTERVAL: integer amount of milliseconds between automatic transition. FALSE for no autoplay
    	<div class="carousel_container looper {transition}" data-looper="go" data-interval="{interval}" id="{carouselID}">
    		<div class="looper-inner">
    			<div class="item">{...content...}</div>
    			{...more items...}
    		</div>
    		<nav><!-- OPTIONAL -->
    	        <a class="looper-control" data-looper="prev" href="#{carouselID}">
    	            <i class="fa fa-2x fa-chevron-left"></i>
    	        </a>
    	        <a class="looper-control right" data-looper="next" href="#{carouselID}">
    	            <i class="fa fa-2x fa-chevron-right"></i>
    	        </a>
    	         <ul class="looper-nav">
    				<li><a href="#{carouselID}" data-looper="to" data-args="1">{Nav Trigger, e.g. &bull; for bullet entity}</a></li>
    	        	{... more bullets ...}
    	        </ul>
    	    </nav>
    	</div>
    */
    var UI = {
        loaded: false,
        init: function() {
            //if(!UI.loaded){
            //	if(mura){
            //		mura.loader()
            //			.loadcss(siteThemeAssetPath+'/assets/looper/src/looper.css',{media:"all"})
            //			.loadjs(siteThemeAssetPath+'/assets/looper/src/looper.min.js');
            //		UI.loaded=true;
            //	}
            $('.looper-control.right').attr({ name: 'next', 'aria-label': 'next' });
            $('.looper-control').not('.right').addClass('visuallyhidden').attr({ name: 'prev', 'aria-label': 'prev' });
            AE.ui.addBodyClickTask({ func: UI.onBodyClick });
            //AE.addResizeTask({func:function(){UI.manageResize();},args:[]});
            //}
            if(typeof(initSurveyResize) !== 'undefined') AE.ui.carousel.surveyResize.init();
            if(AEdata && AEdata.hasOwnProperty('ui')){
                if(AEdata.ui.hasOwnProperty('surveySpinnerOn')){
                    $('body').on('shown',function(event){
                        $('.carousel_cloak').removeClass('carousel_cloak');
                        if(AEdata.ui.surveySpinnerOn){
                            $('.review_spinner').remove();
                            AEdata.ui.surveySpinnerOn = false;
                        }
                    });
                }
            }
        },
        onBodyClick: function(event, $target) {
            if ($target.hasClass('looper-control')) {
                var looperSelector = $target[0].href.substring($target[0].href.indexOf('#')),
                    $thisLooper = $(looperSelector),
                    $looperControls = $thisLooper.find('.looper-control'),
                    $looperItems = $thisLooper.find('.looper-inner .item');
                $looperControls.removeClass('visuallyhidden');
                if ($looperItems.first().hasClass('prev go') || $looperItems.first().hasClass('next go')) $looperControls.not('.right').addClass('visuallyhidden');
                if ($looperItems.last().hasClass('prev go') || $looperItems.last().hasClass('next go')) $looperControls.filter('.right').addClass('visuallyhidden');
            }
        },
        manageResize: function() {
            var viewType = AE.getSiteViewType();
            $('.looper-control').removeClass('visuallyhidden').not('.right').addClass('visuallyhidden');
            // Normalize all carousel item, Carousel container, and USP container heights
            $('#autoratingbar.grid>.grid__item').attr("style", "overflow:inherit;"); // remove overflow initial setting
            if (viewType !== "palm") {
                AE.heightAdjust($('.carousel_container>.looper-inner>.item,#autoratingbar.grid>.grid__item').not('.noHeightAdjust'));
            } else {
                AE.heightAdjust($('.carousel_container>.looper-inner>.item').not('.noHeightAdjust'));
                $('#autoratingbar.grid>.grid__item').height('auto');
            }
        }
    }



    return UI;
})();
var AE = AE || {}; /* Add to Base object or create it if it doesn't exist. */
AE.ui.carousel.surveyResize = AE.ui.carousel.surveyResize || (function() {
    /*
    DEPENDENCIES: Any other modules that this one will call.
    AE.displayObjects:
    	This module assumes that the AE object has already been loaded and initialized.
    	The reviews displayObject is added after the page has finished loading, so it
    	doesn't get kicked off with the rest of the framework.
    */
    var UI = {
        init: function() {
            UI.props = {
                maxSlides: 1, // Maximum number of slides to show
                arrSlides: [], // Array to recieve the detached slides
                $slideContainer: $('#autoratingbar .carousel_container .carousel__slides-container'), // Where the slides will be taken in and out of
                $carousel: $('#autoratingbar .looper') // The actual carousel object that we can run carousel library methods on
            };
            UI.draw();
            UI.positionReadMoreLink();
            AE.addResizeTask({ func: function() { UI.manageResize(); }, args: [] });
        },
        computeMaxSlides: function(viewType) {
            viewType = viewType || "palm";
            var maxSlides = 1;
            if (viewType === "desk" || viewType === "desk-wide") {
                maxSlides = ($('.reviewCarousel__USP')[0]) ? 2 : 4;
            }
            return maxSlides;
        },
        draw: function() {
            UI.props.maxSlides = UI.computeMaxSlides(AE.getSiteViewType());
            if (!UI.props.arrSlides[0]) UI.props.arrSlides = UI.props.$slideContainer.find('.carousel__slide').detach();
            UI.props.$slideContainer.empty();
            var gridItemClass = (UI.props.maxSlides === 2) ? 'one-half' : 'one-quarter';
            var $df = $(document.createDocumentFragment());
            for (var slidx = 0; slidx < UI.props.arrSlides.length; slidx++) {
                var $carouselItem = $(document.createElement('div')).addClass('item');
                if (UI.props.maxSlides === 1) {
                    $carouselItem.append(UI.props.arrSlides[slidx]);
                } else {
                    var $tr = $(document.createElement('tr'));
                    var $table = $(document.createElement('table')).addClass('flush').append($tr);
                    $carouselItem.append($table);

                    for (var tdx = 0; tdx < UI.props.maxSlides; tdx++) {
                        if (slidx + tdx < UI.props.arrSlides.length) {
                            $tr.append($(document.createElement('td')).addClass(gridItemClass + ' hard').append(UI.props.arrSlides[slidx + tdx]));
                        }
                    }
                    slidx += (UI.props.maxSlides - 1);
                }
                $df.append($carouselItem);
            }
            UI.props.$slideContainer.append($df);
            // Bumped up to a second since loading was happening to fast Deferred was not working can refactor later
            setTimeout(function() {
                AE.ui.carousel.manageResize();
                UI.props.$carousel.find('.item').first().addClass('active');
            }, 1000);

        },
        positionReadMoreLink: function() {
            var $rmLink = $('#autoratingfulllink');
            $rmLink.parent().css({ position: 'relative' });
            $rmLink.css({ position: 'absolute', width: '100%', left: '-14px', bottom: '14px' });
            if (AE.getSiteViewType() !== "palm" && AE.getSiteViewType() !== "lap") $rmLink.css('bottom', '0px');
        },
        manageResize: function() {
            UI.draw();
            UI.positionReadMoreLink();
        }
    }
    return UI;
})();

;
var AE = AE || {}; /* Add to Base object or create it if it doesn't exist. */
AE.ui.carousel.surveySort = AE.ui.carousel.surveySort || (function() {
    // AE.displayObjects.surveySort = (function() {
    /*
    DEPENDENCIES: Any other modules that this one will call.
    AE.displayObjects:
    	This module assumes that the AE object has already been loaded and initialized.
    	The reviews displayObject is added after the page has finished loading, so it
    	doesn't get kicked off with the rest of the framework.
    */
    var UI = {
        init: function() {



            UI.props = {
                $select: $('select[name="surveySort"]'),
                $contents: $('#reviewPagesCarousel').find('.carousel__slides-container'),
                $carousel: $('#reviewPagesCarousel'), // The actual carousel object that we can run carousel library methods on
                arrReviews: [],
                perPage: 20
            };

            $('.review_spinner').remove();

            /* Do various things that happen once upon init. */
            UI.props.$select.on("change", function() {
                if (!UI.props.arrReviews[0]) UI.props.arrReviews = UI.props.$contents.find('.carousel__slide').detach();

                var selValue = $(this).val(),
                    options = {};

                switch (selValue) {
                    case 'lo':
                        options = { prop: "score", asc: true }
                        break;
                    case 'hi':
                        options = { prop: "score", asc: false }
                        break;
                    case 'old':
                        options = { prop: "created", asc: true }
                        break;
                    default: // new
                        options = { prop: "created", asc: false }
                }
                // console.log(UI.split( UI.sort( UI.props.arrReviews, options.prop, options.asc ) ) );

                UI.draw(UI.split(UI.sort(UI.props.arrReviews, options.prop, options.asc)));
            });
            UI.props.$carousel.find('.item').first().addClass('active');
        },
        sort: function(arrReviews, key, ascending) {
            var arrSorted = [];
            if (key === "score") { // Display Each score value from most recent to least recent
                var oScores = _.groupBy(arrReviews, function(review) { return review.dataset.score });
                for (var score = 0; score <= 5; score++) {
                    if (oScores[score] && oScores[score][0]) { // Skip score values with no reivews associated with them
                        oScores[score] = _.sortBy(oScores[score], function(review) { return review.dataset.created });
                        if (ascending) { // Because whole array will be reversed for 'lowest score', reverse the group arrays so the end display will still show the most recent review at each score value, while the score values are displayed in ascending order
                            oScores[score].reverse();
                        }
                    }
                }
                arrSorted = _.union(oScores[0], oScores[1], oScores[2], oScores[3], oScores[4], oScores[5]);
            } else {
                arrSorted = _.sortBy(arrReviews, function(review) { return review.dataset[key] });
            }

            if (!ascending) { // 'Oldest' or 'Lowsest Score' Reviews
                arrSorted.reverse();
            }

            return arrSorted;
        },
        split: function(arrReviews, key) {
            /*
            This function splits a given array into pages of a length determined in the props above. The "perPage" property
            is used as a marker for starting a new page.
            */
            var arrPages = [], // This will be a two-dimensional array, since each page within it will also be an array.
                arrSet = []; // This is an individual page. We don't want to confuse "arrPages" with "arrPage".

            // First we transform the data. Then we built the document fragment.
            for (var i = 0; i < arrReviews.length; i++) {
                // If we're ready for a new page, reset the page array.
                if (i % UI.props.perPage === 0) {
                    // Don't add an empty page on the first time through.
                    if (arrSet.length > 0) {
                        // If sorting by score,

                        // Add this page to the pages array.
                        arrPages.push(arrSet);
                    }
                    // Reset the page array.
                    arrSet = [];
                }
                // Add this item to the current page array.
                arrSet.push(arrReviews[i]);
            };
            // Add the set to the pages array.
            arrPages.push(arrSet);

            return arrPages;
        },
        draw: function(arrPages) {

            /*
            The carousel pages already exist in the markup. We'll loop through them and replace their
            contents with new contents which are sorted according to the select input. The arrPages
            array is built to match the carousel content, so we can use the "index" variable to grab
            the appropriate item within the array.
            */
            UI.props.$contents.each(function(index) {
                $(this).append(fillPage(arrPages[index]));
            });
            UI.props.$carousel.find('.item').first().addClass('active');

            /*
            This is run on an individual carousel slide container. The array passed in is used to
            build each review, which is then added to a document fragment. The end result is returned
            as a document fragment.
            */
            function fillPage(arrSet) {
                var $docFragment = $(document.createDocumentFragment());
                for (var i = 0; i < arrSet.length; i++) {
                    $docFragment.append(arrSet[i]);
                };
                return $docFragment;
            }
            return;
        }
    }
    return UI;
})();
;
var AE = AE || {}; /* Add to Base object or create it if it doesn't exist. */

/*
The AE.ui object will be the returned result of a self-invoked function. This allows us to expose methods
for use by other modules while protecting some variables in a closure. If the AE.ui object is already
defined then it's not altered. This prevents us from running the entire function each time one of its
internal methods are called.

========================================================================
LAUNCHING A NEW DIALOG:
Dialogs are called with a method in this module, which then runs some internal functions. The launch method
is used to create a new one, and it closes normally according to jQuery UI docs. It takes an options object as
its only argument, which will override and/or add to a standardized internal object.


DIALOG OPTIONS:
The "options" object argument will override and/or add to the internal settings object. We're adding a few extra
properties for our internal use.


selector:		This selector string will be fed to jQuery first. It will be used to see if there's a prepared
				container for the dialog in the DOM somewhere. If nothing is found, then an element will be
				dynamically created to launch the dialog.

id:				If this string is provided, then it will be assined to the dialog's id attribute. If there's no
				selector then a hashtag will be added to this and jQuery will search the DOM for any existing
				markup. If nothing is found, then a new element is created as describec above. If both the selector
				and the id are provided, then the selector will be used to search the dom and the id will be
				assigned to the new dialog.

titleBar:		Boolean, defaults to true. If passed in as false, then CSS will be used to hide the dialog's
				title bar. It does this by adding a class to the dialogClass property. This class is appended,
				so it's okay to pass in a dialogClass with our own classes if needed.

applyUI:		Boolean, defaults to false. If passed in as true, then UI functions in AE.ui will be applied
				to the dialog content. Date pickers, Accordions, and Tabs.

content:		This property is a document fragment which is appended to the dialog's content container.
				If no content property is set, then the dialog will be launched with a spinner.

				NOTE: jQuery UI will put a source div back when the dialog closes, but this module does not.
				Instead, a clone of the content is used so that the original remains in the markukp. Don't
				use this with an existing bit of content that has an id, or that id will appear twice in the
				DOM. If the content has an id, then just pass in the id with no selector.

type:			This property allows us to use a specific settings object. This allows us to call an infoTip
				dialog instead of a regular one. Almost all dialogs will be standard, so no type needs to be
				declared. If we need another type later, then we can add it in later.

pos:			An object which will be fed to the dialog internally. It uses jQuery UI's position method to
				correct the position of a dialog which needs to be placed somewhere other than the center. One
				example of this is the matrix infoTips. Here are the docs and an example object:
				https://jqueryui.com/position/
				{ my: "left+10 top", at: "right top", of: '.my-selector'}

autoupdate:		A boolean which defaults to true, and allows dialogs to be corrected for position upon resize.
				If it's passed in as false, then we'll need to run the dialog module's update method manually.
				This is currently used for the matrix, which is destroyed and redrawn upon resize. You can pass
				an object into jQuery UI's position method, but that reference gets lost when the element is
				removed. If a selector string is passed in, then it will be used to search for the element every
				time. This allows us to wait until after the matrix is redrawn before manually updating to the
				element we need.


EXAMPLES OF USE:

A regular dialog called with some content:
AE.ui.dialog.launch("#save-quote", { content:myDocumentFragment } );


A dialog with dynamic content which will arive after an ajax call:
AE.ui.dialog.launchDialog("#save-quote");]

	And here's the line we use when the content is built:
	AE.ui.dialog.addContent( myDocumentFragment );


This is a more complex example, used for matrix infoTips. Since the autoupdate is turned off, we need to run
the initial update manually.

	AE.ui.dialog.launch({
		id:'my-new-id',
		type:'infoTip',
		autoupdate: false,
		pos: { my: "left+5 top", at: "right top", of: mySelectorString },
		content: myDocumentFragment
	});
	AE.ui.dialog.update(true);

========================================================================



*/
AE.ui.dialog = AE.ui.dialog || (function() {
    /*
    DEPENDENCIES: AE, AE.ui
    */
    var UI = {
        dialogHandlers: [], // Delegated Tasks Triggered On Dialog Trigger Click
        init: function() {

            /* Establish the props object only upon init. No need to do the work if the module isn't being called. */
            UI.props = {
                $currentDialog: null, // This will be the instance of the jQuery UI dialog, not the markup.
                positionTarget: null,
                lastBodyY: 0, // Last position of the body before a touchmove scroll.
                size: '80%',
                overClick: true, // Whether an overlay click closes a dialog. Turned off by special buttons, turned back on when a dialog closes.
                maxSize: '850px',
                allTabWidth: 0, // The terms dialog sometimes wraps the tabs, so we're going to set them to full width when that happens.
                $autoDialogs: $('.trg__dialog--Auto'),
                dialogTriggered: false
            };
            //UI.addDialogHandler({func:function(event){UI.markupDialog(event);}});
            //UI.handle(UI.props.$autoDialogs.first());// Only Launch One Dialog on Page Load
            AE.ui.addBodyClickTask({ func: UI.onBodyClick });

            AE.addResizeTask({
                func: function() {
                    UI.manageResize();
                },
                args: []
            });
            AE.addScrollTask({
                func: function() {
                        UI.manageScroll();
                    } //,
                    //args:[]
            });


            /*
            This options object contains the settings for the two types of dialogs that we're using. We're not
            extending anything yet because we want to preserve readability until we finish converting everything.
            Other types of dialogs should have their settings added here.
            */
            UI.options = {
                infoTip: {
                    type: 'infoTip',
                    titleBar: false,
                    applyUI: true,
                    dialogClass: "",
                    typeClass: "info-tip",
                    draggable: true,
                    resizable: false,
                    minHeight: 'auto',
                    modal: true,
                    //appendTo: "#dialog-content",
                    autoupdate: true,
                    // collision: "fit",
                    // using: null
                },
                standard: {
                    type: 'standard',
                    titleBar: true,
                    applyUI: false,
                    dialogClass: "",
                    draggable: false,
                    resizable: false,
                    width: ($(window).width() > 900) ? 850 : '80%',
                    modal: true,
                    //appendTo: "#dialog-content",
                    autoupdate: true,
                    // collision: "flip",
                    // using: null
                }
            };
            if(AE.props.siteCode == 'FCR') {
                UI.options = {
                    infoTip: {
                        type: 'infoTip',
                        titleBar: false,
                        applyUI: true,
                        dialogClass: "",
                        typeClass: "info-tip",
                        draggable: true,
                        resizable: false,
                        minHeight: 'auto',
                        modal: true,
                        //appendTo: "#dialog-content",
                        autoupdate: true,
                        // collision: "fit",
                        // using: null
                    },
                    standard: {
                        type: 'standard',
                        titleBar: true,
                        applyUI: false,
                        dialogClass: "",
                        draggable: false,
                        resizable: false,
                        width: ($(window).width() > 900) ? 850 : '80%',
                        modal: true,
                        //appendTo: "#dialog-content",
                        autoupdate: true,
                        //collision: "flip",
                        // using: null
                        //WEBAE3-4197 - the hide effect below was preventing the dropbox dialog from displaying after the one way fee dialog was accepted.
                        //hide: {effect: "fadeOut", duration: 250},
                        show: {effect: "fadeIn", duration: 250}
                    }
                };
            };
            UI.addListeners();
        },
        addListeners: function(settings) {

            $('body')
                .on({
                    dialogopen: function(event, ui) {

                        var evtTarget = event.target || null;
                        var targetDialog;

                        if (evtTarget && $(evtTarget).parent().hasClass('io-observable')) {
                            targetDialog = $(evtTarget).parent('[role=dialog].io-observable');
                        }


                        // Sometimes on refresh, a dialog which opens automatically might launch before the
                        // browser gets around to recovering the user's scroll position. Since scrolling is
                        // killed by a class when the dialog opens, the user can't scroll up to see it. To
                        // counter this bug, we're going to run an update upon open. If a dialog is updated
                        // manually, then we'll need to make this correction manually.
                        $('.ui-dialog-content').css('height', $('.ui-dialog-content').height() + 1);
                        UI.update();
                        UI.manageTabWidth();



                    },
                    dialogclose: function(event, ui) {

                        var evtTarget = event.target || null;
                        var targetDialog;
                        var ariaLabel = $(evtTarget).parent('div').attr('aria-describedby');

                        if (evtTarget && $(evtTarget).parent().hasClass('io-observable')) {
                            targetDialog = $(evtTarget).parent('[role=dialog].io-observable');
                        }

                        //for member create account only - on close scroll to top
                        if(ariaLabel == 'duplicateWarning'){
                          $(AE.ui.props.scrollContainer).animate({
                            scrollTop: 0
                             }, 50);
                        }
            
                        UI.cleanup(event, ui);
                    }
                }, '.ui-dialog');
            /*.on({
            	touchstart: function(event) {
            		// If there's a dialog, record the current body scroll position.
            		if ( UI.props.$currentDialog ) {
            			UI.props.lastBodyY = AE.props.$bodyElement.scrollTop();
            		}
            	},
            	touchmove: function(event) {
            		if ( UI.props.$currentDialog ) {
            			// We have a dialog, so check to see if we should move.
            			if ( !$(event.target).closest('.ui-dialog')[0] ) {
            				// Scrolling outside of the dialog, so don't move the body.
            				event.preventDefault();
            				return false;
            			}
            		}
            	},
            	touchend: function(event) {
            		if ( UI.props.$currentDialog ) {
            			// If there's a dialog, compare the new body scroll position with the last saved
            			// position. If it's less, then reset it. This is being done because iOS will let
            			// the user scroll down when a dialog is already at the top, changing body position.
            			// After this happens, we put the scroll position back.
            			if ( AE.props.$bodyElement.scrollTop() !== UI.props.lastBodyY ) {
            				AE.props.$bodyElement.scrollTop(UI.props.lastBodyY)
            			}
            		}
            	}
            });*/
        },
        setPos: function(settings) {

            // This function sets the "positionTarget" property to an object which works with jQuery UI's
            // position() method. This seems to be a modification to the position() method in regular old
            // jQuery. It takes one object as an argument with the properties that jQuery UI expects.
            // The docs are here: https://jqueryui.com/position/
            //
            // Here's an example of the argument object:
            //
            // { my:'left top', at:'right top', of: $('.something') }
            //
            // And here's an example of calling the method:
            // $( ".ui-dialog" ).position(UI.getPos());
            //
            // Just in case you need it, this returns the resulting object.

            if(AE.props.siteCode === 'FCR'){
                //settings.my = 'left-75 top';
                settings.my = 'center top';
                settings.at = 'left bottom+5';
            }

            UI.props.positionTarget = {
                my: settings.my,
                at: settings.at,
                of: settings.of,
                collision: settings.collision || 'fit fit'
            };
    
            return UI.props.positionTarget;
        },
        getPos: function() {

            // This function returns the object created by setPos(). It's used during a window resize or an
            // orientation change, to reposition any dialog which is currently open. Here's an example of use:
            // var obj = AE.ui.dialog.setPos( { my: "left+10 top", at: "right top", of: $('.matrix__category--info.trg__more-info') } );
            // $( ".ui-dialog" ).position( obj );
            return UI.props.positionTarget;
        },
        setDialogTriggered: function() {
            //WEBAE3-5800 Call this function to set dialog as triggered before it launches, preventing the exit email dialog from displaying
            UI.props.dialogTriggered = true;
        },
        isDialogTriggered: function() {
            return UI.props.dialogTriggered;
        },
        update: function(isManual) {

            if (!UI.props.$currentDialog) { return };

            UI.props.$currentDialog.uiDialog.uniqueId();

            var siteViewType = AE.getSiteViewType(),
                isManual = isManual || false;

            // If there's an open dialog.
            if (UI.props.$currentDialog.options.autoupdate === true || isManual === true) {
                // Max height will be important no matter what size we're at.
                var winHeight = $(window).height();
                var maxHeight = winHeight - 60;

                var dialogHeight = UI.props.$currentDialog.uiDialog.outerHeight();
                dialogHeight = (dialogHeight > maxHeight) ? maxHeight : dialogHeight;

                $(".ui-dialog").css({
                    'max-height': maxHeight + 'px'
                });

                $(".ui-dialog-content").css({
                    'height': 'auto'
                });

                // Choose the appropriate update function.
                if ($(".ui-dialog").hasClass('info-tip')) {
                    updateInfoTip();
                } else {
                    updateStandard();
                }
                // Check for content overflow.
                UI.handleOverflow();
            }

            function updateStandard() {

                var winHeight = $(window).height();
                var maxHeight = winHeight - 60;

                var dialogHeight = UI.props.$currentDialog.uiDialog.outerHeight();
                dialogHeight = (dialogHeight > maxHeight) ? maxHeight : dialogHeight;

                var dClass = UI.props.$currentDialog.options.dialogClass;

                // terms and search again are placed at top of window, all others center on screen
                var dialogPos = (UI.props.$currentDialog.options.dialogClass.search('top-dialog') !== -1) ? 'center top+40' : 'center center-' + dialogHeight / 2 + '';

                if(AE.props.siteCode == 'FCR') {
                    $( ".ui-accordion" ).accordion({ 
                        animate: { easing: 'easeInOutSine', duration: 100}, 
                    });
                }

                // Update a regular dialog that's currently open.
                if ($(window).width() < 900 && siteViewType !== 'palm') {
                    $(".ui-dialog")
                        .removeClass('dialog-full')
                        .width('90%')
                        .position({
                            my: 'center top',
                            at: dialogPos,
                            of: $(window)
                        });


                } else if (siteViewType !== 'palm') {
                    var thisWidth = (900 <= UI.props.$currentDialog.options.width+10)? '90%' : UI.props.$currentDialog.options.width;
                    $(".ui-dialog")
                        .removeClass('dialog-full')
                        .width(thisWidth)
                        .position({
                            my: 'center top',
                            at: dialogPos,
                            of: $(window)
                        });

                } else {
                    // ====== OTHER DIALOGS: PALM ======
                    $(".ui-dialog")
                        .addClass('dialog-full')
                        .width('auto')
                        .position({
                            my: 'center top',
                            at: 'center top+30',
                            of: $(window)
                        });
                }


                /*
                There's an iOS bug which kills scrolling on an element if the height content is dynamically added. Fortunately,
                subsequent adjustments seem to correct the problem. Although it seems like an extraneous bit of work, the
                following lines will change the appropriate container and reset scrolling. I considered using the CSS solution
                from the link below, but it doesn't work for us in this situation. We need to be sure.
                http://patrickmuff.ch/blog/2014/10/01/how-we-fixed-the-webkit-overflow-scrolling-touch-bug-on-ios/
                */
                //$('.ui-dialog-content').height( ($('.ui-dialog-content').height()-1)+'px');
                //$('.ui-dialog-content').height( ($('.ui-dialog-content').height()+1)+'px');
            }

            function updateInfoTip() {

                // Update the currently open dialog, if it's an info tip.
                if ($(".info-tip")[0]) {
                    if (siteViewType !== 'palm') {
                        $(".info-tip").removeClass('info-tip-full').position(UI.getPos());
                        //UI.allowBodyScroll();
                    } else {
                        // ====== INFO TIPS: PALM ======
                        $(".ui-dialog-titlebar-close").hide()
                        $(".info-tip")
                            .addClass('info-tip-full')
                            .position({
                                my: 'center top',
                                at: 'center top+30',
                                of: $(window)
                            });
                        //UI.stopBodyScroll();
                    }
                }
            }
        },
        launch: function(options) {
            if (UI.props.$currentDialog) { return };
            var $dialog = [], // This will hold our general dialog reference.
                inline = true, // Did we use an inline HTML element or did we pass in a document fragment for content?
                settings = {}, // Creating a new settings object to hold our final local settings.
                scrollTxt = AE.props.oLang.TXT_SCROLL_DOWN; // Language element for scroll down text structure added in html_head
            // Close any existing dialog.
            UI.close();

            if (options.type) {
                // If there's a type, then add the options passed in to the object of that type.
                settings = $.extend(true, settings, AE.ui.dialog.options[options.type], options);
            } else {
                // Otherwise, use the standard object.
                settings = $.extend(true, settings, AE.ui.dialog.options.standard, options);
            }


            // If needed, set the module's position reference so we can reposition the dialog on resize.
            if (settings.pos) {
                UI.setPos(settings.pos);
            }

            // If  typeClass is defined, then add it to the dialog class string.
            settings.dialogClass = (settings.typeClass) ? (settings.dialogClass + ' ' + settings.typeClass) : settings.dialogClass;

            // If  titleBar is false, then add the no-title class to hide the title bar and close button.
            settings.dialogClass = (settings.titleBar) ? settings.dialogClass : (settings.dialogClass + ' mod-title');


            // ========================================================================================================
            // Check to see if there really is an element with the id that was passed in. If there's nothing in the
            // jQuery object's array, then there's no inline element and we'll need to make a new element dynamically.

            // If there's no selector but there is an id, use the id to find the inline div.
            if (!settings.selector && settings.id) { $dialog = $('#' + settings.id); }

            // If there is a selector, that takes precedence, so look for that in the DOM.
            else if (settings.selector) { $dialog = $(settings.selector) }

            // Set the id if there isn't one.
            settings.id = settings.id || 'current-dialog';



            if (settings.type !== 'infoTip') {
                // This is not an info tip, so we need to stop scrolling for desktop and mobile devices.
                //UI.stopBodyScroll();
            }

            if (!$dialog[0]) {
                // Nothing was found in the DOM, so we need to make a div dynamically. If we need a specific id for this, then
                // one needs to be passed in. Otherwise, a default id is assigned.
                inline = false;

                $dialog = $($(document.createElement('div')))
                    .attr('id', settings.id)
                    .append($(document.createElement('div'))
                        .append($(document.createElement('div'))
                            .append(scrollTxt)).addClass('scrollable'));

                

            }

            //$('#dialog-content').addClass('open');

            // Dynamic or inline, we now have our dialog. Launch a dialog with our completed settings object.
            $dialog.dialog(settings);


            // Set our module property to the instance of our new dialog. This allows us to run methods directly and access more
            // of the goodies. We can get the content from the resulting object's properties, or we can still run code on $('.ui-dialog')
            // if we want to mess with stuff in the content area.
            UI.props.$currentDialog = $dialog.dialog('instance');




            // If there's no inline element for the dialog's source, then we'll need to add our content document fragment to the dialog.
            if (!inline) {
                if (settings.content) {
                    if (settings.cloneContentEvents) {
                        // Also clone events when indicated or custom behaviors will be lost
                        UI.addContent($(settings.content).clone(true));
                    } else {
                        // If we've passed in content, then remove any spinner which may be there and append the document fragment.
                        UI.addContent($(settings.content).clone());
                    }
                } else {
                    // If there's no content to append, then add a spinner. Content will probably be added after an ajax call.
                    AE.ui.addSpinner(UI.props.$currentDialog.uiDialog.find('.ui-dialog-content'), { size: '5x' });
                }
            }

            // Apply UI function to content such as tabs, accordions and datepickers
            if (settings.applyUI) {
                UI.applyJQUI();
            }

            // Needs to happen after the dialog is created, because the buttons need to exist for some of the code to run.
            if (settings.buttonOpts) UI.applyButtonOptions(settings.buttonOpts);

            /*
            // Commenting out for now, to see if we get better results from applying this just before opening the dialog.
            if ( UI.props.$currentDialog && UI.props.$currentDialog.options.type !== 'infoTip' ) {
            	// This is not an info tip, so we need to stop scrolling for desktop and mobile devices.
            	UI.stopBodyScroll();
            }
            */

            if(AE.props.siteCode == 'FCR' && settings.class) {
                    $('.ui-dialog').addClass(settings.class)
            }

            $('.ui-dialog').scrollTop(0);
            if (settings.autoupdate) {
                UI.update();
            }
            UI.renderButtonEntities();
            return $dialog;
        },
        addContent: function(content) {

            //http://stackoverflow.com/questions/6068955/jquery-function-after-append
            if (UI.props.$currentDialog) {
                AE.ui.removeSpinner(UI.props.$currentDialog.uiDialog.find('.ui-dialog-content'));
                UI.props.$currentDialog.uiDialog
                    .find('.ui-dialog-content')
                    .append(content)
                    .ready(function() {
                        UI.manageTabWidth();
                    });
            }
        },
        applyJQUI: function(dialogSelector) {

            if (UI.props.$currentDialog) {
                AE.ui.applyJQUI('.ui-dialog-content');
            }
        },
        renderButtonEntities: function() {

            var $dialogButtons = $('.ui-dialog-buttonset button');
            $.each($dialogButtons, function(btnIdx) {
                var thisBtn = $dialogButtons[btnIdx];
                var btnTxt = thisBtn.innerHTML;
                btnTxt = btnTxt.replace(/&amp;/g, '&');
                $(thisBtn).empty().append(btnTxt);
            });
        },
        close: function(event, ui) {
            UI.props.dialogTriggered = false;
            // Closes any dialog which is currently open.
            if (UI.props.$currentDialog) { UI.props.$currentDialog.close(); }
        },
        instance: function() {
            // Returns instance of current dialog.
            return UI.props.$currentDialog.uiDialog;
        },
        hasOverflow: function() {

            if (!UI.props.$currentDialog) {

                return false;
            }
            var totalHeight = 0;
            var currDialog = UI.props.$currentDialog.uiDialog;
            var currentHeight = currDialog.hasClass('mod-title') ? parseInt(currDialog.height() + 15) : currDialog.height();

            //var overflow = ( $().innerHeight() > $().);

            // Changed to use height as was getting false positives with outerHeight()
            UI.props.$currentDialog.uiDialog.children().each(function(index) {

                if ($(this).is(':visible')) {
                    totalHeight += $(this).height();
                }
            });

            return (currentHeight < totalHeight);
        },
        handleOverflow: function() {

            if (UI.hasOverflow()) { //} && $('.ui-dialog-content').find('.scrollable')[0] ) {
                //console.log('+ Content is taller than the dialog.');
                UI.props.$currentDialog.uiDialog.addClass('scroll--more');
            } else {
                //console.log('- Content fits inside the dialog.');
                UI.props.$currentDialog.uiDialog.removeClass('scroll--more');
            }
        },
        stopBodyScroll: function() {

            if ($('html').hasClass('ua-firefox')) {
                // Do nothing, because Firefox desktop shoots to the top when an absolute position is applied, and
                // with longer pages it can frustrate the user when they lose their place.
            } else {
                // In all other cases, use this class.
                $('html').addClass('scroll-stop');
            }
        },
        allowBodyScroll: function() {
            $('html').removeClass('scroll-stop');
        },
        cleanup: function(event, ui) {

            // Meant to be called whenever a dialog is closed. Won't do anything if there's no $currentDialog.
            // This function is added to the close method in the dialog options at the top of this file.
            if (UI.props.$currentDialog) {
                UI.props.dialogTriggered = false;
                // We can call the method directly because we saved the instance to this variable.
                UI.props.$currentDialog.destroy();
                UI.props.$currentDialog = null;
                UI.props.overClick = true;
                //UI.allowBodyScroll();
                //$('#dialog-content').removeClass('open');
            }
        },
        /*
        handle:function(event) {
        	var $target = $(event.target);
        	for (var i = 0; i < UI.dialogHandlers.length; i++) {
        		UI.dialogHandlers[i].func.apply(this, [event]);
        	};

        	//if($target.data('terms')){
        	//	AE.booking.terms.dialog($target);
        	//} else if($target.hasClass('email-quote')){
        	//	AE.booking.saveQuote.dialog($target);
        	//} else if($target.data('selector')){
        	//	$($target.data('selector')).dialog(UI.getDefaultOptions());
        	//}
        },
        */
        addDialogHandler: function(task) {
            /*
            Adds an object with a func property that is function taking the
            event object as its ONLY argument to an array of functions.
            When a dialog trigger element is clicked, these functions will be executed using
            the apply() method in handle() to pass in the correct target on each event.

            Each 'task' should start by performing logic on the event target to determine whether it should run.

            	AE.ui.dialog.addDialogHandler(
            		{
            			func:function(event){
            				if(event meets criteria){
            					do stuff
            				}
            			}
            		}
            	);
            */

            UI.dialogHandlers.push(task);
		},
		onBodyClick: function(event, $target) {
			if ($(event.target).hasClass('trg__dialog')) {
				// This is intended for markup-driven dialogs. The link should have the class listed above, and
				// a data attribute with an ID. It's an ID, not a generalized selector. This function will then
				// launch a standard dialog.
				var contentID = $target.data('dialog-id');
				UI.launch({ id: contentID });
			}

			// All "info tips" close when they are clicked on
			if ($target.closest('.info-tip')[0]) {
				UI.close();
			}

			// All "dialog modal overlays" close when clicked on
			if ($target.hasClass('ui-widget-overlay') && UI.props.overClick) {
				UI.close();
            }
            
            if ($target.hasClass('fcr_close')) {
				UI.close();
			}

			// GPS Form: when closing the T&C modal "X" (close)
			if ((oSite.siteCode === 'AUS') && $target.hasClass('ui-icon-closethick') && ($('body').attr('id') == 'gpsrequest')) {
				$("#gpsreqbtn").removeClass("visuallyhidden");
				$("#gpsTNCchk")
					.removeClass("fa-square")
					.addClass("fa-check-square");
			}
		},
        /*
        markupDialog : function(event) {
        	var $target = $(event.target);
        	if($target.data('selector')){
        		var $selection = $($target.data('selector'));
        		if($selection[0]){
        			$selection.dialog(UI.getDefaultOptions());
        			if($selection.hasClass('trg__dialog--transparent')){
        				$selection
        					.dialog({minHeight:$selection.dialog('option','maxHeight')})
        					.parent().css('backgroundColor','transparent').css('border','0').css('padding','0');
        			}
        		}
        	}
        },
        */
        /*
        create:function(id,dialogOpts,spinnerOpts,content) {

        	if(typeof(id) !== 'string') id = 'unidentifiedDialog_'+Date.now();

        	dialogOpts = dialogOpts || UI.getDefaultOptions();
        	var dialogSelector = '#'+$.trim(id);
        	var $dialog = $( $(document.createElement('div')))
        		.attr('id',id)
        		.dialog(dialogOpts);

        	if(!dialogOpts.close){
        		$dialog.dialog('option','close',
        			function(){
        				$dialog.dialog('destroy');
        			}
        		);
        	}

        	if(dialogOpts.noTitleClose) UI.hideTitleCloseButton(dialogSelector);

        	if(dialogOpts.buttonOpts) UI.applyButtonOptions(dialogSelector,dialogOpts.buttonOpts);

        	if(spinnerOpts) AE.ui.addSpinner(dialogSelector,spinnerOpts);

        	if(content){
        		AE.ui.removeSpinner(dialogSelector);
        		$dialog.append(content);
        	}
        	$dialog.closest('.ui-dialog').css({
        		"position"	: 'fixed',
        		"top"	: dialogOpts.top
        	});

        	return $dialog;
        },
        */
        create: function(id, dialogOpts, spinnerOpts, content) {

            if (typeof(id) !== 'string') id = 'unidentifiedDialog_' + Date.now();

            dialogOpts = dialogOpts || {};
            var dialogSelector = '#' + $.trim(id);

            UI.launch({
                id: '#' + $.trim(id),
                content: buildMarkup(termsData),
                buttons: oButtons,
                applyUI: true,
                buttonOpts: buttonOpts,
                width: ($(window).width() > 900) ? 850 : '80%'
            });

            var $dialog = $($(document.createElement('div')))
                .attr('id', id)
                .dialog(dialogOpts);

            if (!dialogOpts.close) {
                // $dialog.addClass('modded-title-bar');
                $dialog.dialog('option', 'close',
                function(event) {
                    $dialog.dialog('destroy');
                }
            );
            }



            // UI.hideTitleCloseButton seems to be unused in this module - Simari 07/24/18
            // if (dialogOpts.noTitleClose) UI.hideTitleCloseButton(dialogSelector);

            if (dialogOpts.buttonOpts) UI.applyButtonOptions(dialogSelector, dialogOpts.buttonOpts);

            if (spinnerOpts) AE.ui.addSpinner(dialogSelector, spinnerOpts);

            if (content) {
                AE.ui.removeSpinner(dialogSelector);
                $dialog.append(content);
            }
            $dialog.closest('.ui-dialog').css({
                "position": 'fixed',
                "top": dialogOpts.top
            });

            return $dialog;
        },
        fill: function(dialogSelector, content, buttonOpts) {
            AE.ui.removeSpinner(dialogSelector);
            $(dialogSelector).append(content);
            AE.ui.applyJQUI(dialogSelector);
            if (buttonOpts) UI.applyButtonOptions(dialogSelector, buttonOpts);
        },
        /*
        getDefaultOptions:function(){
        	var dims = UI.getDimensions();
        	return {
        		autoOpen: true,
        		position:{my:"center top", at:"center top", of:window},
        		width: dims.width,
        		height: dims.height,
        		top: dims.top,
        		maxHeight: dims.maxHeight,
        		draggable: false,
        		resizable: false,
        		modal: true
        	};
        },
        */
        /*
        buildOptions:function(dialogOpts){
        	return $.extend(true,UI.getDefaultOptions(),dialogOpts);
        },
        */
        /*
        hideTitleCloseButton:function(dialogSelector){
        	$(dialogSelector).siblings('.ui-dialog-titlebar').children('button.ui-dialog-titlebar-close').hide();
        	UI.props.overClick = false;
        },
        */
        applyButtonOptions: function(buttonOpts) {

            if (!UI.props.$currentDialog) { return };


            var $dialog = UI.props.$currentDialog.uiDialog,
                $buttonPane = UI.props.$currentDialog.uiDialogButtonPane,
                $buttonSet = UI.props.$currentDialog.uiButtonSet,
                $buttonsAll = UI.props.$currentDialog.uiButtonSet.children('button'),
                $buttonFirst = UI.props.$currentDialog.uiButtonSet.children('button').first(),
                $buttonLast = UI.props.$currentDialog.uiButtonSet.children('button').last();

            if (buttonOpts.buttons) {
                $dialog.dialog('option', 'buttons', buttonOpts.buttons);
            }

            if (buttonOpts.before) {
                $buttonPane.prepend(buttonOpts.before);
            }
            if (buttonOpts.after) {
                $buttonPane.append(buttonOpts.after);
            }
            if (buttonOpts.paneClass) {
                $buttonPane.addClass(buttonOpts.paneClass);
            }
            if (buttonOpts.setClass) {
                $buttonSet.addClass(buttonOpts.setClass);
            }
            if (buttonOpts.buttonsClass) {
                $buttonsAll.addClass(buttonOpts.buttonsClass);
            }

            if (buttonOpts.firstButtonClass) {
                if (buttonOpts.buttonsClass) $buttonFirst.removeClass(buttonOpts.buttonsClass);
                $buttonFirst.addClass(buttonOpts.firstButtonClass);
            }
            if (buttonOpts.lastButtonClass) {
                if (buttonOpts.buttonsClass) $buttonLast.removeClass(buttonOpts.buttonsClass);
                $buttonLast.addClass(buttonOpts.lastButtonClass);
            }
            if (buttonOpts.firstButtonAttr) {
                $buttonFirst.attr(buttonOpts.firstButtonAttr[0], buttonOpts.firstButtonAttr[1]);
            }
            if (buttonOpts.lastButtonAttr) {
                $buttonLast.attr(buttonOpts.lastButtonAttr[0], buttonOpts.lastButtonAttr[1]);
            }
            if (buttonOpts.exclusiveClose) {
                // Disable the ability for the overlay to close the dialog, and get rid of the close button in the titlebar.
                UI.props.overClick = false;
                UI.props.$currentDialog.uiDialogTitlebarClose.hide();
            }
        },
        empty: function(dialogSelector) {},
        /*
        getDimensions:function(initial){
        	initial = initial || false;

        	var viewType = AE.getSiteViewType(),
        		windowWidth = $(window).outerWidth(),
        		windowHeight = $(window).outerHeight(),
        		dims = {};

        	if ( viewType !== 'palm' ) {
        		dims.width		= windowWidth*0.9 > 700 ? 700 : windowWidth*0.9;
        		dims.height		= 'auto' //$(window).outerHeight()*0.5;
        		dims.maxHeight	= windowHeight-40;//*0.9;
        		dims.left		= (windowWidth - dims.width) / 2
        		dims.top		= 20;

        	} else {
        		dims.width		= windowWidth;
        		dims.height		= windowHeight;
        		dims.maxHeight	= windowHeight;
        		dims.left		= 0;
        		dims.top		= 0;
        	}
        	return dims;
        },
        */
        manageTabWidth: function() {
            if (!UI.props.$currentDialog) { return };

            //See if there are tabs. If not, then return.
            var $tabList = UI.props.$currentDialog.uiDialog.find('.ui-tabs-nav');
            if (!$tabList[0] || AE.getSiteViewType() === 'palm') { return };


            // If the tabs are normal.
            if (!$tabList.hasClass('tab-forcefull')) {
                var total = getTotalWidth();

                if (total >= $tabList.width()) {
                    UI.allTabWidth = total;
                    $tabList.addClass('tab-forcefull');
                }
            } else {
                // The tabs DO have the class, so that means we have a value for the total width.
                if (UI.allTabWidth < $tabList.width()) {
                    UI.allTabWidth = 0;
                    $tabList.removeClass('tab-forcefull');
                }
            }

            function getTotalWidth() {
                var allWidth = 0;
                $tabList.children().each(function() {
                    allWidth += $(this).outerWidth(true);
                });
                return allWidth;
            }
        },
        manageScroll: function() {
            if (UI.props.$currentDialog && UI.props.$currentDialog.option('type') === 'infoTip') {
                UI.props.$currentDialog.close();
            }
        },
        manageResize: function() {
            /*
            var $dialog	= $('.ui-dialog'),
            	dims	= UI.getDimensions();

            $dialog.css({
            	"width"			: dims.width,
            	"height"		: dims.height,
            	"left"			: dims.left,
            	"top"			: dims.top
            });
            */
            UI.update();
            UI.manageTabWidth();
        }
    }
    return UI;
})();
;var AE = AE || {}; /* Add to Base object or create it if it doesn't exist. */

/*
The AE.ui object will be the returned result of a self-invoked function. This allows us to expose methods 
for use by other modules while protecting some variables in a closure. If the AE.ui object is already 
defined then it's not altered. This prevents us from running the entire function each time one of its 
internal methods are called.
*/
AE.ui.tabcordion = AE.ui.tabcordion || (function(){
	/* 
	DEPENDENCIES: AE, AE.ui
	*/

	var UI = {
		init:function() {

			/* Establish the props object only upon init. No need to do the work if the module isn't being called. */
			UI.props = {};
			AE.ui.addBodyClickTask({func: UI.onBodyClick});

		},
		handleTabcordion:function($target){
			var props = $target.data();
			props['display'] = props['display'] || '';
			props['content'] = props['content'] || '';
			props['switchsize'] = props['switchsize'] || '';





			var $tabcordionGroup = $('.tabcordion__item[data-display="'+props['display']+'"]'); // All trigger items.

			/*
			This next bit looks kind of weird, so it needs some explanation. We're making a jQuery collection from the 
			results of a function, and that function involves UnderscoreJS. We take the collection of tabcordian triggers 
			and run them through a chained set of methods from Underscore.

			1)	Use _.map() to get the "content" data attribute from each tabcordian item, returned as an array of strings. 
				The one that the user clicked will return as a boolean false. Ex: ["#id1","#id2",false,"#id4"]
			2)	We then run that through _.compact() to remove any falsey values.
			3)	The _.value() method breaks the chain and returns the final value. Ex: ["#id1","#id2","#id4"]
			4)	The final value is then converted to a string. Ex. "#id1,#id2,#id4"
			5)	This string is used as a jQuery selector. Ex. $myVar = $("#id1,#id2,#id4");
			*/
			var $tabcordionContentGroup = $(
				_.chain( $tabcordionGroup )
				.map(function(item){
					// Do not include the content item that we're trying to open with the current trigger. We just want 
					// to find the others so we can close them.
					var selector = $(item).data('content').toString();
					selector = ( selector === props['content'].toString() ) ? false : selector;
					return selector;
				})
				.compact()
				.value()
				.toString()
			);



			// This bit is used for the promos.
			// Changed to use ID as selector was undefined 
			// if we use this for other tabcordions may want to revisit
			var div = $(props['content'])[0].id.split('-');
			//var div = $(props['content']).selector.split('-');


			var removeClasses = 'visuallyhidden';
			switch($.trim(props['switchsize']).toLowerCase()) {
				case 'palm' : 
					addClasses = 'visuallyhidden--palm visuallyhidden--lap-and-up active-palm';
					removeClasses += ' visuallyhidden--palm visuallyhidden--portable active-palm';
					break;
				case 'portable' : 
					addClasses = 'visuallyhidden--portable visuallyhidden--desk visuallyhidden--desk-wide active-portable';
					removeClasses += ' visuallyhidden--palm visuallyhidden--lap visuallyhidden--portable active-portable';
					break;
				case 'lap' : 
					addClasses = 'visuallyhidden--lap visuallyhidden--desk visuallyhidden--desk-wide active-lap';
					removeClasses += ' visuallyhidden--lap visuallyhidden--portable active-lap';
					break;
				case 'lap-and-up' : 
					addClasses = 'visuallyhidden--lap-and-up visuallyhidden--palm active-lap-and-up';
					removeClasses += ' visuallyhidden--lap-and-up visuallyhidden--lap visuallyhidden--desk visuallyhidden--desk-wide active-lap-and-up';
					break;
				case 'desk' : 
					addClasses = 'visuallyhidden--desk active-desk';
					removeClasses += ' visuallyhidden--desk active-desk';
					break;
				case 'desk-wide' : 
					addClasses = 'visuallyhidden--desk-wide active-desk-wide';
					removeClasses += ' visuallyhidden--desk-wide active-desk-wide';
					break;
			}
			//$tabcordionContentGroup.slideUp('slow').addClass(addClasses);
			//$(props['content']).removeClass(removeClasses).slideDown('slow');



			/*
			By passing in an object instead of the usual arguments, we can access the methods that slideUp and slideDown 
			have with jQuery animate(). We add "queue:false" to run the animations simultaneously.
			*/
			$tabcordionContentGroup.slideUp({
				duration: 'slow',
				queue: false,
				complete: function(){ $(this).addClass(addClasses); /*console.log('Finished sliding UP.');*/ }
			});

			$(props['content']).removeClass(removeClasses).slideDown({
				duration: 'slow',
				queue: false,
				complete: function(){ /*console.log('Finished sliding DOWN.');*/ }
			});

			$(props['display']).empty().removeClass('promo-content-one promo-content-two promo-content-three').append($(props['content']).html()).addClass('promo-content-'+ div[2]);
		},
		onBodyClick:function(event,$target){
			if( $target.closest('.tabcordion__item')[0] ) {
				event.preventDefault();
				UI.handleTabcordion($target);
			}

			// Stuff for promos.
			if ( $('.tabcordion__opaque__parent')[0] ) {
				// Toggle Opaque Background
				$('.tabcordion__opaque__parent').addClass('promo-opacity-fill');
				var parent = $target.closest('div.promo-box');
				parent.children('.tabcordion__opaque__parent').removeClass('promo-opacity-fill');
			}
		}
	}
	return UI;
})();
var AE = AE || {}; /* Add to Base object or create it if it doesn't exist. */

AE.ui.liveTimer = AE.ui.liveTimer || (function () {
		var UI = {
			init: function (callback, iTxd) {
				/* Track mouse-out time by exit direction. */

				var _iTxd = iTxd || {top:0, right:0, bottom:0, left:0};
				UI.props = {
					int: 0,
					bufferInt: 0,
					/* callback to fire on timer complete */
					$fn: callback,
					/* timerInt is set properly in UI._setInt, this is a placeholder. */
					timerInt: function () {
						return false;
					},
					mouseX: 100, /* mouse X leave for exit modal */
					mouseY: 100, /* mouse Y leave for exit modal */
					/* exitDirTest is set properly in UI._trackExit, these are just placeholder values. */
					exitDirTest: {
						'oT': false, /* 'oT' - mouse exits top */
						'oR': false, /* 'oR' - mouse exits right */
						'oB': false, /* 'oB' - mouse exits bottom */
						'oL': false /* 'oL' - mouse exits left */
					},
					/* # seconds to wait before firing dialog (# of iterations based on 1000 ms timeout) */
					idleTimes: {
						'oT': _iTxd.top,
						'oR': _iTxd.right,
						'oB': _iTxd.bottom,
						'oL': _iTxd.left
					}
				};

				window.addEventListener('mousemove', UI._handleMouseMoveEvent, true);
				document.documentElement.addEventListener('mouseleave', UI._setInt);
			},

			_handleMouseMoveEvent: function (e) {
				return UI._setCoordinateProps(e);
			},

			_setCoordinateProps: function (e) {
				UI.props.mouseX = e.clientX;
				UI.props.mouseY = e.clientY;
			},

			_setInt: function () {
				document.documentElement.removeEventListener('mouseleave', UI._setInt);
				document.documentElement.addEventListener('mouseenter', UI._resetIdleTimer);
				UI.timerInt = setInterval(UI._trackExit, UI.props.bufferInt);
			},

			_trackExit: function () {

				UI.props.exitDirTest = {
					'oT': UI.props.mouseY < 10,
					'oR': UI.props.mouseX > (window.innerWidth - 30),
					'oB': UI.props.mouseY > (window.innerHeight - 30),
					'oL': UI.props.mouseX < 10
				};

				for (var i in UI.props.exitDirTest)
					if (UI.props.exitDirTest[i]) UI._watchIdleTimer(i);
			},

			_watchIdleTimer: function (exitDirection) {
				var _secondsToLive = UI.props.idleTimes[exitDirection];

				if (UI.props.int >= _secondsToLive) return UI._triggerCallback();
				UI.props.int++;
			},

			_triggerCallback: function () {
				document.documentElement.removeEventListener('mouseleave', UI._setInt);
				document.documentElement.removeEventListener('mouseenter', UI._killIdleTimer);
				document.documentElement.removeEventListener('mouseenter', UI._resetIdleTimer);
				UI._killIdleTimer();
				return UI.props.$fn();
			},

			_resetIdleTimer: function () {
				UI.props.int = 0;
				clearInterval(UI.timerInt);
				document.documentElement.addEventListener('mouseleave', UI._setInt);
			},

			_killIdleTimer: function () {
				UI.props.int = 0;
				document.documentElement.removeEventListener('mouseenter', UI._killIdleTimer);
				window.removeEventListener('mousemove', UI._handleMouseMoveEvent, true);
				clearInterval(UI.timerInt);
			}
		};

		return UI;
})();
/*
AE.init.ui: Resolves the deferred object for the ui modules.
*/
objDFD.ui.resolve();